/// <reference path="../typings/index.d.ts" />
declare var bootstrap: any;
namespace App.Modulos {
  export class Business {
    public static inicializar() {
      var business = new App.Business();
      business.inicializarEventos();
    }
  }
}

namespace App {
  export class Business {
    private ajax: IAjax;
    private elBtnVincularConta: JQuery = $(".btn-vincular-conta");
    private elBtnVincularMultConta: JQuery = $(".btn-vincular-mult-conta");
    private elBtnTeste: JQuery = $("#btn-teste");
    private elBtnDesfragmentarLiberarEspacoDisco: JQuery = $("#btn-limpeza-disco");
    private elBtnAddPluginInicializacao: JQuery = $("#btn-add-plugin-inicializacao");
    private elBtnRemoverPluginInicializacao: JQuery = $("#btn-remover-plugin-inicializacao");
    private elBtnReiniciarVm: JQuery = $("#btn-reiniciar-vm");
    private elBtnLimparLimites: JQuery = $("#btn-limpar-limits");
    private elBtnLimparLogs: JQuery = $("#btn-limpar-logs");
    private elBtnInterromperTarefas: JQuery = $(".btn-interromper-tarefas");
    private elBtnReiniciarPlugin: JQuery = $(".btn-reiniciar-plugin");
    private elBtnTesteNotificacaoTelegram: JQuery = $("#btn-teste-notificacao-telegram");
    private elBtnExportarDatabaseLocal: JQuery = $("#btn-exportar-database-local");

    private elBtnSalvarConfigGeral: JQuery = $(".btn-salvar-config-geral");

    private elBtnAtualizar: JQuery = $(".btn-atualizar");
    private elBtnSalvarServidor: JQuery = $(".btn-add-servidor");

    private elFiltroExigido: JQuery = $(".filtro-exigido");
    private elAgendamentoExigido: JQuery = $(".agendamento-exigido");
    private elDataTableLogs: any = $("#datatableLogs");
    private elDataTableContas: any = $("#datatableContas");
    private elDropdownAplicarFiltroPro: JQuery = $(".aplicar-filtro-pro");
    private elDropdownSubstituirFiltroPro: JQuery = $(".substituir-filtro-pro");
    private elBtnLimparFiltroPro: JQuery = $(".limpar-filtro-pro");
    private elBtnAplicarProfile: JQuery = $(".btn-aplicar-profile");
    private elBtnAplicarFiltros: JQuery = $(".btn-aplicar-filtros");
    private elBtnAplicarProxy: JQuery = $(".btn-aplicar-proxy");
    private elBtnResolverDmeContas: JQuery = $(".btn-acao-resolver-dme-contas");
    private elBtnSelecionarTodosOsFiltros: JQuery = $(".btn-selecionar-todos-os-filtros");
    private elBtnApagarTodosOsFiltros: JQuery = $(".btn-apagar-todos-os-filtros");
    private elBtnAbrirContas: JQuery = $(".btn-abrir-contas");
    private elBtnLimparCache: JQuery = $(".btn-limpar-cache");
    private elBtnSincronizarDatabase: JQuery = $(".btn-sincronizar-database");
    private elBtnExecutarTarefaContas: JQuery = $(".btn-executar-tarefa-contas");
    private elBtnVenderCoins: JQuery = $(".btn-vender-coins");
    private elBtnResolverBugEa: JQuery = $(".btn-resolver-bug-ea");
    private elBtnAjustarLucro: JQuery = $(".btn-ajustar-lucro");
    private elBtncadastrarFiltroPro: JQuery = $("#cadastrarFiltro");
    private elBtnAtivarPilotoAutomatico: JQuery = $(".piloto-automatico");

    private elBtnSalvarFiltroProModalSniper: JQuery = $(".salvar-filtro-pro-modal-sniper");

    private elBtnAddConta: JQuery = $(".btn-iniciar-vincular-conta");


    private socketClientBot: any = null;
    private comunicacao: Comunicacao = null;
    private conectado: boolean = false;
    private pluginLigado: boolean = false;
    private versaoPlugin: any = null;
    private ipPlugin: string = null;
    private tarefaLigada: boolean = false;
    private filtrosEa: FiltrosEa = null;
    private objSelect2: ISelect2 = null;
    private alertPrecisaAddConta: any = null;
    private selectTextMilisegundosComplementoDefault: string = " milliseconds";
    public static dadosTeste: any = null;
    private objDataTableLogs: any = null;
    public static objDataTableContas: any = null;
    private arrayContas: IConta[] = [];
    private arrayConsolidados: IContaConsolidado[] = [];
    private idContaSniperModalAberto: number = null;
    private tarefasSniperContas: any = {}
    private ocultarLoadListHabilitado: boolean = true

    public static cronometros: any = {};
    private chartJsLucro: any = null;
    private chartJsCaptchas: any = null;
    private chartJsVendasApi: any = null;
    private chartJsRequests: any = null;
    private chartJsTempoUso: any = null;
    private chartJsComprasBuscas: any = null;

    private inicializacaoDashBoardConcluida: boolean = false;
    private cacheInfoContas: any = {};

    private configuracoesGeraisExecucao: IConfiguracoesGeraisExecucao = { contas_simultaneas: 1, intervalo_abertura_conta: 20, intervalo_proxima_execucao: 30, minutos_log_exibicao: 1440, jogadores_overall_clube_exibicao: "83-99", exibir_escudo_clube: true, exibir_cronometro: true, notificar_falha_autocaptcha: false, notificar_falha_carregamento: false, info_tempo_real: true };

    private elCheckBoxAtivarDesativar: JQuery = $("input[name=status_filtro]");
    private elCheckBoxAtivarDesativarConfigRemota: JQuery = $("input[name=config_remota]");
    private elBtbAcaoResolverDme: JQuery = $(".btn-acao-resolver-dme");
    private executandoTarefa: boolean = false;
    private atualizandoContas: boolean = false;
    private indiceAtualListaContas: number = 0;
    private intervaloVinculoListaContas: any = 0;
    private vendendoCoinsContaLista: boolean = false;
    private executandoResolverBugEa: boolean = false;
    private util: any = null;
    private static tempoMilisegundoEntreAberturaContaVendaCoins: number = 40000;
    private ip: string = null;
    private infoPlanoAtual: IInfoPlanoAtual = { ehPlanoCloud: false, ehPlanoPro: false, ehPlanoProCloud: false };
    private processarAlertasUtil: any = null;
    private quantidadeFalhaConexaoPlugin: number = 0;
    private dadosServidor: IServidor = null

    public async inicializarEventos() {
      this.iniciarComunicacaoSocket();
      Util.unpinSidenav();
      this.processarAlertasUtil = App.Util.processarAlertas;
      App.Util.processarAlertas = () => { };

      this.elBtnVincularConta.on("click", (e) => { this.vincularConta(e) });
      this.elBtnVincularMultConta.on("click", (e) => { this.vincularMultConta(e) });
      this.elBtnTeste.on("click", (e) => { this.teste(e) });
      this.elBtnDesfragmentarLiberarEspacoDisco.on("click", (e) => { this.executarDesfragmentarLiberarEspacoDisco(e) });
      this.elBtnAddPluginInicializacao.on("click", (e) => { this.adicionarPluginNaInicializacaoWindows(e) });
      this.elBtnRemoverPluginInicializacao.on("click", (e) => { this.removerPluginNaInicializacaoWindows(e) });
      this.elBtnReiniciarVm.on("click", (e) => { this.reiniciarVm(e) });
      this.elBtnLimparLimites.on("click", (e) => { this.limparLimitesContas(e) });
      this.elBtnLimparLogs.on("click", (e) => { this.limparLogs(e) });
      this.elBtnInterromperTarefas.on("click", (e) => { this.imterromperTarefas(e) });
      this.elBtnReiniciarPlugin.on("click", (e) => { this.reiniciarPlugin(e) });
      this.elBtnTesteNotificacaoTelegram.on("click", (e) => { this.testeNotificacaoTelegram(e) });
      this.elBtnSalvarConfigGeral.on("click", (e) => { this.salvarConfigGeral(e) });
      this.elBtnExportarDatabaseLocal.on("click", (e) => { this.exportarDataBaseLocal(e) });

      this.elBtnAtualizar.on("click", (e) => { this.atualizar(e) });
      this.elBtnSalvarServidor.on("click", (e) => { this.salvarServidor(e) });
      this.elFiltroExigido.on("click", (e) => { this.aoClicarAgendamentoSemFiltro(e) });
      this.elAgendamentoExigido.on("click", (e) => { this.aoClicarAgendamentoExigido(e) });

      this.elCheckBoxAtivarDesativar.on("change", (e) => { this.aoAtivarDesativarFiltro(e) });
      this.elCheckBoxAtivarDesativarConfigRemota.on("change", (e) => { this.aoAtivarDesativarConfigRemota(e) });
      this.elBtbAcaoResolverDme.on("click", (e) => { this.executarResolverDmeImediato(e) });

      $(document).on('click', '.btn-salvar-credenciais', (e) => { this.salvarCredenciais(e) });
      $(document).on('click', '.abrir-sniper', (e) => { this.aoAbrirSniper(e) });
      $(document).on('click', '.btn-parar-tarefa', (e) => { this.pararTarefa(e) });
      $(document).on('click', '.btn-acessar', (e) => { this.acessarSniper(e, true) });
      $(document).on('click', '.btn-fechar-sniper', (e) => { this.fecharSniper(e) });
      $(document).on('click', '.btn-iniciar-venda-de-coins-imediata', (e) => { this.executarVendaCoinsImediata(e) });
      $(document).on('click', '.btn-iniciar-resolver-dme-imediato', (e) => { this.aoClicarResolverDmeImediato(e) });
      $(document).on('click', '.btn-atualizar-info-jogadores-clube', (e) => { this.atualizarInfoJogadoresClube(e) });
      $(document).on('click', '.btn-atualizar-agenda', (e) => { this.aoAtualizarAgenda(e) });
      $(document).on('click', '.remover-conta', (e) => { this.aoExcluirConta(e) });
      $(document).on('click', '.btn-autenticar', (e) => { this.acessarSniper(e) });
      $(document).on('click', '.btn-sincronizar-conta-local', (e) => { this.sincronizarContaNaMaquinaLocal(e) });
      $(document).on('click', '.btn-resolver-captcha', (e) => { this.acessarSniper(e, true) });
      $(document).on('click', '.btn-resolver-captcha-auto', (e) => { this.resolverCaptchaAutomaticamente(e) });
      $(document).on('click', '.btn-ver-mais', (e) => { this.aoVerEstatisticas(e) });
      $(document).on('click', '.btn-dt-ajustar-lucro', (e) => { this.aoClicarAjustarLucro(e) });

      $(document).on('click', '.btn-cancelar-venda-coins', (e) => { this.cancelarVendaCoins(e) });
      $(document).on('click', '.btn-encontrar-jogadores-para-sniper', (e) => { this.aoBuscarJogadoresParaSnipar(e) });
      $(document).on('click', '.btn-aplicar-jogador-filtro', (e) => { this.aoAplicarjogadorFiltro(e) });
      $(document).on('click', '.btn-mostrar-telawebapp', (e) => {
        if (this.ip && this.ipPlugin && this.ip != this.ipPlugin) {
          this.acessarSniper(e, true, true)
        } else {
          this.mostrarTelaWebApp(e)
        }
      });

      $(document).on('change', 'input[name=agenda_ativa]', (e) => { this.aoLigarDesligarAgenda(e); });
      $(document).on('click', 'span.email-conta', (e) => { this.aoClicarEmailConta(e) });

      $(document).on('click', '.btn-iniciar-correcao-bug-ea', (e) => { this.executarResolverBugContaEa(e) });

      this.elDropdownAplicarFiltroPro.on("click", (e) => { this.aoAplicarFiltroPro(e) });
      this.elDropdownSubstituirFiltroPro.on("click", (e) => { this.aoSubstituirFiltroPro(e) });
      this.elBtnLimparFiltroPro.on("click", (e) => { this.aoLimparFiltroPro(e) });
      this.elBtnAplicarProfile.on("click", (e) => { this.aoAplicarPerfil(e) });
      this.elBtnAplicarFiltros.on("click", (e) => { this.aoAplicarFiltros(e) });
      this.elBtnAplicarProxy.on("click", (e) => { this.aoAplicarProxy(e) });
      this.elBtnResolverDmeContas.on("click", (e) => { this.executarResolverDmeImediato(e, $("#modalResolverDmeContasSelecionadas"), this.getIdsContasSelecionadas()) });
      this.elBtnSelecionarTodosOsFiltros.on("click", (e) => { this.aoSelecionarTodosOsFiltros(e) });
      this.elBtnApagarTodosOsFiltros.on("click", (e) => { this.aoApagarTodosOsFiltros(e) });
      this.elBtnAbrirContas.on("click", (e) => { this.abrirContas() });
      this.elBtnLimparCache.on("click", (e) => { this.limparCacheContas() });
      this.elBtnSincronizarDatabase.on("click", (e) => { this.sincronizarDataBaseContas() });
      this.elBtnExecutarTarefaContas.on("click", (e) => { this.executarTarefaContas() });
      this.elBtnVenderCoins.on("click", (e) => { this.executarVendaCoinsIdsContas() });
      this.elBtnResolverBugEa.on("click", (e) => { this.executarResolverBugIdsContas() });
      this.elBtnAjustarLucro.on("click", (e) => { this.ajustarLucro(e) });

      //quando clicar no new filter chamar essa funcao
      this.elBtncadastrarFiltroPro.on("click", (e) => { this.estadoVazioFiltroPro(e) });

      this.elBtnAtivarPilotoAutomatico.on('change', (e) => { this.aoSelecionarPilotoAutomatico(e); });

      this.elBtnSalvarFiltroProModalSniper.on("click", (e) => { this.aoSalvarFiltroModalSniper(e); });
      this.elBtnAddConta.on("click", (e) => { this.aoAbirFormAddConta(e); });

      $("input[name=tarefa_ligada]").on("click", (e) => { this.aoSelecionarLigarDesligarTarefa(e); });

      $("#searchclearSniperPro").click((e) => {
        var formSniperPro: any = $(e.currentTarget).parents('#formSniperPro');
        formSniperPro.find("#imgJogador").attr('src', "images/default.png");
        formSniperPro.find(".campo-jogador").select2('val', '0');
        formSniperPro.find('.campo-jogador').find("option").remove();
      });

      $('#modalCadastrarFiltroProCad').on('shown.bs.modal', function (e) {
        $(e.currentTarget).find('input[name=id]').val("")
      });

      $('#modalSniperPro').on('hidden.bs.modal', (e) => {
        $('.conteudo-loading-sniper-pro').modal('hide')
        this.desativarInteracaoSniper($(e.currentTarget).find('input[name=id]').val())
        $(".modal-backdrop.show").remove()
      });

      $('.btn-estimar-lucro').on("click", (e) => { this.iniciarSniper(e) });
      $('.btn-criar-filtro').on("click", (e) => { this.getJogadoresMultRaridadesPorUrlFutbin(e) });
      $('.dropdown-menu-criar-filtro').on("click", (e) => { e.stopPropagation() });

      this.inicializarCrudFiltroPro()
      this.inicializarCrudAgendamento()
      this.inicializarCrudPerfil()
      this.inicializarCrudApiVendaCoins()
      this.inicializarCrudProxy()
      this.inicializarCrudServidor()

      App.Util.exebirSweetConfirmacao = App.Bot.exibirSweetConfirmacaoHtml;

      this.objSelect2 = new Select2();
      this.getPlayers(() => {
        this.continuarInicializacao();
      });

      App.Util.verificarSessaoLoginPorClick(['btn-atualizar', 'btn-agendar', 'btn-iniciar-vincular-conta', 'btn-add-servidor', 'remover-conta', 'dropdown-item-config'])
      this.util = new Util()
      this.obterConfiguracaoGeralAtualizada()

      this.ip = await App.Util.getPublicIP()
      this.infoPlanoAtual = $('#cardBodyDashboard') && $('#cardBodyDashboard').data('infoPlano') ? $('#cardBodyDashboard').data('infoPlano') : this.infoPlanoAtual

      this.inicializarMetodosEnvioCromprovante()
      this.verificarSituacaoDaConta()
    }

    private fecharDropdownCriarFiltro() {
      try {
        var dropdown = $('.dropdown-toggle-criar-filtro');
        dropdown.click()
      } catch (e) {
        console.log("ERRO FECHAR DROPDOWN", e)
      }
    }

    private aoAtivarDesativarFiltro(e: JQueryEventObject) {
      this.ajax = new App.Ajax();
      this.ajax.postAcao($(e.currentTarget).data("url"), { id: $(e.currentTarget).data("id"), status: $(e.target).is(':checked') });
    }

    private inicializarMetodosEnvioCromprovante() {
      setTimeout(() => {
        this.processarAlertasUtil()
        App.Util.processarAlertas = this.processarAlertasUtil
        this.processarAlertasUtil = () => { };

        Util.exibirNotificacaoPlanoExpirando()

      }, 4000);
    }

    private inicializarCrudFiltroPro() {
      var modelViewFiltroPro = new ModelView();
      modelViewFiltroPro.elBtnEditar = $(".btn-editar-filtro-pro");
      modelViewFiltroPro.elBtnCopiar = $(".btn-copiar-filtro");
      modelViewFiltroPro.inicializar($('#formFiltroPro, #formFiltroProCad'), false, () => {
        App.Util.exibirModalPaginaCarregando();
        window.location.href = $("#formFiltroPro").data('url-aba-filtro');
      });
      modelViewFiltroPro._this = this;
      modelViewFiltroPro.aoEditarRegistro = this.aoEditarRegistroFiltroPro;
      this.ajax = new App.Ajax();
      modelViewFiltroPro.validacaoAntesDeSalvar = (e: JQueryEventObject, continuar: any) => {
        var dadosFormFiltroPro: IFormDadosSniperPro = this.ajax.convertFormToJSON($(e.currentTarget));
        if (App.Util.validarFiltroSniper(dadosFormFiltroPro)) {
          continuar()
        }
      }

      modelViewFiltroPro.acaoAposCopiarRegistro = (dados: IRespostaSucessoAjx) => {
        document.location.reload();
      }


      $("#formFiltroProCad").on("change", "input:not([name=nome]), select:not([name=nome])", (e) => {
        let formSniperPro: any = $(e.currentTarget).parents('#formFiltroProCad');
        let nomeFiltro = this.obterNomeFiltro('#' + formSniperPro.attr('id'));
        formSniperPro.find('input[name=nome').val(nomeFiltro);
      });

      modelViewFiltroPro.ojDataTableCarregado.elDataTable = $("#dataTableFiltros");

      modelViewFiltroPro.ojDataTableCarregado.metodoSelecionarDeselecionarComplemento = (count: number) => {
        $('.btn-ativar-selecionados').html(count > 0 ? `Ativar (${count})` : `Ativar`)
        $('.btn-desativar-selecionados').html(count > 0 ? `Desativar (${count})` : `Desativar`)
      }

      modelViewFiltroPro.ojDataTableCarregado.acoesButtonExtra = [
        {
          className: "btn-sm btn-outline-primary btn-ativar-selecionados",
          text: 'Ativar',
          action: () => {
            let itensSelecionados = modelViewFiltroPro.getContasSelecionadas()
            let count = itensSelecionados.count();
            if (count) {
              this.aoAtivaDesativarRegistros(modelViewFiltroPro, true, itensSelecionados.ids().toArray())
            }
          }
        },
        {
          className: "btn-sm btn-outline-primary btn-desativar-selecionados",
          text: 'Desativar',
          action: () => {
            let itensSelecionados = modelViewFiltroPro.getContasSelecionadas()
            let count = itensSelecionados.count();
            if (count) {
              this.aoAtivaDesativarRegistros(modelViewFiltroPro, false, itensSelecionados.ids().toArray())
            }
          }
        }
      ]

      modelViewFiltroPro.carregardataTable()
    }

    private inicializarCrudAgendamento() {
      let agendaPreenchida: number[] = []
      var modelViewAgendamento = new ModelView();
      modelViewAgendamento.elBtnEditar = $(".btn-editar-agendamento");
      modelViewAgendamento.elBtnExcluir = $(".btn-excluir-agendamento");
      modelViewAgendamento.elBtnCopiar = $(".btn-copiar-agendamento");

      modelViewAgendamento.inicializar($('.form-step-config-agendamento'), false, (dados: IRespostaSucessoAjx) => {
        let e: JQueryEventObject = dados.parametroCallback;
        $(e.currentTarget).parents('tr').remove();
      });

      modelViewAgendamento._this = this;
      modelViewAgendamento.aoEditarRegistro = (e: JQueryEventObject, _this: this) => {
        let idRegistro = $(e.currentTarget).data("id")
        var modal = $(`#modalCadastrarAgendamento${idRegistro}`);
        var form: JQuery = modal.find('form');
        modal.modal('show');

        var objAgendamento: IObjAgendamento = { id: $(e.currentTarget).data("id"), nome: $(e.currentTarget).data("nome"), dados: $(e.currentTarget).data("dados") }
        _.contains(agendaPreenchida, idRegistro) || this.preencherAgendamentos(form, modal, objAgendamento)
        agendaPreenchida.push(idRegistro)

        //console.log("REGISTRO EDIT::", $(e.currentTarget).data("id"), objAgendamento)
      }

      modelViewAgendamento.aoSalvarRegistroPorModal = (e: JQueryEventObject) => {
        e.preventDefault();
        var formAgendamento = $(e.target);
        var modalAgendamento = $(e.target).parents('.modal-step-config');
        var invalido = false;
        let idRegistro = formAgendamento.data('id');

        formAgendamento.find(".select-filtro").each((index, value) => {
          //console.log("Sel", value)
          var containerItem = $(value).parents('.container-item-sch')
          var pilotoAutomatico = containerItem.find("input[name=piloto_automatico]").is(':checked')
          if ($(value).val().length <= 0 && !pilotoAutomatico) {
            invalido = true;
            $('.collapse').collapse('hide')
            setTimeout(() => {
              $(value).parents('.collapse').collapse('show')
              $(value).parents('.espaco-filtro').find('.error-filtro').show()
              setTimeout(() => {
                document.getElementById($(value).attr('id')).scrollIntoView();
              }, 1000)
            }, 1000)
          }
        });

        if (invalido) {
          toastr.warning("O agendamento precisa ter pelo menos 1 filtro", "Informe o Filtro!");
          return
        } else {
          formAgendamento.find('.error-filtro').hide()
        }

        var objAgendamentosContas: { nome: string, dados: any } = { nome: formAgendamento.find("input[name=nome]").val(), dados: this.obterObjetoAgendamento(formAgendamento, null) }

        //console.log("FORM::", objAgendamentosContas)

        modalAgendamento.modal('hide');
        App.Util.exibirModalPaginaCarregando(parseInt(idRegistro));
        try {
          this.ajax = new App.Ajax();
          this.ajax.postAcao(`${formAgendamento.data('url')}/${idRegistro}`, objAgendamentosContas, (objVinculoConta: IRespostaAjaxPostAcao) => {
            if (objVinculoConta.hasOwnProperty('status') && objVinculoConta.status == "success") {
              modalAgendamento.find('.nao-salvo-geral').hide()
              let dadosResposta: { atualizar_agenda: { idUser: number, data: string, contasIds: number[] }, dados: any, id: number, nome: string } = objVinculoConta.dadosRetornados.dadosResposta;
              this.atualizarContasByIdsContas(dadosResposta.atualizar_agenda ? this.getIdsAllContas() : null)

              let tempoTotalExecucao = 0
              $.each(objVinculoConta.dadosEnviados.dados, (index: any, agendamento: IAgendamentoConfiguracao) => {
                var elementoContainer: JQuery = formAgendamento.find('#containerItem' + index);
                let infoFiltrosSalvos: string = this.obterInfoNomeFiltrosSalvosAposSalvarAgendamento(index, objVinculoConta.dadosRetornados)
                let infoTempoExecucao = this.obterTempoExecucaoAposSalvarAgendamento(index, objVinculoConta.dadosRetornados)
                tempoTotalExecucao += infoTempoExecucao.tempo
                //console.log("SALVAR 02", agendamento, infoFiltrosSalvos, objVinculoConta.dadosRetornados)
                this.atualizarViewContainerAgendamento(elementoContainer, agendamento, true, infoFiltrosSalvos, infoTempoExecucao.info)
              });

              this.atualizarTempoTotalExecucao(formAgendamento, tempoTotalExecucao)
              this.atualizarListaAgendamento(idRegistro, objAgendamentosContas)
            } else {
              modalAgendamento.modal('show');
            }
            App.Util.ocultarModalPaginaCarregando()
          }, null, false);
        } catch (e) {
          //console.log("ERRO SALVAR AGENDAMENTO", e)
          App.Util.ocultarModalPaginaCarregando()
          modalAgendamento.modal('show');
        }
      }

      modelViewAgendamento.acaoAposCopiarRegistro = (dados: IRespostaSucessoAjx) => {
        document.location.reload();
      }
    }

    private inicializarCrudPerfil() {
      let formPreenchido: number[] = []
      var modelViewPerfil = new ModelView();
      modelViewPerfil.elBtnEditar = $(".btn-editar-perfil");
      modelViewPerfil.elBtnExcluir = $(".btn-excluir-perfil");
      modelViewPerfil.elBtnCopiar = $(".btn-copiar-perfil");

      modelViewPerfil.inicializar($('.form-step-config-perfil'), false, (dados: IRespostaSucessoAjx) => {
        let e: JQueryEventObject = dados.parametroCallback;
        $(e.currentTarget).parents('tr').remove();
      });

      modelViewPerfil._this = this;
      modelViewPerfil.aoEditarRegistro = (e: JQueryEventObject, _this: this) => {
        let idRegistro = $(e.currentTarget).data("id")
        var modal = $(`#modalCadastrarPerfil${idRegistro}`);
        var form: JQuery = modal.find('form');
        modal.modal('show');

        var objPerfil: IPerfil = { id: $(e.currentTarget).data("id"), nome: $(e.currentTarget).data("nome"), dados: $(e.currentTarget).data("dados") }
        _.contains(formPreenchido, idRegistro) || this.preencherFormPerfil(form, modal, objPerfil)
        formPreenchido.push(idRegistro)

        //console.log("REGISTRO EDIT::", objPerfil)
      }

      modelViewPerfil.aoSalvarRegistroPorModal = (e: JQueryEventObject) => {
        e.preventDefault();
        var formRegistro = $(e.target);
        var modalAgendamento = $(e.target).parents('.modal-step-config');
        let idRegistro = formRegistro.data('id');

        this.ajax = new App.Ajax();
        let dadosForm: any = this.ajax.convertFormToJSON(formRegistro)
        //console.log("PERFIL::", dadosForm)
        var objDadosRegistro: { nome: string, dados: any } = { nome: formRegistro.find("input[name=nome]").val(), dados: _.omit(dadosForm, ['_token', 'id', 'nome']) }

        // if (objDadosRegistro && objDadosRegistro.dados && objDadosRegistro.dados.recarregar_webapp) {
        objDadosRegistro.dados.recarregar_webapp = false;
        // }

        //console.log("FORM::", objDadosRegistro)
        modalAgendamento.modal('hide');
        App.Util.exibirModalPaginaCarregando(parseInt(idRegistro));

        try {
          this.ajax.postAcao(`${formRegistro.data('url')}/${idRegistro}`, objDadosRegistro, (objResposta: IRespostaAjaxPostAcao) => {
            if (objResposta.hasOwnProperty('status') && objResposta.status == "success") {
              let dadosResposta: { atualizar_agenda: { idUser: number, data: string, contasIds: number[] }, dados: any, id: number, nome: string } = objResposta.dadosRetornados.dadosResposta;
              this.atualizarContasByIdsContas(dadosResposta.atualizar_agenda ? this.getIdsAllContas() : null)
              this.atualizarListaPerfil(idRegistro, objDadosRegistro)
            } else {
              modalAgendamento.modal('show');
            }
            App.Util.ocultarModalPaginaCarregando()
          }, null, false);
        } catch (e) {
          console.log("ERRO SALVAR Registro", e)
          App.Util.ocultarModalPaginaCarregando()
          modalAgendamento.modal('show');
        }
      }

      modelViewPerfil.acaoAposCopiarRegistro = (dados: IRespostaSucessoAjx) => {
        document.location.reload();
      }
    }

    private inicializarCrudApiVendaCoins() {
      let formPreenchido: number[] = []
      var modelViewApiVendaCoins = new ModelView();
      modelViewApiVendaCoins.elBtnEditar = $(".btn-editar-api-venda-coins");
      modelViewApiVendaCoins.elBtnExcluir = $(".btn-excluir-api-venda-coins");

      $('.form-step-config-api-venda-coins').find('select[name=id_servico]').on('change', function () {
        let formApi = $(this).parents('form')
        let selectedOption = $(this).val();
        switch (selectedOption) {
          case '1':
          case '6':
            formApi.find(".espaco-campo-user-email").hide()
            break;
          default:
            formApi.find(".espaco-campo-user-email").show()
            break;
        }
      });

      modelViewApiVendaCoins.inicializar($('.form-step-config-api-venda-coins'), false, (dados: IRespostaSucessoAjx) => {
        let e: JQueryEventObject = dados.parametroCallback;
        $(e.currentTarget).parents('tr').remove();
      });

      modelViewApiVendaCoins._this = this;
      modelViewApiVendaCoins.aoEditarRegistro = (e: JQueryEventObject, _this: this) => {
        let idRegistro = $(e.currentTarget).data("id")
        var modal = $(`#modalCadastrarApiVendaCoins${idRegistro}`);
        var form: JQuery = modal.find('form');
        modal.modal('show');

        var objApiVendaCoins: IObjFormApiVendaCoins = { id: $(e.currentTarget).data("id"), nome: $(e.currentTarget).data("nome"), dados: $(e.currentTarget).data("dados") }
        _.contains(formPreenchido, idRegistro) || this.preencherFormApiVendaCoins(form, modal, objApiVendaCoins)
        formPreenchido.push(idRegistro)

        //console.log("REGISTRO EDIT::", objApiVendaCoins)
      }

      modelViewApiVendaCoins.aoSalvarRegistroPorModal = (e: JQueryEventObject) => {
        e.preventDefault();
        var formRegistro = $(e.target);
        var modalAgendamento = $(e.target).parents('.modal-step-config');
        let idRegistro = formRegistro.data('id');

        this.ajax = new App.Ajax();
        let dadosForm: any = this.ajax.convertFormToJSON(formRegistro)
        var objDadosRegistro: { nome: string, dados: any } = { nome: formRegistro.find("input[name=nome]").val(), dados: _.omit(dadosForm, ['_token', 'id', 'nome']) }

        //console.log("FORM::", objDadosRegistro)

        modalAgendamento.modal('hide');
        App.Util.exibirModalPaginaCarregando(parseInt(idRegistro));

        try {
          this.ajax.postAcao(`${formRegistro.data('url')}/${idRegistro}`, objDadosRegistro, (objResposta: IRespostaAjaxPostAcao) => {
            if (objResposta.hasOwnProperty('status') && objResposta.status == "success") {
              this.atualizarListaApiVendaCoins(idRegistro, objDadosRegistro)
            } else {
              modalAgendamento.modal('show');
            }
            App.Util.ocultarModalPaginaCarregando()
          }, null, false);
        } catch (e) {
          console.log("ERRO SALVAR Registro", e)
          App.Util.ocultarModalPaginaCarregando()
          modalAgendamento.modal('show');
        }
      }
    }

    private inicializarCrudProxy() {
      var modelViewProxy = new ModelView();
      modelViewProxy.elBtnEditar = $(".btn-editar-proxy");
      modelViewProxy.elBtnExcluir = $(".btn-excluir-proxy");

      modelViewProxy.inicializar($('.form-step-config-proxy'), true, (dados: IRespostaSucessoAjx) => {
        let e: JQueryEventObject = dados.parametroCallback;
        $(e.currentTarget).parents('tr').remove();
      });

      modelViewProxy.aoEditarRegistro = (e: JQueryEventObject, _this: this) => {
        let idRegistro = $(e.currentTarget).data("id")
        var modal = $(`#modalCadastrarProxy${idRegistro}`);
        modal.modal('show');
      };
    }

    private inicializarCrudServidor() {
      var modelViewServidor = new ModelView();
      modelViewServidor.elBtnEditar = $(".btn-editar-servidor");
      modelViewServidor.elBtnExcluir = $(".btn-excluir-servidor");

      modelViewServidor.inicializar($('.form-step-config-servidor'), true, (dados: IRespostaSucessoAjx) => {
        let e: JQueryEventObject = dados.parametroCallback;
        $(e.currentTarget).parents('tr').remove();
      });

      modelViewServidor.aoEditarRegistro = (e: JQueryEventObject, _this: this) => {
        let idRegistro = $(e.currentTarget).data("id")
        var modal = $(`#modalCadastrarServidor${idRegistro}`);
        modal.modal('show');
      };

      modelViewServidor.ojDataTableCarregado.elDataTable = $("#dataTableServidores");
      modelViewServidor.ojDataTableCarregado.acoesButtonExtra = [
        {
          className: "btn-sm btn-outline-primary btn-abrir-servidores",
          text: 'Abrir Servidor',
          action: () => {
            let itensSelecionados = modelViewServidor.ojDataTableCarregado.objDataTable.rows({ selected: true })
            let count = itensSelecionados.count();
            if (count) {
              itensSelecionados.ids().toArray().forEach((id: number) => {
                let urlHref = $(`#${id}`).find('.btn-acessar-servidor').attr('href');
                window.open(urlHref, '_blank');
              });

              if (count > 1) {
                toastr.warning("Para que nosso sistema consiga abrir varias abas em seu nevegador, pode ser necessário uma autorização de sua parte para abertura de pop-ups", "Importante!");
              }
            }
          }
        }
      ]

      modelViewServidor.ojDataTableCarregado.metodoSelecionarDeselecionarComplemento = (count: number) => {
        $('.btn-abrir-servidores').html(count > 0 ? `Abrir Servidor (${count})` : `Abrir Servidor`)
      }

      modelViewServidor.carregardataTable()
    }

    public aoSalvarFiltroModalSniper(e: JQueryEventObject) {
      this.ajax = new App.Ajax();
      let formSniperPro: any = $(e.currentTarget).parents('#formSniperPro');
      let dadosForm: any = this.ajax.convertFormToJSON(formSniperPro);
      let nomeFiltro = formSniperPro.find('input[name=nome]').val()

      try {
        let campoNomeDigitavel = formSniperPro.find('input[name=campo_nome_filtro]').val()
        nomeFiltro = campoNomeDigitavel ? campoNomeDigitavel : nomeFiltro
      } catch (e) { }

      if (App.Util.validarFiltroSniper(dadosForm)) {
        let dadosFormatado = _.omit(dadosForm, ['descanso', 'intervalo', 'limite_compra', 'piloto_automatico', 'tempo', 'velocidade']);
        dadosFormatado.nome = nomeFiltro ? nomeFiltro : this.obterNomeFiltro("#formSniperPro");
        this.ajax.postAcaoSemCabecalhoGlobal($(e.currentTarget).data("url-salvar-filtro-modal-sniper") + "?nao-regarregar=true", dadosFormatado, App.SalvarFiltro.acaoAposSalvarFiltro);
      }
    }

    private obterNomeFiltro(seletor: any) {
      var elemento = $(seletor);
      var jogador = elemento.find('.select2-selection__choice').find(".name").text();
      var qualidade = $.trim(elemento.find('#qualidade option:selected').text());
      var raridade = $.trim(elemento.find('#raridade option:selected').text());
      var posicao = $.trim(elemento.find('#posicao option:selected').text());
      var estilo = $.trim(elemento.find('#estilo option:selected').text());
      var estiloJogo = $.trim(elemento.find('#estiloJogo option:selected').text());
      var nacionalidade = $.trim(elemento.find('#pais option:selected').text());
      var liga = $.trim(elemento.find('#liga option:selected').text());
      var time = $.trim(elemento.find('#time option:selected').text());

      var valorOferta = null;
      var valorPorLucro = null;
      var ehPrecoCompra = $(seletor).find("input[name=precoCompra]").prop('checked');

      if (ehPrecoCompra) {
        valorOferta = elemento.find("input[name='maxBuyNow']").val() + " Coins";
      } else {
        valorPorLucro = elemento.find("input[name='lucro']").val() + "%";
      }

      var nomeFiltro = (qualidade.indexOf('Limpar') !== -1 ? "" : qualidade + " ") +
        (raridade.indexOf('Limpar') !== -1 ? "" : raridade.substring(0, 7) + " ") + (posicao.indexOf('Limpar') !== -1 ? "" : posicao.substring(0, 3) + " ") +
        (estilo.indexOf('Limpar') !== -1 ? "" : estilo.substring(0, 3) + " ") + (nacionalidade.indexOf('Limpar') !== -1 ? "" : nacionalidade.substring(0, 15).replace(/ /g, "") + " ") +
        (liga.indexOf('Limpar') !== -1 ? "" : liga.substring(0, 8).replace(/ /g, "") + " ") + (time.indexOf('Limpar') !== -1 ? "" : time.substring(0, 15).replace(/ /g, "") + " ") + (estiloJogo.indexOf('Limpar') !== -1 ? "" : estiloJogo.substring(0, 3) + " ") +
        (valorOferta ? valorOferta : valorPorLucro);
      nomeFiltro = nomeFiltro.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
        return a.toUpperCase();
      });
      var nomeFiltroCompleto = (jogador.indexOf('Limpar') !== -1 ? "" : jogador.replace(/ /g, "") + " ") + nomeFiltro;

      return Util.removeAspasEAcentos(nomeFiltroCompleto);
    }

    private continuarInicializacao() {
      $('.piloto-automatico-agendamento').on('change', (e) => { this.aoSelecionarPilotoAutomaticoAgendamento(e); });
      $('.modal-step-config').each((index, value) => {
        var cloneData = new CloneData();
        cloneData.inicializarCampo($('a#' + $(value).find('.add-more-sch').attr('id')), 0, 20, $(value).find('.main-container-sch').attr('id'), $(value).find('.container-item-sch').data('classContainerItem'), $(value).find('.remove-item-sch').data('classRemove'), Util.getOptionsSelectTag(), () => {
          $('.piloto-automatico-agendamento').off('change');
          $('.piloto-automatico-agendamento').on('change', (e) => { this.aoSelecionarPilotoAutomaticoAgendamento(e); });
          $('.copy-item-sch').unbind("click");
          $('.copy-item-sch').on("click", (e) => { this.copiarItemAgendamento(e) });
        }, () => {
          $(value).find('.nao-salvo-geral').show()
        });
      });
      $('.copy-item-sch').on("click", (e) => { this.copiarItemAgendamento(e) });
      $('.espaco-collapse-agenda').on('show.bs.collapse', function (e) {
        if (_.contains(['a', 'i', 'input'], (event.target as any).nodeName.toLowerCase())) {
          e.preventDefault();
          e.stopPropagation();
        }
      })
      this.objSelect2.inicializarCampo($('.select2'));
      this.objSelect2.inicializarCampo($('.select-tag'), Util.getOptionsSelectTag());

      this.filtrosEa = new FiltrosEa();
      this.filtrosEa.inicializarEventos();
      App.Util.ocultarModalPaginaCarregando()
    }

    private getPlayers(metodoCallback: any) {
      const hoje = new Date();
      const parametroCache = `${hoje.getFullYear()}-${hoje.getMonth() + 1}-${hoje.getDate()}`; // Gera o parâmetro baseado na data atual
      $.getJSON("/players.json", { _: parametroCache }, (data) => {
        App.Util.objPlayers = data.Players;
        metodoCallback();
      });
    }

    private aoLimparLog(e: JQueryEventObject) {
      var id: number = $(e.currentTarget).data("id");
      $(`.espaco-log-${id}`).html('');
    }


    public aoEditarRegistroFiltroPro(e: JQueryEventObject, _this: this) {
      var modal = $("#modalCadastrarFiltroPro");
      modal.modal('show');
      var id: number = $(e.currentTarget).data("id");
      var nome: string = $(e.currentTarget).data("nome");
      var nomeOriginal: string = $(e.currentTarget).data("nomeOnly");

      var dados: IDataFiltroPro = $(e.currentTarget).data("dados");
      _this.filtrosEa.setCampoInputName("id", id);
      _this.filtrosEa.setCampoInputName("nome", nomeOriginal);
      if (dados.data.maskedDefId && dados.data.maskedDefId.length) {
        _this.filtrosEa.setCampoJogador(dados.data.maskedDefId, App.Util.objPlayers);
      } else {
        modal.modal('show');
        modal.find("#searchclear").click();
      }

      _this.filtrosEa.setCampoSelect2("quality", dados.data.quality);
      _this.filtrosEa.setCampoSelect2("icontraits", dados.data.icontraits);
      _this.filtrosEa.setCampoSelect2("rarity[]", dados.data.rarity);
      _this.filtrosEa.setCampoSelect2("position", dados.data.position);
      _this.filtrosEa.setCampoSelect2("chemical", dados.data.chemical);
      _this.filtrosEa.setCampoSelect2("nation", dados.data.nation);
      _this.filtrosEa.setCampoSelect2("league", dados.data.league);
      _this.filtrosEa.setCampoSelect2("club", dados.data.club);
      _this.filtrosEa.setCampoInputName("minBuyNow", dados.data.minBuyNow);
      _this.filtrosEa.setCampoInputName("maxBuyNow", dados.data.maxBuyNow);
      _this.filtrosEa.setCampoInputName("variar", dados.data.variar, true);
      _this.filtrosEa.setCampoInputRadio("precoCompra", dados.data.lucro ? "2" : "1");
      _this.filtrosEa.setCampoInputCheckbox("ativar_venda_automatica", !App.Util.empty(dados.venda));
      _this.filtrosEa.setCampoInputCheckbox("precoInteligente", !App.Util.empty(dados.venda) && dados.venda.precoInteligente);
      _this.filtrosEa.setCampoInputCheckbox("precoFutbin", !App.Util.empty(dados.venda) && dados.venda.precoFutbin);
      _this.filtrosEa.setCampoInputName("lucro", dados.data.lucro);
      _this.filtrosEa.setCampoInputCheckbox("turbo", !App.Util.empty(dados.data.turbo) && dados.data.turbo);
      _this.filtrosEa.setCampoInputName("porcentagemMaisBarato", !App.Util.empty(dados.venda) && dados.venda.porcentagemMaisBarato ? dados.venda.porcentagemMaisBarato : 0);
      _this.filtrosEa.setCampoInputName("valor_lance_minimo", !App.Util.empty(dados.venda) && dados.venda.valorLanceMinimo ? dados.venda.valorLanceMinimo : "");
      _this.filtrosEa.setCampoInputName("valor_venda", !App.Util.empty(dados.venda) && dados.venda.valorVenda ? dados.venda.valorVenda : "");
      _this.filtrosEa.setCampoInputName("limite_compra_min", dados.data.limiteCompraMin);
      _this.filtrosEa.setCampoInputName("limite_compra_max", dados.data.limiteCompraMax);
    }

    private async iniciarComunicacaoSocket() {
      let pct: string = null
      let srv: string = null
      let prt: any = null

      let idServidor = Util.getIdServidorByUrl(window.location.href)
      this.dadosServidor = await this.getDadosServidorByTid(idServidor) || { id: null, tid: null, nome: null, address: null, password: null, port: null }
      if (this.dadosServidor && this.dadosServidor.hasOwnProperty('address') && this.dadosServidor.address) {
        pct = this.dadosServidor.protocolo
        srv = this.dadosServidor.address
        prt = this.dadosServidor.port
      } else {
        let objParametrosAtuais = Util.getObjParametrosUrlLocation()
        pct = objParametrosAtuais.get('pct') ? objParametrosAtuais.get('pct') : `http`
        srv = objParametrosAtuais.get('srv') ? objParametrosAtuais.get('srv') : `localhost`
        prt = objParametrosAtuais.get('prt') ? objParametrosAtuais.get('prt') : `5033`
        // console.log("objParametrosAtuais", objParametrosAtuais, srv, prt)
      }
      let objSocketIo = new SocketIo();
      this.socketClientBot = objSocketIo.inicializarCampo(`${pct}://${srv}:${prt}`, App.Util.usuario.id, App.Util.usuario.api_token, this.dadosServidor.address, this.dadosServidor.password, this.dadosServidor.port);
      this.comunicacao = new Comunicacao(this.socketClientBot);
      this.comunicacao.socket.on('disconnect', () => {
        //console.log("Disconect");
        $('.btn-autenticar').hide()
        $('.menu-api-venda-coins').hide()
        this.conectado = false;
        this.exibirViewConexao();
      });
      this.comunicacao.socket.on('connect', () => {
        //console.log("connect");
        $('.btn-autenticar').show()
        this.conectado = true;
        this.exibirViewConexao();
        // this.salvarAutorizacaoCertificadoConexaoHttps(pct, srv, prt)
        swal.close()
      });

      this.comunicacao.socket.on(Comunicacao.CANAL_RECEIVE, async (acao: number | string, request: any, callback: any = null) => {
        switch (acao) {
          case "plugin_ligado":
            this.executarAcoesAoLigarDesligarPlugin(request);
            return;
          case "status":
            this.atualizarStatusConta(request);
            return;
          case "plx":
            this.exibirPlanoExpirado(request);
            return;
          case "log":
            this.receberLogs(request.data)
            return;
          case "busca":
            this.tratarBuscaSniper(request, callback)
            return;
          case "erro_login":
            this.exibirFalhaNaAutenticacao(request);
            return;
          case "update_consolidado_conta":
            this.updateConsolidadosContaDatatable(request.consolidado.id, request.consolidado);
            return;
          case "atualizar_creditos":
            this.atualizarCreditos(request.id, request.creditos, request.lucro);
            return;
          case "conta_agendada":
            this.atualizarViewInfoAgendamento(request.id, request.programacao)
            if (request.ocultarLoad) {
              this.ocultarLoadListConta(request.id)
            }
            return;
          case "codigo_autenticacao_solicitado":
            App.Util.ocultarModalPaginaCarregando()
            return await this.solicitarCodigoValidacao(request, callback)
          case "informar_codigo_autenticacao_solicitado":
            App.Util.ocultarModalPaginaCarregando()
            swal.fire({
              icon: 'info',
              title: `Informe o código de autenticação`,
              text: `vá até o navegador da conta ${request.email} e informe o código enviado pela EA.`,
              allowOutsideClick: false,
              allowEscapeKey: false,
            })
            return
          case "acao":
            this.tratarAcao(request, callback)
            return;
          case "error":
            this.tratarError(request, callback)
            return;
          case "base_dados_corrompido":
            this.informarBaseDadosCorrompida(request);
            return;
          case "init_view_webapp":
            this.iniciarVisualizacaoTelaWebAppRemota(request);
            return;
          case "instalar_chrome_bin":
            this.informarSobreInstalacaoChrome(request);
            return;
        }
      });

      this.comunicacao.socket.on("connect_error", (err: any) => {
        if (pct == "http") {
          return;
        }
        console.log("sock", this.quantidadeFalhaConexaoPlugin, err.message); // prints the message associated with the error
        if (!this.getAutorizacaoCertificadoConexaoHttps(pct, srv, prt)) {
          this.quantidadeFalhaConexaoPlugin++;
          let exibirManutencaoPlugin = Boolean(this.quantidadeFalhaConexaoPlugin >= 6);
          if (exibirManutencaoPlugin && this.quantidadeFalhaConexaoPlugin == 6) {
            swal.close()
          }

          if (!swal.isVisible()) {
            swal.fire({
              title: 'Conectando ao Servidor!',
              confirmButtonText: "Autorizar",
              showDenyButton: exibirManutencaoPlugin,
              denyButtonText: `Iniciar Manutenção`,
              confirmButtonColor: "#2dce89",
              text: 'Por segurança o chrome exige que você autorize a conexão com nosso servidor, se ainda não autorizou, clique em autorizar e siga os passos mostrados na imagem acima para se conectar.',
              imageUrl: '/img/gifs/autorizar-servidor.gif',
              imageWidth: 500,
              imageAlt: 'Autorizar servidor',
              allowOutsideClick: false,
              allowEscapeKey: false
            }).then((result: any) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                console.log("Saved!", "", "success");
                window.location.href = `${pct}://${srv}:${prt}?tid=${this.dadosServidor.tid}&nome=${this.dadosServidor.nome}`
              } else if (result.isDenied) {
                this.ajax.postAcao(App.Util.config.urlSolicitarManutencao, this.dadosServidor, (dadosSucesso: IRespostaSucessoAjx) => {
                  console.log("Manutenção", dadosSucesso.dadosRetornados)
                  swal.fire("Manutenção Programada!", "Uma manutenção programada será iniciada em seu servidor. Aguarde aproximadamente 5 minutos para que seu dashboard seja reconectado. Se necessário, recarregue esta página e clique em 'Autorizar' novamente após esse tempo.", "info");
                });
              }
            });
          }
        }
      });
    }

    private async getDadosServidorByTid(idServidor: string) {
      return new Promise(async (resolve: any, reject: any) => {
        try {
          if (!this.ajax) {
            this.ajax = new Ajax();
          }

          this.ajax.get(App.Util.config.urlGetServidor, { "tid": idServidor }, (dadosSucesso: IRespostaSucessoAjx) => {
            resolve(dadosSucesso.dadosRetornados)
          }, null, null, false)
        } catch (e) {
          resolve(null)
        }
      })
    }

    private salvarAutorizacaoCertificadoConexaoHttps(pct: string, srv: string, prt: string) {
      let chaveAutorizacaoCertificado = `${pct}${srv}${prt}`
      localStorage.setItem(chaveAutorizacaoCertificado, new Date().toISOString());
    }

    private getAutorizacaoCertificadoConexaoHttps(pct: string, srv: string, prt: string) {
      let chaveAutorizacaoCertificado = `${pct}${srv}${prt}`
      return false;
      // return localStorage.getItem(chaveAutorizacaoCertificado) || null;
    }

    private getElementoListConta(idConta: number): JQuery {
      return $(`tr#${idConta}`)
    }

    private receberLogs(dataLog: IDataLog) {
      // console.log("RECEBER_LOG::", dataLog);

      if (dataLog.tipo == Util.EVENTO_TIPO_COMPRA) {
        this.atualizarConsolidadoDaConta(dataLog.idConta)
      }

      this.exibirLogsSniper(dataLog)
      this.carregarTabelaLogs(dataLog);
    }

    private async solicitarCodigoValidacao(request: any, callback: any) {
      Util.ocultarModalPaginaCarregando();
      var result = await swal.fire({
        title: `Informe o código da conta ${request.email} enviado pela EA`,
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Enviar`,
        denyButtonText: `Solicitar outro`,
        denyButtonColor: "#5e72e4",
        confirmButtonColor: "#2dce89",
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

      if (result.isConfirmed) {
        Util.exibirModalPaginaCarregando();
        return this.responderServidor(true, { codigo: result.value }, callback);
      } else if (result.isDenied) {
        // Solicitar novo código
        Util.exibirModalPaginaCarregando();
        return this.responderServidor(true, { codigo: 0 }, callback);
      } else {
        // Cancelou processo informação de codigo
        return this.responderServidor(true, { codigo: null }, callback);
      }

    }

    private iniciarConfiguracoesDeConta(idContaEa: string) {
      try {
        $(".modal-config-extensao").each((index, el) => {
          var configuracoesConta = new App.ConfiguracoesConta($(el), 2);
          configuracoesConta.executarCallbackChange = (obj: IConfiguracoesConta, id: number, data: any = null) => {
            if (App.Util.isset(obj.ativar_proxy)) {
              this.atualizarViewProxyConta(id, obj.ativar_proxy, data)
            }
          }
        });
      } catch (e) {
        console.log("ERRO iniciarConfiguracoesDeConta", e)
      }
    }

    private getIdsContasEaVinculadas(): any {
      return _.pluck(App.Util.usuario.contas, 'id_conta_ea')
    }
    private getIdsContasEaVinculadasPlugin(): any {
      return _.pluck(this.arrayContas, 'id')
    }

    private async getContasPlugin(): Promise<any> {
      return new Promise(async (resolve: any, reject: any) => {
        try {
          this.comunicacao.enviar(Util.ACAO_COMUNICACAO_GET_CONTAS, this.getIdsContasEaVinculadas(), (response: IRespostaMensagem) => {
            resolve(response.result)
          })

        } catch (e) {
          resolve([])
        }
      });
    }

    private async getConsolidadosPlugin(id: number = null): Promise<any> {
      return new Promise(async (resolve: any, reject: any) => {
        try {
          this.comunicacao.enviar(Util.ACAO_COMUNICACAO_GET_CONSOLIDADOS, { id: id }, (response: IRespostaMensagem) => {
            resolve(response.result)
          })
        } catch (e) {
          resolve([])
        }
      });
    }

    private async sincronizarAtualizarDadosGeraisEntrePluginInterface() {
      App.Util.exibirLoadingTableContas()
      this.arrayConsolidados = await this.getConsolidadosPlugin()
      this.arrayContas = await this.getContasPlugin();
      this.carregarPartialsViewsContas()
      await this.continuarinicializacaodashBoard()
      this.carregarTabelaContas(this.arrayContas);
      this.updateLucroGeralPorPlataforma()
      this.updateCoinsGeralPorPlataforma()
      this.updateEncontradosPorFiltro()
      App.Util.ocultarLoadingTableContas()
    }

    private async atualizarConsolidadoDaConta(id: any, consolidado: IContaConsolidado = null) {
      if (!consolidado) {
        consolidado = await this.getConsolidadosPlugin(parseInt(id)) as IContaConsolidado
      }
      this.updateConsolidadosContaDatatable(id, consolidado)
    }


    private getProgressoConsolidadoTempoExecucao(tempoExecucaoSegundos: number): { label?: string, labelAbreviado?: string, limite?: number, tempo?: number, percent?: number, color: string } {
      var consolidadoTempoExecucao: { label?: string, labelAbreviado?: string, limite?: number, tempo?: number, percent?: number, color: string } = { color: '#00e673' }
      if (tempoExecucaoSegundos < 3600) {
        consolidadoTempoExecucao.labelAbreviado = "min";
        consolidadoTempoExecucao.label = "minutos";
        consolidadoTempoExecucao.limite = 120;
        consolidadoTempoExecucao.tempo = App.Util.parseSegundosParaMinutos(tempoExecucaoSegundos);
        consolidadoTempoExecucao.percent = Math.round(consolidadoTempoExecucao.tempo * 100 / consolidadoTempoExecucao.limite)
        consolidadoTempoExecucao.color = consolidadoTempoExecucao.percent > 80 ? "#ff1a1a" : (consolidadoTempoExecucao.percent > 50 ? "#ffff00" : consolidadoTempoExecucao.color)
      } else {
        consolidadoTempoExecucao.labelAbreviado = "h";
        consolidadoTempoExecucao.label = "horas";
        consolidadoTempoExecucao.limite = 2;
        consolidadoTempoExecucao.tempo = App.Util.parseSegundosParaHoras(tempoExecucaoSegundos);
        consolidadoTempoExecucao.percent = Math.round(consolidadoTempoExecucao.tempo * 100 / consolidadoTempoExecucao.limite)
        consolidadoTempoExecucao.color = consolidadoTempoExecucao.percent > 80 ? "#ff1a1a" : (consolidadoTempoExecucao.percent > 50 ? "#ffff00" : consolidadoTempoExecucao.color)
      }

      return consolidadoTempoExecucao;
    }

    private getProgressoDinamico(valor: number, limite: number, label: string): { label?: string, limite?: number, valor?: number, percent?: number, color: string } {
      var consolidadoprogresso: { label?: string, limite?: number, valor?: number, percent?: number, color: string } = { color: '#00e673' }
      consolidadoprogresso.label = label;
      consolidadoprogresso.limite = limite;
      consolidadoprogresso.valor = valor;
      consolidadoprogresso.percent = Math.round(consolidadoprogresso.valor * 100 / consolidadoprogresso.limite)
      consolidadoprogresso.color = consolidadoprogresso.percent > 80 ? "#ff1a1a" : (consolidadoprogresso.percent > 50 ? "#ffff00" : consolidadoprogresso.color)

      return consolidadoprogresso;
    }

    private getConsolidadoLucro(valor: number, label: string): { label?: string, valor?: number, class: string, classIcon: string } {
      var consolidado: { label?: string, valor?: number, class: string, classIcon: string } = { class: 'text-default', classIcon: '' }
      consolidado.label = label;
      consolidado.valor = valor;

      consolidado.class = consolidado.valor < 0 ? "text-danger" : (consolidado.valor > 0 ? "text-success" : consolidado.class)
      consolidado.classIcon = consolidado.valor < 0 ? "fa fa-arrow-down" : (consolidado.valor > 0 ? "fa fa-arrow-up" : consolidado.classIcon)

      return consolidado;
    }

    private vincularConta(e: JQueryEventObject) {
      $("#modalAddConta").modal('hide')
      var credenciais: IDadosCredenciais = this.getCredenciaisConta();
      this.aoVincularConta(credenciais.email, (resposta: { id: number, status_conta: boolean, conta_encontrada_do_usuario: boolean, tem_espaco_vinculo: boolean }) => {
        console.log("aoVincularConta", resposta);
        // se é plano cloud e a conta ja existe do usuario mas está inutilizada, status=false
        if (this.infoPlanoAtual.ehPlanoCloud && resposta.conta_encontrada_do_usuario && !resposta.status_conta) {
          swal.fire({
            icon: 'warning',
            title: 'Conta EA já removida Anteriormente!',
            text: `A conta EA que você deseja adicionar no sistema já foi vinculada e removida/Inutilizada anteriormente, caso deseje voltar a utiliza-la, favor entrar em contato conosco pelo email: contato@futsniperweb.com.br`
          })
          return
        }

        // // se a conta não foi encontrada e não tem espaço para mais vinculos, avisar limite atingido
        // if (!resposta.conta_encontrada_do_usuario && !resposta.tem_espaco_vinculo) {
        //   swal.fire({
        //     icon: 'warning',
        //     title: 'Limite de Conta Atingido!',
        //     text: `Não há espaço para adicionar uma nova conta, exclua uma de suas contas atuais ou considere fazer um upgrade do seu plano para poder adicionar mais contas.`
        //   })
        //   return
        // }


        this.iniciarSessaoConta(null, credenciais, false, true)
      })
    }

    private vincularMultConta(e: JQueryEventObject) {
      $("#modalAddMultConta").modal('hide')
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_VINCULAR_MULT_CONTAS, this.getCredenciaisMultConta(), (response: IRespostaMensagem) => {
        //console.log("REAGENDAR", response)
      })
    }

    private acessarSniper(e: JQueryEventObject, navegadorVisivel: boolean = false, mostrarTelaWebApp: boolean = false) {
      var idConta = $(e.currentTarget).data('idContaEa');
      var credenciais = this.getCredenciaisConta(idConta);
      this.iniciarSessaoConta(idConta, credenciais, navegadorVisivel, false, mostrarTelaWebApp)
    }

    private pararTarefa(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      this.exibirLoadListConta(idConta, "Parando Tarefa...")
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_PARAR_TAREFA, { id: idConta }, (response: IRespostaMensagem) => {
        this.ocultarLoadListConta(idConta)
      });
    }

    private atualizarExecucaoConta(idConta: number) {
      //console.log("atualizarExecucaoConta", idConta);
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_UPDATE_EXECUCAO_CONTA, { id: idConta });
    }

    private cancelarVendaCoins(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      this.exibirLoadListConta(idConta, "Cancelando...")
      //console.log("Cancelar venda", idConta, Util.ACAO_COMUNICACAO_CANCELAR_VENDA_COINS, { id: idConta })
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_CANCELAR_VENDA_COINS, { id: idConta }, (response: IRespostaMensagem) => {
        this.ocultarLoadListConta(idConta)
      });
    }

    private async atualizarContasByIdsContas(contasIds: number[]) {
      //console.log("DADOS", contasIds)
      if (!contasIds || !contasIds.length) {
        return
      }

      await this.atualizarContasNoPluginAposDadosAplicados(contasIds)

      this.avisarSobreReagendamentoPluginDesconectado()
    }

    private pararTarefaByModal(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_PARAR_TAREFA, { id: idConta }, (response: IRespostaMensagem) => {
        setTimeout(() => {
          let conta: IConta = response.result.conta
          $('.conteudo-loading-sniper-pro').modal('hide')
          this.atualizarEstadoModalSniper(conta.id, conta.status)
        }, 3000);
      });
    }

    private ativarEstadoConectado() {
    }

    private ativarEstadoDesconectado() {
    }

    private fecharSniper(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      this.exibirLoadListConta(idConta, "Fechando Conta...")
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_FECHAR_CONTA, { id: idConta }, (response: IRespostaMensagem) => {
        this.ocultarLoadListConta(idConta)
      });
    }

    private executarVendaCoinsImediata(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      this.exibirLoadListConta(idConta, "Executar Venda de Coins")
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_EXECUTAR_ACAO_UNICA, { acao: Util.ID_TIPO_ACAO_UNICA_VENDER_COINS_NA_CONTA, id: idConta }, (response: IRespostaMensagem) => {
        this.ocultarLoadListConta(idConta)
      });
    }

    private resolverCaptchaAutomaticamente(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      this.exibirLoadListConta(idConta, "Resolver Captcha Automaticamente")
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_EXECUTAR_ACAO_UNICA, { acao: Util.ID_TIPO_ACAO_UNICA_RESOLVER_CAPTCHA_AUTOMATICAMENTE, id: idConta }, (response: IRespostaMensagem) => {
        console.log("resolverCaptchaAutomaticamente", idConta, response)
        this.ocultarLoadListConta(idConta)
      });
    }

    private atualizarInfoJogadoresClube(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      this.exibirLoadListConta(idConta, "Atualizando info jogadores clube")
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_EXECUTAR_ACAO_UNICA, { acao: Util.ID_TIPO_ACAO_UNICA_ATUALIZAR_INFO_JOGADORES_CLUBE, id: idConta }, (response: IRespostaMensagem) => {
        //console.log("atualizarInfoJogadoresClube", response, response.status)
        if (response.status) {
          this.atualizarContaNoPlugin({ id: idConta }, (response: IRespostaMensagem) => {
            //console.log("ATUALIZAR NO PLUGIN::", response);
            if (response.status && response.result && response.result.contaAtualizada) {
              this.updateContaDatatable(response.result.contaAtualizada);
            }
          })
        }
        this.ocultarLoadListConta(idConta)
      });
    }

    private aoAtualizarAgenda(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      this.atualizarContaNoPlugin({ id: idConta })
      this.avisarSobreReagendamentoPluginDesconectado("O plugin está desconectado, para poder reagendar a conta, conecte ao plugin.")
    }

    private salvarCredenciais(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      var credenciais = this.getCredenciaisConta(idConta);
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_CREDENCIAIS, credenciais, (response: IRespostaMensagem) => {
        if (response.status) {
          toastr.success("Credenciais foram salvas", "Sucessso!");
          $(`#modalConfigCredenciais${idConta}`).modal('hide')
        }
      })
    }
    private salvarConfigGeral(e: JQueryEventObject) {
      var form = $(`#formConfiguracoesGeralBot`)
      App.Util.exibirLoadingFormModal($('.loading-form-modal'))
      if (this.elCheckBoxAtivarDesativarConfigRemota.is(':checked')) {
        this.salvarOuAtualizarConfigRemota(true, (objRepostaAtualizacaoConfigRemota: IRespostaAjaxPostAcao) => {
          App.Util.ocultarLoadingFormModal($('.loading-form-modal'))
          console.log("objRepostaAtualizacaoConfigRemota", objRepostaAtualizacaoConfigRemota);
          if (objRepostaAtualizacaoConfigRemota && objRepostaAtualizacaoConfigRemota.status == "success") {
            toastr.success("Configurações foram salvas", "Sucessso!");
            form.parents('.modal').modal('hide')
            if (objRepostaAtualizacaoConfigRemota.dadosRetornados) {
              this.configuracoesGeraisExecucao = objRepostaAtualizacaoConfigRemota.dadosRetornados.dados
              if (!this.configuracoesGeraisExecucao.exibir_cronometro) {
                $.each(App.Business.cronometros, (index: any, id: number) => {
                  Util.pararCronometroMult(App.Business.cronometros[id]);
                });
              }
            }
          }
        })
      } else {
        var dadosForm: IConfiguracoesGeraisExecucao = this.ajax.convertFormToJSON(form)
        //console.log("DDDD", dadosForm)
        this.comunicacao.enviar(Util.ACAO_COMUNICACAO_SALVAR_CONFIG_GERAL, dadosForm, (response: IRespostaMensagem) => {
          App.Util.ocultarLoadingFormModal($('.loading-form-modal'))
          if (response && response.status) {
            toastr.success("Configurações foram salvas", "Sucessso!");
            form.parents('.modal').modal('hide')
            if (response.result && response.result.configuracao) {
              this.configuracoesGeraisExecucao = response.result.configuracao
              if (!this.configuracoesGeraisExecucao.exibir_cronometro) {
                $.each(App.Business.cronometros, (index: any, id: number) => {
                  Util.pararCronometroMult(App.Business.cronometros[id]);
                });
              }
            }
          }
        })
      }
    }

    private atualizarContasVinculadasNoPlugin() {
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_ATUALIZAR_CONTAS_VINCULADAS, this.getIdsContasEaVinculadas())
    }

    private teste(e: JQueryEventObject) {
      //console.log("TESTE", App.Business.dadosTeste)
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_TESTE, App.Business.dadosTeste ? App.Business.dadosTeste : {}, (response: IRespostaMensagem) => {
        console.log("TESTE", response)
        if (response.status) {
          toastr.success(response.status, "Sucessso!");
        }
      })
    }

    private testeNotificacaoTelegram(e: JQueryEventObject) {
      //console.log("TESTE_NOTIFICACAO_TELEGRAM", App.Business.dadosTeste)
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_TESTE_NOTIFICACAO_TELEGRAM, App.Business.dadosTeste ? App.Business.dadosTeste : {}, (response: IRespostaMensagem) => {
        if (response.status) {
          toastr.success(response.status, "Sucessso!");
        }
      })
    }

    private ativarInteracaoSniper(id: number) {
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_INTERACAO_SNIPER, { status: true, id: id }, (response: IRespostaMensagem) => { })
    }

    private desativarInteracaoSniper(id: number) {
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_INTERACAO_SNIPER, { status: false, id: id }, (response: IRespostaMensagem) => { })
    }

    private getCredenciaisConta(idConta: number = null): IDadosCredenciais {
      let elementoCredenciais = null;
      if (idConta) {
        elementoCredenciais = $(`#formCredenciaisBot${(idConta)}`);
      } else {
        elementoCredenciais = $(`#formConfiguracoesBotAddConta`);
      }

      if (elementoCredenciais.length) {
        return {
          id: idConta, email: elementoCredenciais.find('input[name=email]').val() || null, senha: elementoCredenciais.find('input[name=senha]').val() || null,
          auth: elementoCredenciais.find('input[name=auth]').val() || null,
          persona: elementoCredenciais.find('select[name=select_persona]').val() || null,
          tipoAuth: elementoCredenciais.find('input[name=modo_auth2]:checked').val(),
          resolverBug: elementoCredenciais.find('input[name=modo_resolver_bug]').is(':checked') ? true : false
        }
      }

      return { id: idConta, email: null, senha: null, auth: null, persona: null, tipoAuth: null, resolverBug: false }
    }

    private getCredenciaisMultConta(idConta: number = null): any {
      let elementoFormCredenciais = $(`#formConfiguracoesBotAddMultConta`);

      let lista = null
      if (elementoFormCredenciais.length) {
        try {
          lista = elementoFormCredenciais.find('textarea[name=lista_contas]').val() || null
          //console.log("List", lista)
          lista = JSON.parse(JSON.stringify(lista))
        } catch (e) {
          console.log("error", e)
          toastr.warning("Confira se os dados estão no padrão correto conforme informado no exemplo default.", "Dados Incorretos!");
          lista = null

        }
        if (!lista) {
          toastr.warning("Informe os dados no padrão conforme informado no exemplo default.", "Informe os dados das contas!");
        }
        return lista
      }

      return lista
    }

    private getListaContasVinculo(listaContas: string): IListaContasVinculo[] {
      var linhas = listaContas.split('\n').map(function (linha) {
        return linha.trim().replace('"', '');
      }).filter(function (linha) {
        return linha !== '';
      });

      // Mapeia cada linha para um objeto com as propriedades desejadas
      var contasArray: IListaContasVinculo[] = linhas.map(function (linha) {
        var dados = linha.split(',').map(function (valor) {
          return valor.trim();
        });

        return {
          email: dados[0],
          senha: dados[1],
          auth: dados[2] && dados[2] != "0" ? dados[2] : null,
          proxy: dados[3] && dados[3] != "0" ? dados[3] : null,
          tipoAuth: dados[4] && dados[4] != "0" ? dados[4] : null,
          persona: dados[5] && dados[5] != "0" ? dados[5] : null
        };
      });

      return contasArray
    }

    private async vincularListaContas(contasArray: IListaContasVinculo[], navegadorVisivel: boolean = false, exibirLoading: boolean = false) {
      if (this.indiceAtualListaContas < contasArray.length) {
        if (exibirLoading) {
          App.Util.exibirLoadingTableContas()
        }
        var conta: IListaContasVinculo = contasArray[this.indiceAtualListaContas];
        console.log(`CONTA FILA ${this.indiceAtualListaContas}`, conta); // Substitua isso com o processamento real que você deseja fazer
        let proxy: any = null;

        try {
          // se conta.proxy for numerico é porque é um id de proxy, então busca o proxy
          if (conta.proxy && !isNaN(conta.proxy)) {
            proxy = await this.getProxyById(conta.proxy)
            if (proxy) {
              conta.proxy = proxy
            }
          }
        } catch (e) {
          console.log("ERRO BUSCA PROXY", e)
        }

        console.log("CONTA FILA APOS VERIFICAR PROXY", conta, proxy)

        this.comunicarIniciarConta(null, { email: conta.email, senha: conta.senha, auth: conta.auth, id: null, persona: conta.persona, tipoAuth: conta.tipoAuth }, navegadorVisivel, false, proxy)
        // Incrementa o índice para a próxima conta
        this.indiceAtualListaContas++;
      } else {
        console.log("Encerrou vinculo Listas", this.indiceAtualListaContas)
        App.Util.ocultarLoadingTableContas()
        // Para o intervalo quando todas as contas tiverem sido processadas
        clearInterval(this.intervaloVinculoListaContas);
      }
    }

    private iniciarSessaoConta(idConta: number = null, credenciais: IDadosCredenciais = null, navegadorVisivel: boolean = false, exibirLoading: boolean = false, mostrarTelaWebApp: boolean = false) {
      if (idConta && (!credenciais.email || !credenciais.senha)) {
        $(`#modalConfigCredenciais${idConta}`).modal('show')
        return
      }
      if (exibirLoading) {
        App.Util.exibirLoadingTableContas()
      }

      try {
        if (!idConta) {
          let arrLista: IListaContasVinculo[] = null;
          let elementoCredenciais = $(`#formConfiguracoesBotAddConta`);
          let listaContas = elementoCredenciais.find('textarea[name=lista]').val()
          if (listaContas) {
            arrLista = this.getListaContasVinculo(listaContas)
            console.log("LISTA", arrLista, this.configuracoesGeraisExecucao.intervalo_abertura_conta)
          }

          if (arrLista && arrLista.length) {
            this.indiceAtualListaContas = 0;
            // Define o intervalo de 30 segundos (30000 milissegundos)
            this.intervaloVinculoListaContas = setInterval(() => { this.vincularListaContas(arrLista, navegadorVisivel, exibirLoading) }, this.configuracoesGeraisExecucao.intervalo_abertura_conta ? (this.configuracoesGeraisExecucao.intervalo_abertura_conta * 1000) : 30000);
            this.vincularListaContas(arrLista, navegadorVisivel, exibirLoading)
            return
          }
        }
      } catch (e) {
        console.log("ERROR LISTA", e)
      }


      this.exibirLoadListConta(idConta, "Iniciando Conta...")

      this.comunicarIniciarConta(idConta, credenciais, navegadorVisivel, exibirLoading, null, mostrarTelaWebApp)
    }

    private comunicarIniciarConta(idConta: number = null, credenciais: IDadosCredenciais = null, navegadorVisivel: boolean = false, exibirLoading: boolean = false, proxy: IProxy = null, mostrarTelaWebApp: boolean = false) {
      console.log("CREDENCIAIS INICIAR CONTA", idConta, credenciais)
      var conta: IConta = { id: (!idConta ? 'vinculo' : idConta) as any, email: credenciais.email, senha: credenciais.senha, auth: credenciais.auth, tokenUser: App.Util.usuario.token, tipoAuth: credenciais.tipoAuth, userAgent: null, proxy: proxy ? proxy : this.getDadosProxyVinculo(idConta) }
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_INICIAR_CONTA, { conta: conta, navegadorVisivel: navegadorVisivel, proxy: proxy ? proxy : this.getDadosProxyVinculo(idConta), persona: this.getPersona(), abrirComBrowserRemoto: mostrarTelaWebApp, resolverBug: credenciais.resolverBug }, (response: IRespostaMensagem) => {
        this.ocultarLoadListConta(idConta)
        if (exibirLoading) {
          App.Util.ocultarLoadingTableContas()
        }
        if (response.status) {
          var contaIniciada: IConta = response.result.conta

          // conferindo proxy inicial para vincular junto a conta
          try {
            if (contaIniciada && !contaIniciada.proxy && (proxy || this.getDadosProxyVinculo(idConta))) {
              contaIniciada.proxy = proxy ? proxy : this.getDadosProxyVinculo(idConta)
            }
          } catch (e) { console.log("ERRO PREPARACAO VINCULO PROXY", e) }


          console.log("CONTA_INICIADA", contaIniciada)
          if (!$.isArray(this.arrayContas)) {
            this.arrayContas = []
            this.arrayContas.push(contaIniciada)
          }

          this.updateContaDatatable(contaIniciada);
          this.vincularContaEa(contaIniciada, response.result.recarregar, exibirLoading, idConta == null);
        }

        if (mostrarTelaWebApp) {
          console.log("comunicarIniciarConta", response)
        }
      });
    }

    private atualizarContaNoPlugin(dados: { id: number, semCache?: boolean }, callback: any = (response: IRespostaMensagem) => { }) {
      if (!this.conectado) {
        return
      }
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_ATUALIZAR_CONTA, dados, callback);
    }

    private vincularContaEa(conta: IConta, recarregar: boolean = false, ocultarLoading: boolean = false, vinculoInicial: boolean = false) {
      console.log("vincular conta", conta.dadosEa, App.Util.config.urlSalvarContaEa);
      var obj: IVinculoConta = {
        clube: conta.dadosEa.clubeName,
        coins: conta.dadosEa.coins,
        datan: null,
        email: conta.email,
        id: conta.dadosEa.idConta,
        usuario_id: conta.dadosEa.idUsuario,
        id_img_clube: conta.dadosEa.img,
        token: conta.dadosEa.token,
        ptf: conta.dadosEa.plataforma,
        eh_vinculo: vinculoInicial,
        id_proxy: conta.proxy ? conta.proxy.id : null,
        tipo: "pro",
      };

      this.ajax = new App.Ajax();
      this.ajax.postAcao(App.Util.config.urlSalvarContaEa, obj, (objVinculoConta: IVinculoConta) => {
        console.log("vincular conta REsp", vinculoInicial, objVinculoConta, obj);
        if (!App.Util.inArray(objVinculoConta.id.toString(), this.getIdsAllContas()) || recarregar) {
          if (ocultarLoading) {
            App.Util.ocultarModalPaginaCarregando()
          }

          toastr.success("O recarregamento da página é necessário para visualizar a conta na lista.", `Conta adicionada: ${objVinculoConta.clube}`)
          if (this.infoPlanoAtual.ehPlanoCloud) {
            swal.fire({
              icon: 'success',
              title: 'Conta adicionada: ' + objVinculoConta.clube,
              text: 'Essa tela será recarregada para finalizar o processo.'
            })
            setTimeout(() => {
              document.location.reload();
            }, 5000);
          }
        }
      }, obj, false);

    }

    private aoExcluirConta(e: JQueryEventObject) {
      var textoExclusao: string = this.infoPlanoAtual.ehPlanoCloud ? "Essa conta EA será removida e desvinculada do seu Plano FutSniperWeb e não será mais exibida em seu dashboard." : "Escolha entre excluir da máquina local ou excluír e desvinculada a conta do seu Plano FutSniperWeb.";
      var idConta = $(e.currentTarget).data('idContaEa');
      swal.fire({
        title: 'Deseja excluir a Conta?',
        text: textoExclusao,
        icon: 'warning',
        confirmButtonText: 'Excluir e desvincular',
        denyButtonText: `Excluir Local`,
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showDenyButton: this.infoPlanoAtual.ehPlanoCloud ? false : true,
        denyButtonColor: "#db7250",
        confirmButtonColor: "#db5250",
        allowOutsideClick: true,
        allowEscapeKey: true
      }).then((result: any) => {
        if (result.isConfirmed) {
          console.log("Excluir geral")
          this.excluirContaPlugin(idConta)
        } else if (result.isDenied) {
          console.log("Excluir local")
          this.excluirContaPlugin(idConta, true)
        }
      });
      return;
    }

    private excluirContaPlugin(idConta: number, excluirLocalApenas: boolean = false) {
      this.exibirLoadListConta(idConta, "Excluindo Conta...")
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_EXCLUIR_CONTA, { id: idConta }, (response: IRespostaMensagem) => {
        this.ocultarLoadListConta(idConta)
        App.Util.exibirModalPaginaCarregando()

        if (excluirLocalApenas) {
          swal.fire({
            icon: 'success',
            title: 'Conta excluída(LOCAL)!',
            text: "Conta excluida com sucesso em sua máquina local, reinicie seu plugin para que todas as alterações após exclusão sejam concluídas."
          })
          this.deleteContaDataTable(idConta)
          App.Util.ocultarModalPaginaCarregando()
        } else {
          this.ajax = new App.Ajax();
          this.ajax.postAcao(App.Util.config.urlSalvarContaEa, { id_conta_ea: idConta, agenda_ativa: false, excluir: true }, (resposta: any) => {

            try {
              let msgExclusao = this.infoPlanoAtual.ehPlanoCloud ? 'Seu Plugin será reiniciado, considere reativar suas tarefas automaticas caso estivesse ativa antes.' : 'Conta excluida com sucesso, reinicie seu plugin para que todas as alterações após exclusão sejam concluídas.';
              swal.fire({
                icon: 'success',
                title: 'Conta excluida!',
                text: msgExclusao
              })

              if (this.infoPlanoAtual.ehPlanoCloud) {
                $(".btn-reiniciar-plugin").click()
                setTimeout(() => {
                  this.elBtnAtualizar.click()
                }, 5000);
              }

              this.deleteContaDataTable(idConta)
            } catch (e) {
              console.log("Error processo exclusao conta", e);
            }

            App.Util.ocultarModalPaginaCarregando()
          })
        }
      });
    }

    private async atualizar(e: JQueryEventObject) {
      await this.sincronizarAtualizarDadosGeraisEntrePluginInterface();
    }

    private async salvarServidor(e: JQueryEventObject) {
      try {
        let urlSalvarServidor = $('.btn-add-servidor').data('url');
        let ip: string = $('.btn-add-servidor').data('ip').trim()
        let dadoosServidor: IServidor = { address: ip, nome: `SV_${ip}` }

        this.ajax.postAcao(urlSalvarServidor, dadoosServidor, async (resposta: { dadosEnviados: any, dadosRetornados: { dadosResposta: { perfil: { id: number, nome: string } } } }) => {
          swal.fire({
            icon: 'success',
            title: 'Servidor Salvo!',
            text: 'A seguir, essa página será atualizada.'
          })

        });
      } catch (e) {
        console.log("Error ao salvar servidor", e);
      }
    }

    private preencherCredenciais(conta: IConta) {
      let elementoCredenciais = $(`#formCredenciaisBot${conta.id}`);
      if (elementoCredenciais.length) {
        elementoCredenciais.find('input[name=email]').val(conta.email)
        elementoCredenciais.find('input[name=senha]').val(conta.senha)
        elementoCredenciais.find('input[name=auth]').val(conta.auth)
        elementoCredenciais.find('select[name=select_persona]').val(conta.persona)
      }
    }



    private preencherFormularioApiVendaCoins(form: any, configuracoesServicoVendaCoins: any) {
      for (const [prop, valor] of (Object as any).entries(configuracoesServicoVendaCoins)) {
        if (prop == "status") {
          form.find(`select[name=${prop}]`).val(valor)
        } else if (prop == "mydgn") {
          for (const [p, val] of (Object as any).entries(valor.credenciais)) {
            form.find(`input[name=${p}]`).val(val)
          }
        } else {
          form.find(`input[name=${prop}]`).val(valor)
          form.find(`select[name=${prop}]`).val(valor).trigger("change");
        }
      }
    }

    private atualizarViewCreditosConta(id: number, creditos: number) {
      this.updateCoinsContaDatatable(id, creditos)
    }
    private atualizarViewLucroConta(id: number, lucro: number) {
      this.updateLucroContaDatatable(id, lucro)
    }

    private atualizarStatusContaBanida(id: number) {
      let elementoConta = this.getElementoListConta(id);
      elementoConta.find('.label-conta-banida').show()
    }

    private atualizarStatusConta(request: { dadosEa: any, status: number, id: number, data: any, tarefa: any, navegador_status: boolean }) {
      if (!this.arrayContas.length) {
        return
      }

      var { status, id, data, tarefa, navegador_status } = request;
      var apenasAtualizacaoDeStatus = !(request.hasOwnProperty('dadosEa') && request.dadosEa.idConta)

      // if (apenasAtualizacaoDeStatus) {
      //   return
      // }

      this.atualizarEstadoModalSniper(id, status)
      this.updateStatusContaDatatable(id, status, data, tarefa, navegador_status)
    }

    private getStateViewAcoes(id: number, status: number): IViewAcoes {
      if (status == Util.STATUS_CONTA_ABERTA) {
        return {
          btnResolverCatptcha: false,
          btnAutenticar: false,
          btnParar: false,
          btnPararTarefa: false,
          btnAbrirSniper: true,
          btnPararVendaCoins: false
        }
      } else if (status == Util.STATUS_CONTA_EXECUCAO) {
        return {
          btnResolverCatptcha: false,
          btnAutenticar: false,
          btnParar: true,
          btnPararTarefa: true,
          btnAbrirSniper: true,
          btnPararVendaCoins: false
        }
      } else if (status == Util.STATUS_CONTA_VENDENDO_COINS) {
        return {
          btnResolverCatptcha: false,
          btnAutenticar: false,
          btnParar: false,
          btnPararTarefa: false,
          btnAbrirSniper: true,
          btnPararVendaCoins: true
        }
      } else if (status == Util.STATUS_CONTA_PARADA || status == Util.STATUS_ERROS_REPETIDOS_EM_SEQUENCIA) {
        return {
          btnResolverCatptcha: false,
          btnAutenticar: false,
          btnParar: false,
          btnPararTarefa: false,
          btnAbrirSniper: true,
          btnPararVendaCoins: false
        }
      } else if (status == Util.STATUS_POSSIVEL_SOFTBAN_BUSCA || status == Util.STATUS_POSSIVEL_SOFTBAN_COMPRA
        || status == Util.STATUS_POSSIVEL_SOFTBAN_ALTERNATIVO_1 || status == Util.STATUS_POSSIVEL_SOFTBAN_ALTERNATIVO_2) {
        return {
          btnResolverCatptcha: false,
          btnAutenticar: false,
          btnParar: false,
          btnPararTarefa: false,
          btnAbrirSniper: true,
          btnPararVendaCoins: false
        }
      } else {
        var ehCaptcha = status == Util.STATUS_CONTA_CAPTCHA || status == Util.STATUS_CONTA_CAPTCHA_FALHA_AUTOCAPTCHA;
        if (ehCaptcha) {
          // if (Util.loadCarregamentoId == id) {
          //   Util.ocultarModalPaginaCarregando();
          // }
          return {
            btnResolverCatptcha: true,
            btnAutenticar: false,
            btnParar: false,
            btnPararTarefa: false,
            btnAbrirSniper: false,
            btnPararVendaCoins: false
          }
        } else if (status == Util.STATUS_CONTA_BANIDA) {
          return {
            btnResolverCatptcha: false,
            btnAutenticar: false,
            btnParar: false,
            btnPararTarefa: false,
            btnAbrirSniper: false,
            btnPararVendaCoins: false
          }
        } else {
          return {
            btnResolverCatptcha: false,
            btnAutenticar: true,
            btnParar: false,
            btnPararTarefa: false,
            btnAbrirSniper: false,
            btnPararVendaCoins: false
          }
        }
      }
    }

    private async continuarinicializacaodashBoard() {
      if (this.inicializacaoDashBoardConcluida) {
        return
      }
      return new Promise(async (resolve: any, reject: any) => {
        this.iniciarConfiguracoesDeConta(null);
        this.obterConfiguracaoGeralAtualizada(() => {
          this.obterLogsDoDia();
          this.obterMediaDelay();
          this.atualizarContasVinculadasNoPlugin()
          this.inicializacaoDashBoardConcluida = true
          resolve()
        });

      })
    }

    private async obterViewPartialsContas(ids: number[]) {
      return new Promise(async (resolve: any, reject: any) => {
        try {
          this.ajax.get(App.Util.config.urlPartialsViewContas, { "ids": ids }, (dadosSucesso: IRespostaSucessoAjx) => {
            $("#modalsFormViewPartialsContas").append(dadosSucesso.dadosRetornados);
            for (let id of ids) {
              this.preencherCredenciais((this.arrayContas as any).find((conta: IConta) => conta.id == id))
            }
            resolve()
          }, null, null, false)
        } catch (error) {
          console.log("error obterViewPartialsContas", error)
          resolve()
        }
      })
    }

    private async carregarPartialsViewsContas() {
      let modalsFormViewPartialsContas = document.getElementById('modalsFormViewPartialsContas');
      if (modalsFormViewPartialsContas.childNodes.length) {
        return
      }

      return new Promise(async (resolve: any, reject: any) => {
        try {
          if (!this.ajax) {
            this.ajax = new Ajax();
          }
          $("#modalsFormViewPartialsContas").html('')
          let arrayIdsContasVinculadas = this.getIdsContasEaVinculadasPlugin()
          // console.log("arrayIdsContasVinculadas", arrayIdsContasVinculadas)
          // preciso a cada 10 ids chamar a view parcial
          let arrayIdsContasVinculadasChunks = _.chunk(arrayIdsContasVinculadas, 50)
          for await (let ids of arrayIdsContasVinculadasChunks) {
            await this.obterViewPartialsContas(ids)
          }

          resolve()
        } catch (e) {
          console.log("error carregarPartialsViewsContas", e)
          resolve()
        }

      })
    }

    private executarAcoesAoLigarDesligarPlugin(request: any) {
      var { status, tarefa_ligada, versao, ip } = request;
      this.pluginLigado = status;
      this.tarefaLigada = tarefa_ligada;
      this.versaoPlugin = versao;
      this.ipPlugin = ip;
      // console.log("PLUGIN LIGADO", this.pluginLigado, this.versaoPlugin, App.Util.config.versaoAtualPluginVersaoPro)
      if (this.pluginLigado) {
        this.sincronizarAtualizarDadosGeraisEntrePluginInterface();
      }

      try {
        if (this.versaoPlugin) {
          $(".plugin-versao").html(this.versaoPlugin.toString());
        }
      } catch (e) { }

      if (this.versaoPlugin && App.Util.config.versaoAtualPluginVersaoPro && App.Util.config.avisarSobreAtualizacaoPlugin) {
        try {
          // console.log({ versaoPlugin: Util.parseVersion(this.versaoPlugin), versaoAtual: Util.parseVersion(App.Util.config.versaoAtualPluginVersaoPro) })
          if (Util.parseVersion(this.versaoPlugin) < Util.parseVersion(App.Util.config.versaoAtualPluginVersaoPro)) {
            if (App.Util.config.pluginFazerDownload) {
              swal.fire({
                icon: 'warning',
                title: "Plugin desatualizado!",
                text: "Existe uma versão mais nova do Plugin FutSniperWeb PRO, é importante que você desligue-o, faça download e instale a nova versão " + App.Util.config.versaoAtualPluginVersaoPro,
                type: "info",
                showCancelButton: false,
                confirmButtonText: "Download",
                confirmButtonColor: '#3740FF'
              }).then(function (result: any) {
                if (result.hasOwnProperty('value') && result.value) {
                  window.open(
                    App.Util.config.urlPluginFswPro,
                    '_blank'
                  );
                  return;
                }
              });
            } else {
              swal.fire({
                icon: 'warning',
                title: "Plugin desatualizado!",
                text: "Atualize seu plugin para a nova versão " + App.Util.config.versaoAtualPluginVersaoPro + ", Reinicie o Plugin no menu superior(Reiniciar Plugin) do dashboard ou clique em atualizar agora.",
                type: "info",
                showCancelButton: false,
                confirmButtonText: "Atualizar Agora",
                confirmButtonColor: '#2dce89'
              }).then((result: any) => {
                if (result.hasOwnProperty('value') && result.value) {
                  $(".btn-reiniciar-plugin").click()
                  return;
                }
              });
            }
          }
        } catch (e) {
          console.log("error conferencia versao plugin", e)
        }
      }

      $('input[name=tarefa_ligada]').prop("checked", this.tarefaLigada)

      if (request && request.ip && $('.btn-add-servidor') && $('.btn-add-servidor').data('ips')) {
        let ipsServidores = JSON.parse(JSON.stringify($('.btn-add-servidor').data('ips')))
        let objIps = JSON.parse(JSON.stringify($('.btn-add-servidor').data('objips')))

        $('.btn-add-servidor').attr('data-ip', request.ip)
        $('.btn-add-servidor').prop('data-ip', request.ip)
        // console.log("REQ SERVER", request, ipsServidores, objIps);

        if (!ipsServidores.includes(request.ip.toString())) {
          // console.log("SERVER NAO SALVO")
          $('.btn-add-servidor .text-servidor').html('<i class="fas fa-save"></i>&nbsp;Salvar Servidor')
          $('.btn-add-servidor .text-ip').html(request.ip)
          $('.btn-add-servidor').show()
          $('.info-servidor').hide()
        } else {
          // console.log("SERVER SALVO", `.` + `linha-servidor${request.ip}`.replace(/\./g, ''))
          $('.info-servidor .text-servidor').html(objIps[request.ip])
          $('.info-servidor .text-ip').html(request.ip)
          $('.info-servidor').show()
          $('.btn-add-servidor').hide()
          $(`.` + `linha-servidor${request.ip}`.replace(/\./g, '')).css('background-color', '#c4ffe6')
        }
      } else {
        $('.btn-add-servidor').hide()
        $('.info-servidor').hide()
      }
    }

    private informarBaseDadosCorrompida(request: { status: boolean, caminho: string }) {
      if (request.status) {
        swal.fire({
          icon: 'warning',
          title: 'Base de dados Corrompida foi Restaurada!',
          text: `Isso pode acontecer quando o seu computador é desligado de forma repentina/incorreta, o último backup encontrado foi restaurado, os backups automáticos são executados aproximadamente de 5 em 5 minutos.`
        })

      } else {
        swal.fire({
          icon: 'warning',
          title: 'Base de dados Corrompida!',
          text: `Isso pode acontecer quando o seu computador é desligado de forma repentina/incorreta, não encontramos nenhum backup anterior para restauração, o arquivo corrompido deve ser excluido no caminho informado a seguir e o plugin deve ser reiniciado. Caminho do arquivo: ${request.caminho}`
        })
      }
    }

    private exibirPlanoExpirado(request: any) {
      swal.fire({
        icon: 'warning',
        title: 'Plano Expirado',
        text: 'Seu Plano expirou, recarregue a pagina para ativar um novo Plano'
      })

      setTimeout(() => {
        document.location.reload();
      }, 20000);
    }

    private exibirViewConexao() {
      if (this.conectado) {
        $(".btn-conectado").show();
        $(".btn-desconectado").hide();
        $("input[name=agenda_ativa]").prop('disabled', false);
        this.quantidadeFalhaConexaoPlugin = 0
      } else {
        $(".btn-conectado").hide();
        $(".btn-desconectado").show();
        this.desabilitarInfoAgendamento();
        $("input[name=agenda_ativa]").prop('disabled', true);
        $(".plugin-versao").html('');
      }
    }

    private exibirFalhaNaAutenticacao(conta: IConta) {
      Util.ocultarModalPaginaCarregando();
      swal.fire({
        icon: 'error',
        title: 'Falha na Autenticação: ' + conta.email,
        text: 'Email ou senha inválido!'
      })
    }

    private atualizarCreditos(id: number, creditos: number, lucro: number = null) {
      this.atualizarViewCreditosConta(id, creditos)
      if (lucro) {
        this.atualizarViewLucroConta(id, lucro)
      }
    }

    public responderServidor(status: boolean, request: any, callback: any = null) {
      return callback && callback({ status: status, result: request });
    }

    private atualizarViewInfoAgendamento(idConta: number, programacao: any[] = []) {
      if (programacao.length) {
        this.updateAgendaContaDatatable(idConta, programacao)
      }
    }

    private desabilitarInfoAgendamento() {
      $('.btn-info-agenda').hide();
      $('.btn-info-agenda').attr('data-content', '');
    }

    private aoClicarAgendamentoSemFiltro(e: JQueryEventObject) {
      this.exibirAlertaNecessarioCadastrarFiltro();
    }
    private aoClicarAgendamentoExigido(e: JQueryEventObject) {
      this.exibirAlertaNecessarioCadastrarUmaAgenda();
    }

    public exibirAlertaNecessarioCadastrarUmaAgenda(): void {
      this.alertPrecisaAddConta = swal.fire({
        title: 'Adicione um agendamento!',
        confirmButtonColor: "#f9ca3b",
        text: 'Antes de criar um perfil é necessário que você tenha cadastrado pelo menos 1 agendamento, clique na aba "Agendamentos" para cadastrar um agendamento',
        imageUrl: '/img/gifs/add-filtro.png',
        imageWidth: 405,
        imageAlt: 'Cadastre Agendamento',
        allowOutsideClick: false,
        allowEscapeKey: false
      })
    }
    public exibirAlertaNecessarioCadastrarFiltro(): void {
      this.alertPrecisaAddConta = swal.fire({
        title: 'Crie um filtro!',
        confirmButtonColor: "#f9ca3b",
        text: 'Antes de agendar uma tarefa é necessário que você tenha cadastrado pelo menos 1 filtro, clique na aba "Filtros" para cadastrar um filtro',
        imageUrl: '/img/gifs/add-filtro.png',
        imageWidth: 405,
        imageAlt: 'Cadastre filtro',
        allowOutsideClick: false,
        allowEscapeKey: false
      })
    }

    private obterTempoExecucaoAposSalvarAgendamento(index: number, dadosRetornados: IRespostaDadosRetornadosAjaxPostAcao): { tempo: number, info: string } {
      let objInfo = { tempo: 0, info: "" }
      if (dadosRetornados.hasOwnProperty("dadosResposta") && dadosRetornados.dadosResposta.dados && dadosRetornados.dadosResposta.dados.length) {
        let agendamentos = dadosRetornados.dadosResposta.dados
        if (agendamentos.length) {
          let objAgendamento = agendamentos[index];
          if (objAgendamento && objAgendamento.tarefa && objAgendamento.tarefa.data) {
            objInfo.tempo = Util.parseMilisegundosParaMinutos(objAgendamento.tarefa.data.tempo)
            objInfo.info = Util.getDescricaoHumanaMilissegundos(objAgendamento.tarefa.data.tempo)
          }
        }

        return objInfo
      }
    }

    private obterInfoNomeFiltrosSalvosAposSalvarAgendamento(index: number, dadosRetornados: IRespostaDadosRetornadosAjaxPostAcao): string {
      let infoNamesFiltros = ""
      if (dadosRetornados.hasOwnProperty("dadosResposta") && dadosRetornados.dadosResposta.dados && dadosRetornados.dadosResposta.dados.length) {
        let agendamentos = dadosRetornados.dadosResposta.dados
        if (agendamentos.length) {
          let objAgendamento = agendamentos[index];
          if (objAgendamento && objAgendamento.tarefa && objAgendamento.tarefa.data) {
            let filtros = objAgendamento.tarefa.data.filtros
            if (filtros && filtros.length) {
              infoNamesFiltros = _.pluck(filtros, 'nome').join(', ')
            }
          }
        }

        return infoNamesFiltros
      }
    }

    private preencherItemAgendamento(modal: JQuery, formConta: JQuery, objAgendamento: IObjAgendamento, agendamentoConfig: IAgendamentoConfiguracao, index: number): void {
      // console.log("PREENCHER::", index, agendamentoConfig)
      if (index > 0) {
        modal.find(`#add-more${objAgendamento.id}`).click();
      }

      var elementoContainer: JQuery = formConta.find('#containerItem' + index);
      elementoContainer.find("select[name='dia[]']").val(agendamentoConfig.dia);
      elementoContainer.find("input[name='hora[]']").val(agendamentoConfig.hora);

      var pilotoAutomatico = !agendamentoConfig.tarefa.data || (agendamentoConfig.tarefa.data.filtros && !agendamentoConfig.tarefa.data.filtros.length)
      elementoContainer.find('input[name=piloto_automatico]').prop("checked", pilotoAutomatico).trigger("change");

      let temFiltros: boolean = false;
      let infoNamesFiltros: string = "";
      let infoExecucao: string = "";

      var agendamento: IFuncaoSniperOptions = agendamentoConfig.tarefa.data;
      if (!pilotoAutomatico) {
        var selectVelocidade: JQuery = elementoContainer.find("select[name='velocidade[]']");
        var selectDescanso: JQuery = elementoContainer.find("select[name='descanso[]']");
        var selectIntervalo: JQuery = elementoContainer.find("select[name='intervalo[]']");
        var selectTempo: JQuery = elementoContainer.find("select[name='tempo[]']");

        this.objSelect2.setSelectTag(selectVelocidade, { id: agendamento.velocidade.toString(), text: (agendamento.velocidade.toString() + this.selectTextMilisegundosComplementoDefault) })
        this.objSelect2.setSelectTag(selectDescanso, { id: agendamento.descanso.toString(), text: (agendamento.descanso.toString() + this.selectTextMilisegundosComplementoDefault) })
        this.objSelect2.setSelectTag(selectIntervalo, { id: agendamento.intervalo.toString(), text: (agendamento.intervalo.toString() + this.selectTextMilisegundosComplementoDefault) })
        this.objSelect2.setSelectTag(selectTempo, { id: agendamento.tempo.toString(), text: (agendamento.tempo.toString() + this.selectTextMilisegundosComplementoDefault) })

        var filtrosSelect: string[] = [];
        elementoContainer.find("input[name='porcentagem_eficacia[]']").val(agendamento.porcentagem_eficacia);
        elementoContainer.find("input[name='tempo_minimo_eficacia[]']").val(agendamento.tempo_minimo_eficacia);
        elementoContainer.find("input[name='limite_compra[]']").val(agendamento.limite_compra);

        temFiltros = agendamento.filtros && agendamento.filtros.length > 0;

        if (temFiltros) {
          infoNamesFiltros = _.pluck(agendamento.filtros, 'nome').join(', ')
          // console.log("FILTROS", infoNamesFiltros)
          $.each(agendamento.filtros, function (index2: any, filtro: IFiltroOptions) {
            filtrosSelect.push(filtro.id);
          });
        }

        infoExecucao = Util.getDescricaoHumanaMilissegundos(agendamento.tempo)


        // console.log("filtrosSelect", formConta, index, filtrosSelect)

        formConta.find('select.select2').eq(index).val(filtrosSelect).trigger('change').trigger('select2:select');
      } else {
        var selectTempo: JQuery = elementoContainer.find("select[name='tempo[]']");
        this.objSelect2.setSelectTag(selectTempo, { id: agendamento.tempo.toString(), text: (agendamento.tempo.toString() + this.selectTextMilisegundosComplementoDefault) })
        elementoContainer.find("input[name='limite_compra[]']").val(agendamento.limite_compra);
      }

      this.atualizarViewContainerAgendamento(elementoContainer, agendamentoConfig, temFiltros, infoNamesFiltros, infoExecucao)

    }
    private preencherAgendamentos(formConta: JQuery, modal: JQuery, objAgendamento: IObjAgendamento): void {
      formConta.find('input[name=id]').val(objAgendamento.id);
      formConta.find('input[name=nome]').val(objAgendamento.nome);

      var tempoTotalExecucao = objAgendamento.dados.reduce((accumulator, object: IAgendamentoConfiguracao) => {
        return accumulator + (object.tarefa.data && object.tarefa.data.tempo ? Util.parseMilisegundosParaMinutos(object.tarefa.data.tempo) : 0);
      }, 0);
      this.atualizarTempoTotalExecucao(formConta, tempoTotalExecucao)
      // console.log("tempoTotalExecucao::", tempoTotalExecucao)
      $.each(objAgendamento.dados, (index: any, agendamentoConfig: IAgendamentoConfiguracao) => {
        this.preencherItemAgendamento(modal, formConta, objAgendamento, agendamentoConfig, index)
      });
    }

    private preencherFormPerfil(formConta: JQuery, modal: JQuery, objPerfil: IPerfil): void {
      formConta.find('input[name=id]').val(objPerfil.id);
      formConta.find('input[name=nome]').val(objPerfil.nome);
      Util.preencherFormulario(formConta, objPerfil.dados)

      formConta.find('input[name=piloto_automatico]').prop("checked", objPerfil.dados.piloto_automatico).trigger("change");

      var selectVelocidade: JQuery = formConta.find("select[name='velocidade']");
      var selectDescanso: JQuery = formConta.find("select[name='descanso']");
      var selectIntervalo: JQuery = formConta.find("select[name='intervalo']");
      var selectTempo: JQuery = formConta.find("select[name='tempo']");
      // console.log("PREENCHENDO PERFIL::", objPerfil.dados.velocidade, objPerfil.dados)

      this.objSelect2.setSelectTag(selectVelocidade, { id: objPerfil.dados.velocidade.toString(), text: (objPerfil.dados.velocidade.toString() + this.selectTextMilisegundosComplementoDefault) })
      this.objSelect2.setSelectTag(selectDescanso, { id: objPerfil.dados.descanso.toString(), text: (objPerfil.dados.descanso.toString() + this.selectTextMilisegundosComplementoDefault) })
      this.objSelect2.setSelectTag(selectIntervalo, { id: objPerfil.dados.intervalo.toString(), text: (objPerfil.dados.intervalo.toString() + this.selectTextMilisegundosComplementoDefault) })
      this.objSelect2.setSelectTag(selectTempo, { id: objPerfil.dados.tempo.toString(), text: (objPerfil.dados.tempo.toString() + this.selectTextMilisegundosComplementoDefault) })

      // formConta.find("input[name='porcentagem_eficacia[]']").val(objPerfil.dados.porcentagem_eficacia);
      // formConta.find("input[name='tempo_minimo_eficacia[]']").val(objPerfil.dados.tempo_minimo_eficacia);
      formConta.find("input[name='limite_compra']").val(objPerfil.dados.limite_compra);


      if (objPerfil.dados.exceto_dia && objPerfil.dados.exceto_dia.length > 0) {
        formConta.find("select[name='exceto_dia[]']").val(objPerfil.dados.exceto_dia).trigger('change').trigger('select2:select')
      }
      if (objPerfil.dados.filtros && objPerfil.dados.filtros.length > 0) {
        formConta.find("select[name='filtros[]']").val(_.pluck(objPerfil.dados.filtros, 'id')).trigger('change').trigger('select2:select')
      }
    }

    private preencherFormApiVendaCoins(formConta: JQuery, modal: JQuery, objApiVendaCoins: IObjAgendamento): void {
      formConta.find('input[name=id]').val(objApiVendaCoins.id);
      formConta.find('input[name=nome]').val(objApiVendaCoins.nome);
      this.preencherFormularioApiVendaCoins(formConta, objApiVendaCoins.dados)
    }


    private atualizarListaPerfil(id: number, objRegistro: { nome: string, dados: any }) {
      if (id) {
        let listRegistro = $('.list-perfil')
        listRegistro.find(`.nome-perfil${id}`).html(objRegistro.nome)
        listRegistro.find(`.edit-perfil${id}`).data('dados', objRegistro.dados);
        listRegistro.find(`.edit-perfil${id}`).data('nome', objRegistro.nome);
      } else {
        document.location.reload();
      }
    }
    private atualizarListaApiVendaCoins(id: number, objRegistro: { nome: string, dados: any }) {
      if (id) {
        let listRegistro = $('.list-api-venda-coins')
        listRegistro.find(`.nome-api-venda-coins${id}`).html(objRegistro.nome)
        listRegistro.find(`.edit-api-venda-coins${id}`).data('dados', objRegistro.dados);
        listRegistro.find(`.edit-api-venda-coins${id}`).data('nome', objRegistro.nome);
      } else {
        document.location.reload();
      }
    }

    private atualizarListaAgendamento(id: number, objAgendamento: { nome: string, dados: any }) {
      if (id) {
        var tempoTotalExecucao = objAgendamento.dados.reduce((accumulator: any, object: IAgendamentoConfiguracao) => {
          return accumulator + Util.parseMilisegundosParaMinutos(object.tarefa.data.tempo);
        }, 0);

        let mili = Util.parseMinutosParaMilisegundos(tempoTotalExecucao)
        let listAgendamento = $('.list-agendameto')
        listAgendamento.find(`.nome-agendamento${id}`).html(objAgendamento.nome)
        listAgendamento.find(`.tempo-agendamento${id}`).html(Util.getDescricaoHumanaMilissegundos(mili))
        listAgendamento.find(`.edit-agendamento${id}`).data('dados', objAgendamento.dados);
        listAgendamento.find(`.edit-agendamento${id}`).data('nome', objAgendamento.nome);
      } else {
        document.location.reload();
      }
    }

    private atualizarTempoTotalExecucao(formAgendamento: JQuery, tempoTotal: any) {
      let milis = Util.parseMinutosParaMilisegundos(tempoTotal)
      formAgendamento.find('.info-tempo-total-execucao').html(Util.getDescricaoHumanaMilissegundos(milis));
    }

    private atualizarViewContainerAgendamento(elementoContainer: JQuery, agendamentoConfig: IAgendamentoConfiguracao = null, containerSalvo: boolean = true, infoNamesFiltros: string = "", infoTempoExecucao: string = "") {
      if (agendamentoConfig) {
        elementoContainer.find('.info-quando').html(App.Util.ARRAY_DIAS_AGENDAMENTO[parseInt(agendamentoConfig.dia)]);
        elementoContainer.find('.info-hora').html(agendamentoConfig.hora);
      }

      elementoContainer.find('.info-names-filtros').html(infoNamesFiltros);
      elementoContainer.find('.info-tempo-execucao').html(infoTempoExecucao);

      if (containerSalvo) {
        let strInfoFiltros = `&nbsp;<span class="badge badge-pill badge-success agenda-salva">salvo</span>`
        elementoContainer.find('.info-filtros').html(strInfoFiltros);
      }
    }

    private obterObjetoAgendamento(form: JQuery, dadosResponse: any = null): any[] {
      var arrayElementosAdd = form.find('.container-item-sch');
      var dadosEnviados: any = form.serializeObject();

      var agendamentos: any[] = [];

      $.each(arrayElementosAdd, (index: any, containerItem: any) => {
        var pilotoAutomatico = $(containerItem).find("input[name=piloto_automatico]").is(':checked')
        var arrFiltros = dadosEnviados.hasOwnProperty(`filtro${index}`) ? dadosEnviados[`filtro${index}`] : []

        var objAgendamentoConfiguracao: IAgendamentoConfiguracao = {};

        var objDataTarefa: IFuncaoSniperOptions = {};
        objAgendamentoConfiguracao.dia = dadosEnviados.dia[index];
        objAgendamentoConfiguracao.hora = dadosEnviados.hora[index];

        if (!pilotoAutomatico) {
          objDataTarefa.porcentagem_eficacia = dadosEnviados.hasOwnProperty('porcentagem_eficacia') ? dadosEnviados.porcentagem_eficacia[index] : 10;
          objDataTarefa.tempo_minimo_eficacia = dadosEnviados.hasOwnProperty('tempo_minimo_eficacia') ? dadosEnviados.tempo_minimo_eficacia[index] : 10;
          objDataTarefa.descanso = dadosEnviados.descanso[index];
          objDataTarefa.intervalo = dadosEnviados.intervalo[index];
          objDataTarefa.limite_compra = dadosEnviados.limite_compra[index];
          objDataTarefa.tempo = dadosEnviados.tempo[index];
          objDataTarefa.velocidade = dadosEnviados.velocidade[index];
          objDataTarefa.filtros = [];

          $.each(arrFiltros, (index2: any, filtroId: any) => {
            objDataTarefa.filtros.push(filtroId);
          });

          objAgendamentoConfiguracao.tarefa = {};
          objAgendamentoConfiguracao.tarefa.id = dadosEnviados.id_tarefa
          objAgendamentoConfiguracao.tarefa.data = objDataTarefa
        } else {
          objDataTarefa.tempo = dadosEnviados.tempo[index];
          objDataTarefa.limite_compra = dadosEnviados.limite_compra[index];
          objDataTarefa.filtros = [];

          objAgendamentoConfiguracao.tarefa = {};
          objAgendamentoConfiguracao.tarefa.id = dadosEnviados.id_tarefa
          objAgendamentoConfiguracao.tarefa.data = objDataTarefa
        }

        agendamentos.push(objAgendamentoConfiguracao)
      });

      return agendamentos;
    }

    private obterLogsDoDia() {
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_GET_LOGS, {}, (response: IRespostaMensagem) => {
        if (response.status) {
          this.carregarTabelaLogs(response.result);
        }
      });
    }

    private carregarTabelaLogs(dataLog: IDataLog[] | IDataLog) {

      if ($.isArray(dataLog)) {
        dataLog = (dataLog as any).filter((log: IDataLog) => {
          return !_.contains([Util.EVENTO_TIPO_LUCRO_FILTRO_ESTIMADO, Util.EVENTO_WEBAPP_COMPLETOU_CARREGAMENTO, Util.EVENTO_CONTA_FILTROS_NAO_ATUALIZADOS, Util.EVENTO_CONTA_PERFIL_DEFAULT], log.tipo)
        })
      }

      if (this.objDataTableLogs instanceof $.fn.dataTable.Api) {
        if ($.isArray(dataLog)) {
          this.objDataTableLogs.clear().draw();
          this.objDataTableLogs.rows.add(dataLog);
        } else {
          try {
            if ((dataLog as any).tipo != Util.EVENTO_TIPO_LUCRO_FILTRO_ESTIMADO) {
              this.objDataTableLogs.row.add(dataLog);
            }
          } catch (error) {
            this.objDataTableLogs.row.add(dataLog);
          }
        }
        this.objDataTableLogs.columns.adjust().draw();
      } else {
        this.objDataTableLogs = this.elDataTableLogs.DataTable({
          data: dataLog,
          order: [[3, "desc"]],
          lengthChange: false,
          pageLength: 100,
          dom: "Bfrtip",
          buttons: {
            buttons: [
              { extend: 'copy', className: 'btn-link' },
              { extend: 'print', className: 'btn-link' }
            ]
          },
          language: {
            paginate: {
              previous: "<i class='fas fa-angle-left'>",
              next: "<i class='fas fa-angle-right'>"
            }
          },
          columnDefs: [
            {
              targets: 0,
              className: "name",
              render: (data: any, tipo: any, obj: IDataLog, meta: any) => {
                try {
                  data = `<div class="media align-items-center">
                          <a href="#" class="avatar rounded-circle mr-3" style="width: 20px;height: 20px;">
                            <img alt="Clube Name" src="/favicon.ico">
                          </a>
                          <div class="media-body">
                            <span class="name mb-0 text-sm">Plugin</span>
                          </div>
                         </div>`;
                  var conta: IConta = App.Util.getItemArrayById(this.arrayContas, obj.idConta);
                  if (conta && conta.hasOwnProperty('dadosEa') && conta.dadosEa) {
                    if (!this.configuracoesGeraisExecucao.exibir_escudo_clube && !this.cacheInfoContas[conta.id]) {
                      this.cacheInfoContas[conta.id] = {}
                      this.cacheInfoContas[conta.id].corAvatar = App.Util.obterCorRandomica()
                      this.cacheInfoContas[conta.id].nomeAvatar = App.Util.getNomeAvatar(conta.dadosEa.clubeName)
                    }

                    let viewImageConta = this.configuracoesGeraisExecucao.exibir_escudo_clube
                      ? `<div class="media align-items-center">
                          <a href="#" class="avatar rounded-circle mr-3" style="width: 20px;height: 20px;">
                            <img alt="Clube Name" src="${conta.dadosEa.img}">
                          </a>
                          <div class="media-body">
                            <span class="name mb-0 text-sm">${conta.dadosEa.clubeName}</span>
                          </div>
                         </div>`
                      : `<div class="media align-items-center">
                          <a href="#" class="avatar rounded-circle mr-3" style="width: 20px;height: 20px;background-color:${this.cacheInfoContas[conta.id].corAvatar}">${this.cacheInfoContas[conta.id].nomeAvatar}</a>
                          <div class="media-body">
                            <span class="name mb-0 text-sm">${conta.dadosEa.clubeName}</span>
                          </div>
                         </div>`

                    data = viewImageConta
                  } else if (conta) {
                    data = '<div class="media align-items-center">\n\
                                            <a href="#" class="avatar rounded-circle mr-3" style="width: 20px;height: 20px;">\n\
                                            <img alt="Clube Name" src="/img/escudo-default.png">\n\
                                            </a><div class="media-body">\n\
                                            <span class="name mb-0 text-sm">Account ' + conta.id + '</span>\n\
                                            </div>\n\
                                            </div>';
                  }
                } catch (e) { }

                return data;
              }
            },
            {
              targets: 1,
              className: "tipo",
              render: function (data: any, tipo: any, obj: IDataLog, meta: any) {
                try {
                  var dadosLog = Util.getObjStatusViewLog(obj);
                  data = '<span class="badge badge-' + dadosLog.class + '">' + dadosLog.texto + '</span>'
                  return data;
                } catch (e) {
                  return '-'
                }
              }
            },
            {
              targets: 2,
              className: "text-muted info",
              render: function (data: any, tipo: any, obj: IDataLog, meta: any) {
                return Util.getObjInfoViewLog(obj);
              }
            },
            {
              targets: 3,
              className: "date",
              render: function (data: any, tipo: any, obj: IDataLog, meta: any) {
                data = '<div class="text-right">\n\
                                        <small class="text-muted">'+ obj.createdAt + '&nbsp;&nbsp;<i class="fas fa-clock mr-1"></i></small>\n\
                                        </div>';
                return data;
              }
            }
          ],
        });
      }
    }


    private atualizarViewFuncionamentoAtual(id: number, status: number, navegador_status: boolean) {
      let elementoCronometro: string = `.cronometro${id} .values`
      if (status != Util.STATUS_CONTA_EXECUCAO) {
        // Util.pararCronometroMult(App.Business.cronometros[id]);
        return;
      }

      var conta: IConta = App.Util.getItemArrayById(this.arrayContas, id);
      if (conta.execucao && conta.execucao.funcionamentoAtual) {
        // if (this.configuracoesGeraisExecucao.exibir_cronometro) {
        //   App.Business.cronometros[id] = Util.iniciarCronometroMult(App.Business.cronometros[id], elementoCronometro, conta.execucao.funcionamentoAtual.tempo / 1000);
        // }
      } else {
        Util.pararCronometroMult(App.Business.cronometros[id]);

        if (status == Util.STATUS_CONTA_EXECUCAO) {
          this.atualizarExecucaoConta(id)
        }
      }

      // se existir elemento com classe conta-navegador-aberto remover o elemento
      if (!navegador_status && $(`.conta-navegador-aberto${id}`).length) {
        $(`.conta-navegador-aberto${id}`).remove();
      }
    }

    private atualizarEstadoModalSniper(idConta: number, status: number) {
      if (this.idContaSniperModalAberto == idConta) {
        this.updateLogsAcoesContaModalSniper(idConta);
        $('.btn-snipar-pro').prop("disabled", status == Util.STATUS_CONTA_EXECUCAO);
        $('.btn-snipar-pro').html(status == Util.STATUS_CONTA_EXECUCAO ? "Snipando..." : "Snipar")
        if (status == Util.STATUS_CONTA_EXECUCAO) {
          $('.conteudo-loading-sniper-pro').modal('show')
          App.Util.reinicializarTentativas($('.conteudo-loading-sniper-pro').find('.tentativas'))
          App.Util.reinicializarQuantidadeComprasModalSniper()
        } else {
          $('.conteudo-loading-sniper-pro').modal('hide')
        }
      }
    }

    private updateLogsAcoesContaModalSniper(idConta: number) {
      if ($("#modalSniperPro .espaco-log-acoes").find(".conteudo-log-acoes-sniper-pro").length) {
        $("#modalSniperPro .espaco-log-acoes").find(".conteudo-log-acoes-sniper-pro").remove()
      }
      $("#modalSniperPro .espaco-log-acoes").append($(`#conteudoLogAcoesSniperPro${idConta}`).clone());

      $('.btn-snipar-pro').on("click", (e) => { this.iniciarSniper(e) });
      $('.btn-parar-tarefa-sniper').on("click", (e) => { this.pararTarefaByModal(e) });
      $(".limpar-log-pro").on('click', (e) => { this.aoLimparLog(e); });

    }
    private aoAbrirSniper(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      this.idContaSniperModalAberto = idConta;
      var conta: IConta = App.Util.getItemArrayById(this.arrayContas, idConta);


      let elementoRowConta: any = this.getElementoListConta(idConta)
      $('.espaco-nome-conta').html(elementoRowConta.find('td.info-conta').clone())


      this.ativarInteracaoSniper(idConta)
      this.preencherCamposModalSniperTarefaAtual(idConta, conta.status == Util.STATUS_CONTA_EXECUCAO && this.tarefasSniperContas[idConta] && this.tarefasSniperContas[idConta].hasOwnProperty("data") ? this.tarefasSniperContas[idConta].data.filtros[0] : null)
      this.updateLogsAcoesContaModalSniper(idConta);

      if (conta.status == Util.STATUS_CONTA_EXECUCAO) {
        $('.conteudo-loading-sniper-pro').modal('show')
        $('.btn-snipar-pro').prop("disabled", true);
        $('.btn-snipar-pro').html('Snipando...')
      } else {
        $('.btn-snipar-pro').prop("disabled", false);
        $('.btn-snipar-pro').html('Snipar')
        $('.conteudo-loading-sniper-pro').modal('hide')
      }
      $('#modalSniperPro').find(`input[name=id]`).val(idConta);
      $('#modalSniperPro').modal('show')
    }

    private iniciarSniper(e: JQueryEventObject) {
      var estimar = $(e.currentTarget).data('estimar')
      var parent = $(e.target).parents('.parent-sniper-pro');
      var form = parent.find('form')
      var tarefaSniper: ITarefaSniper = this.obterObjetoFormSniper($(form))
      var idConta = this.idContaSniperModalAberto
      if (!tarefaSniper) {
        return
      }

      $('#modalSniperPro').modal('hide')

      this.exibirLoadListConta(idConta, "Aguarde...")
      if (Boolean(estimar)) {
        tarefaSniper.id = Util.TAREFA_ESTIMAR_LUCRO_FILTRO
      } else {
        this.tarefasSniperContas[idConta] = tarefaSniper;
      }

      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_SNIPAR, { id: idConta, tarefa: tarefaSniper }, (response: IRespostaMensagem) => {
        let conta: IConta = response.result.conta
        if (response.status) {
          $(`#abrirSniper${conta.id}`).trigger("click")
        }
      });
    }

    private obterObjetoFormSniper(form: JQuery): ITarefaSniper {
      this.ajax = new App.Ajax();
      var dadosForm: IFormDadosSniperPro = this.ajax.convertFormToJSON(form);
      // console.log("DATA FORM", dadosForm);

      if (App.Util.validarFiltroSniper(dadosForm)) {
        var tarefa: ITarefaSniper = {};
        if (dadosForm.piloto_automatico) {
          tarefa.id = App.Util.TAREFA_SNIPER
          tarefa.data = null
          return tarefa
        }


        tarefa.id = App.Util.TAREFA_SNIPER
        tarefa.data = {}
        tarefa.data.descanso = dadosForm.descanso
        tarefa.data.intervalo = dadosForm.intervalo
        tarefa.data.limite_compra = dadosForm.limite_compra
        tarefa.data.quantidade = dadosForm.limite_compra
        tarefa.data.tempo = dadosForm.tempo
        tarefa.data.velocidade = dadosForm.velocidade
        tarefa.data.tempo_minimo_eficacia = 10
        tarefa.data.porcentagem_eficacia = 10
        tarefa.data.filtros = []
        tarefa.data.filtros.push(this.obterObjetoFormFiltro(dadosForm))
        return tarefa
      }

      return null;
    }

    private obterObjetoFormFiltro(dadosForm: IFormDadosSniperPro): IFiltroOptions {
      return {
        data: {
          maskedDefId: !App.Util.empty(dadosForm.maskedDefId) ? dadosForm.maskedDefId : null,
          minBid: !App.Util.empty(dadosForm.minBid) ? dadosForm.minBid : null,
          maxBid: !App.Util.empty(dadosForm.maxBid) ? dadosForm.maxBid : null,
          quality: !App.Util.empty(dadosForm.quality) ? dadosForm.quality : null,
          icontraits: !App.Util.empty(dadosForm.icontraits) ? dadosForm.icontraits : null,
          rarity: !App.Util.empty(dadosForm.rarity) ? dadosForm.rarity : null,
          position: !App.Util.empty(dadosForm.position) ? dadosForm.position : null,
          chemical: !App.Util.empty(dadosForm.chemical) ? dadosForm.chemical : null,
          nation: !App.Util.empty(dadosForm.nation) ? dadosForm.nation : null,
          league: !App.Util.empty(dadosForm.league) ? dadosForm.league : null,
          club: !App.Util.empty(dadosForm.club) ? dadosForm.club : null,
          minBuyNow: !App.Util.empty(dadosForm.minBuyNow) ? dadosForm.minBuyNow : null,
          maxBuyNow: !App.Util.empty(dadosForm.maxBuyNow) && dadosForm.precoCompra == 1 ? dadosForm.maxBuyNow : null,
          variar: !App.Util.empty(dadosForm.variar) && dadosForm.variar >= 1 ? dadosForm.variar : null,
          lucro: !App.Util.empty(dadosForm.lucro) && dadosForm.precoCompra == 2 ? dadosForm.lucro : null,
          turbo: !App.Util.empty(dadosForm.turbo) && dadosForm.turbo ? true : null,
          limiteCompraMin: !App.Util.empty(dadosForm.limite_compra_min) ? dadosForm.limite_compra_min : null,
          limiteCompraMax: !App.Util.empty(dadosForm.limite_compra_max) ? dadosForm.limite_compra_max : null,
        },
        venda: dadosForm.ativar_venda_automatica
          ? {
            duracao: 3600,
            valorLanceMinimo: !App.Util.empty(dadosForm.valor_lance_minimo) ? dadosForm.valor_lance_minimo : null,
            valorVenda: !App.Util.empty(dadosForm.valor_venda) ? dadosForm.valor_venda : null,
            precoFutbin: dadosForm.precoFutbin,
            porcentagemMaisBarato: !App.Util.empty(dadosForm.porcentagemMaisBarato) ? dadosForm.porcentagemMaisBarato : 0,
            precoInteligente: dadosForm.precoInteligente
          }
          : null,
        id: dadosForm.id ? dadosForm.id : null,
        nome: "SNIPER"
      }
    }

    private exibirLogsSniper(dadosLog: IDataLog) {
      if ($.isArray(dadosLog)) {
        return
      }

      let elementoEspacoLogConta = $(`.espaco-log-${dadosLog.idConta}`)

      switch (dadosLog.tipo) {
        case Util.EVENTO_TIPO_COMPRA:
          var descricao = Util.getObjInfoViewLog(dadosLog);
          if (dadosLog.status) {
            Util.salvarLogSniper(elementoEspacoLogConta, 'badge-success', "Comprou", descricao)
            this.atualizarContadorModalSniper(dadosLog.idConta)
          } else {
            Util.salvarLogSniper(elementoEspacoLogConta, 'badge-secondary', "Disputa Perdida", descricao)
          }
          break;
        case Util.EVENTO_TIPO_ENVIOU_TRANSFERENCIA:
          var descricao = Util.getObjInfoViewLog(dadosLog);
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-info', "Movido para Transferência", descricao)
          break;
        case Util.EVENTO_TIPO_COLOCOU_A_VENDA:
          var descricao = Util.getObjInfoViewLog(dadosLog);
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-info', "Colocou à venda", descricao)
          break;
        case Util.EVENTO_INICIOU_SNIPER:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-primary', "Iniciou", "Sniper foi iniciado.")
          break;
        case Util.EVENTO_PAROU_SNIPER:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Parou", "Sniper parou.")
          break;
        case Util.EVENTO_PAROU_SNIPER_LIMITE_ATINGIDO:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Limite Compra", "Limite de compra atingido.")
          break;
        case Util.EVENTO_PAROU_CAPACIDADE_LISTAS_ATINGIDA:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Lista Cheia", "Sua lista está cheia.")
        case Util.EVENTO_TIPO_ERRO:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Erro Indefinido", "Um erro ocorreu.")
          break;
        case Util.EVENTO_TIPO_ENVIOU_CLUBE:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-info', "Enviou para o clube", "Item enviado ao clube.")
          break;
        case Util.EVENTO_TIPO_RELISTOU:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-info', "Relistagem", "Itens foram relistados à venda.")
          break;
        case Util.EVENTO_TIPO_LIMPAR_VENDIDOS:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-info', "Vendidos Removidos", "Removeu itens vendidos da lista de itens vendidos.")
          break;
        case Util.EVENTO_TIPO_LISTA_NAO_ATRIBUIDOS_CHEIA:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Lista Cheia", "Lista de não atribuídos cheia.")
          break;
        case Util.EVENTO_TIPO_CAPTCHA:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-warning', "Captcha Solicitado", "Um captcha foi solicitado em sua conta.")
          break;
        case Util.EVENTO_TIPO_SOFTBAN:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-warning', "Softban", "Parece que há um softban nesse momento em sua conta.")
          break;
        case Util.EVENTO_TIPO_ERROS_EM_SEQUENCIA:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-warning', "Erro de conexao", "Parece que ocorreu um erro de conexão em sua conta.")
          break;
        case Util.EVENTO_TIPO_INCIANDO_AUTOCAPTCHA:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-primary', "Iniciando AutoCaptcha", "O sistema irá tentar resolver o captcha automaticamente.")
          break;
        case Util.EVENTO_TIPO_AUTOCAPTCHA_RESOLVIDO:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-success', "Captcha Resolvido", "O sistema resolveu seu captcha automaticamente.")
          break;
        case Util.EVENTO_TIPO_AUTOCAPTCHA_NAO_RESOLVIDO:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Captcha Não Resolvido", "O sistema não conseguiu resolver o captcha automaticamente.")
          break;
        case Util.EVENTO_TIPO_LUCRO_INCOMPATIVEL_COM_FILTRO:
          var descricao = Util.getObjInfoViewLog(dadosLog);
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-alerta-amarelo', "Lucro Incompatível", descricao)
          break;
        case Util.EVENTO_TIPO_LUCRO_FILTRO_BAIXO:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-alerta-amarelo', "Lucro Baixo", "Esse filtro no momento está obtendo lucro muito baixo.")
          break;
        case Util.EVENTO_TIPO_LUCRO_FILTRO_INUTIL:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Lucro Impossível", "Não é possível obter lucro com esse filtro, por esse motivo o sniper está parando.")
          break;
        case Util.EVENTO_TIPO_LUCRO_FILTRO_ESTIMADO:
          var dadosLucro: any = dadosLog.data && dadosLog.data.response ? JSON.parse(dadosLog.data.response) : null;
          var descricao = parseInt(dadosLucro.lucroEstimado) <= 0 ? `É Previsto que você tenha prejuízo nesse filtro, preço de venda mais barato encontrado é de <b>${dadosLucro.precoVenda} Coins</b>.` : `É Previsto um lucro mínimo de <b>${dadosLucro.lucroEstimado} Coins</b> por compra, comprando por até <b>${dadosLucro.precoCompra} Coins</b> e Vendendo por no mínimo <b>${dadosLucro.precoVenda} Coins</b> nesse filtro.`;
          Util.salvarLogSniper(elementoEspacoLogConta, parseInt(dadosLucro.lucroEstimado) <= 0 ? 'badge-danger' : 'badge-success', "Lucro Estimado", descricao)
          break;
        case Util.EVENTO_TIPO_NENHUM_FILTRO_ENCONTRADO_PARA_TAREFA:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Filtro nao encontrado", "Não foi possível iniciar a tarefa, nenhum filtro foi encontrado.")
          break;
        case Util.EVENTO_ERROR_INICIAR_INSTANCIA:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Erro ao abrir conta", "Não foi possível abrir o WebApp.")
          break;
        case Util.EVENTO_ERROR_INICIAR_INSTANCIA_COM_PROXY:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Erro proxy", "Proxy incorreto, verifique as configurações de proxy da sua conta.")
          break;
        case Util.EVENTO_TIPO_SALDO_INSUFICIENTE:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Saldo insuficiente", "Você não tem uma quantidade de coins suficiente.")
          break;
        case Util.EVENTO_TIPO_VENDA_NAO_INFORMADA:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-info', "Não Colocado à Venda", "Valor de venda não encontrado para esse item.")
          break;
        case Util.EVENTO_TIPO_VENDA_BLOQUEADA:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-info', "Venda Bloqueada", "Item não pode ser vendido, o valor de venda é <b>inferior ao comprado ou listado</b> anteriormente, para desativar essa trava de segurança vá para <b>preferências em seu menu configurações</b>")
          break;
        case Util.EVENTO_RELISTAGEM_DESCARTE:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-alerta-amarelo', "Descarte", "Itens foram descartados na lista de transferência")
          break;
        case Util.EVENTO_CONTA_ABERTA_COM_RESOLVER_BUG_EA:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-alerta-amarelo', "Resolver Bug EA", "Conta iniciada com resolver bug EA ativo")
          break;
        case Util.EVENTO_TIPO_CONTA_CARREGADA:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-primary', "WebApp recarregado", "Seu WebApp foi recarregado, essa é uma medida do sistema para liberar memória em sua máquina")
          break;
        case Util.EVENTO_TIPO_TRAVA_CONFERENCIA_FILTRO:
          var dadosConferenciaFiltro: { conferenciaFiltro: any, filtroSelecionado: any } = Util.getObjResponseLog(dadosLog);
          console.log("dadosConferenciaFiltro", dadosConferenciaFiltro)
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-alerta-amarelo-vermelho', "Conferência de Filtro", Util.getMensagemConferenciaFiltro(dadosConferenciaFiltro.conferenciaFiltro))
          break;
        case Util.EVENTO_TIPO_ATUALIZACAO_PRECO_COMPRA_FILTRO_LUCRO:
          var dadosAtualizacaoPreco: { preco: number, minutosmaximoAtualizacao: number } = dadosLog.data && dadosLog.data.response ? JSON.parse(dadosLog.data.response) : null;
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-primary', "Preço Compra Atualizado", `Seu filtro teve o preço de compra atualizado para <b>${dadosAtualizacaoPreco.preco} Coins</b> , essa é uma medida para evitar prejuízo`)
          break;
        case Util.EVENTO_LIMITE_VENDA_ATIVA_ATINGIDO:
          var resposta: { capacidadeVendaAtiva: number } = dadosLog.data && dadosLog.data.response ? JSON.parse(dadosLog.data.response) : null;
          if (resposta.capacidadeVendaAtiva >= 100) {
            Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Limite de Venda Ativa Atingido!", `Impossível listar em venda, você atingiu o limite máximo de <b>${resposta.capacidadeVendaAtiva} itens</b> em venda ativa`)
          } else {
            Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Limite de Venda Ativa Atingido!", `Só é permitido colocar até <b>${resposta.capacidadeVendaAtiva} itens</b> em venda ativa no WebApp, essa é uma nova regra da EA, caso queira burlar esse limite e assumir os riscos, vá em <a class="btn btn-sm btn-link" data-config="config" data-id-conta-ea="" data-toggle="modal" data-target="#modalConfigExtensao" href=""><i class="fa fa-cog" style="margin-right: 0.5rem;"></i>Preferências</a> e ative a opção "Aumentar Capacidade de Venda Ativa"`)
          }
          break;
        case Util.EVENTO_LIMITE_ATINGIDO:
          var respostaLimiteAtingido: { id_conta: number, limite_atual: number, id_perfil: number, requests: number } = Util.getObjResponseLog(dadosLog);;

          let msgPerfil = !respostaLimiteAtingido.id_perfil ?
            `Sua conta está sem um perfil, para continuar, <b>crie um perfil para a conta</b>, coloque um limite acima do atual no <b>campo "Limite de Requests dia"</b>, salve esse perfil e aplique-o na conta,`
            : ' Para continuar, <b>edite o perfil da conta</b>, coloque um limite acima do atual no campo "Limite de Requests dia", salve o perfil'
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Limite Atingido",
            `O limite diário de buscas da sua conta foi atingido: <b>Limite Atual(${respostaLimiteAtingido.limite_atual})</b>.<br />
           ${msgPerfil} depois clique em "remover limites" no menu "mais opções" do dashboard.`)
          break;
        case Util.EVENTO_AUTODME_DME_NAO_ENCONTRADO:
        case Util.EVENTO_AUTODME_DME_RESOLVIDO:
        case Util.EVENTO_PACOTE_ANALISE:
        case Util.EVENTO_AUTODME_ACOES:
          var dadosLogAutoDme: { html: string } = Util.getObjResponseLog(dadosLog);
          console.log("dadosConferenciaFiltro", dadosLogAutoDme)
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-cinza-escuro', "Auto DME", dadosLogAutoDme.html)
          break;
        case Util.EVENTO_PACOTE_ABERTO:
          var dadosLogAutoDme: { html: string } = Util.getObjResponseLog(dadosLog);
          console.log("dadosConferenciaFiltro", dadosLogAutoDme)
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-pacote-aberto', "Pacote Aberto", dadosLogAutoDme.html)
          break;
        case Util.EVENTO_FILTROS_DEFINIDOS:
          var dadosFiltros: { nomeFiltroExecucao: string, nomeFiltrosDefinidos: string, evento: string, precoCompra: string, vaiVariarPrecoBusca: boolean } = dadosLog.data && dadosLog.data.response ? JSON.parse(dadosLog.data.response) : null;
          let infoVariarPreco = dadosFiltros.vaiVariarPrecoBusca ? ' com variação' : '';
          let infoEvento = '';
          if (dadosFiltros.evento == "STARTED") {
            infoEvento = "no início da tarefa";
          } else if (dadosFiltros.evento == "RESUMED") {
            infoEvento = "na continuação da tarefa";
          }
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-filtro', "Filtro Definido", `Filtro Definido: <b>${dadosFiltros.nomeFiltroExecucao}</b> ${infoEvento} | Preço de Compra: <b>${dadosFiltros.precoCompra}</b>${infoVariarPreco}<br/>Filtros disponíveis na execução: <b>${dadosFiltros.nomeFiltrosDefinidos}</b>`)
          break;
        case Util.EVENTO_ERRO_AUTENTICACAO:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-alerta-amarelo', "Autenticação Expirou", "Foi necessário fechar a conta para fazer uma nova autenticação.")
          break;
      }

    }

    private preencherCamposModalSniperTarefaAtual(idConta: number, dadosFiltroAplicar: IFiltroOptions = null, nomeOriginal: string = ''): void {
      var tarefaAtual: ITarefaSniper = null
      if (dadosFiltroAplicar && this.tarefasSniperContas[idConta] && this.tarefasSniperContas[idConta].hasOwnProperty("data")) {
        this.tarefasSniperContas[idConta].data.filtros[0] = dadosFiltroAplicar
        tarefaAtual = this.tarefasSniperContas[idConta]
      } else if (dadosFiltroAplicar) {
        tarefaAtual = {}
        tarefaAtual.data = {}
        tarefaAtual.data.filtros = []
        tarefaAtual.data.tempo = null
        tarefaAtual.data.filtros[0] = dadosFiltroAplicar
      }

      if (!tarefaAtual) {
        return
      }

      var modalSniperPro = $("#modalSniperPro");

      var pilotoAutomatico = !tarefaAtual.data
      if (pilotoAutomatico) {
        modalSniperPro.find('input[name=piloto_automatico]').prop("checked", true).trigger('change');
        return
      } else {
        modalSniperPro.find('input[name=piloto_automatico]').prop("checked", false).trigger('change');
      }

      var dadosFiltro: IFiltroOptions = tarefaAtual.data.filtros[0]

      this.filtrosEa.setCampoInputName("id", dadosFiltro.id);
      this.filtrosEa.setCampoInputName("nome", dadosFiltro.nome);
      try {
        modalSniperPro.find('input[name=campo_nome_filtro]').val(nomeOriginal)
      } catch (e) { }


      if (dadosFiltro.data.maskedDefId && dadosFiltro.data.maskedDefId.length) {
        this.filtrosEa.setCampoJogadorFiltroPro(dadosFiltro.data.maskedDefId, App.Util.objPlayers, modalSniperPro.find('select[name="maskedDefId[]"]'), "#searchclearSniperPro");
      } else {
        modalSniperPro.find("#searchclearSniperPro").click();
      }

      /**
       * Filtro e Venda automatica
       */
      this.filtrosEa.setCampoSelect2("quality", dadosFiltro.data.quality);
      this.filtrosEa.setCampoSelect2("icontraits", dadosFiltro.data.icontraits);
      this.filtrosEa.setCampoSelect2("rarity[]", dadosFiltro.data.rarity);
      this.filtrosEa.setCampoSelect2("position", dadosFiltro.data.position);
      this.filtrosEa.setCampoSelect2("chemical", dadosFiltro.data.chemical);
      this.filtrosEa.setCampoSelect2("nation", dadosFiltro.data.nation);
      this.filtrosEa.setCampoSelect2("league", dadosFiltro.data.league);
      this.filtrosEa.setCampoSelect2("club", dadosFiltro.data.club);
      this.filtrosEa.setCampoInputName("minBuyNow", dadosFiltro.data.minBuyNow);
      this.filtrosEa.setCampoInputName("maxBuyNow", dadosFiltro.data.maxBuyNow);
      this.filtrosEa.setCampoInputName("variar", dadosFiltro.data.variar, true);
      this.filtrosEa.setCampoInputRadio("precoCompra", dadosFiltro.data.lucro ? "2" : "1");
      this.filtrosEa.setCampoInputCheckbox("ativar_venda_automatica", !App.Util.empty(dadosFiltro.venda));
      this.filtrosEa.setCampoInputCheckbox("precoInteligente", !App.Util.empty(dadosFiltro.venda) && dadosFiltro.venda.precoInteligente);
      this.filtrosEa.setCampoInputCheckbox("precoFutbin", !App.Util.empty(dadosFiltro.venda) && dadosFiltro.venda.precoFutbin);
      this.filtrosEa.setCampoInputName("lucro", dadosFiltro.data.lucro);
      this.filtrosEa.setCampoInputCheckbox("turbo", !App.Util.empty(dadosFiltro.data.turbo) && dadosFiltro.data.turbo);
      this.filtrosEa.setCampoInputName("porcentagemMaisBarato", !App.Util.empty(dadosFiltro.venda) && dadosFiltro.venda.porcentagemMaisBarato ? dadosFiltro.venda.porcentagemMaisBarato : 0);
      this.filtrosEa.setCampoInputName("valor_lance_minimo", !App.Util.empty(dadosFiltro.venda) && dadosFiltro.venda.valorLanceMinimo ? dadosFiltro.venda.valorLanceMinimo : "");
      this.filtrosEa.setCampoInputName("valor_venda", !App.Util.empty(dadosFiltro.venda) && dadosFiltro.venda.valorVenda ? dadosFiltro.venda.valorVenda : "");
      this.filtrosEa.setCampoInputName("limiteCompraMin", dadosFiltro.data.limiteCompraMin);
      this.filtrosEa.setCampoInputName("limiteCompraMax", dadosFiltro.data.limiteCompraMax);

      /**
       * Configuracões comportamento
       */
      if (tarefaAtual.data.tempo) {
        var selectVelocidade: JQuery = modalSniperPro.find("select[name='velocidade']");
        var selectDescanso: JQuery = modalSniperPro.find("select[name='descanso']");
        var selectIntervalo: JQuery = modalSniperPro.find("select[name='intervalo']");
        var selectTempo: JQuery = modalSniperPro.find("select[name='tempo']");

        this.objSelect2.setSelectTag(selectVelocidade, { id: tarefaAtual.data.velocidade.toString(), text: (tarefaAtual.data.velocidade.toString() + this.selectTextMilisegundosComplementoDefault) })
        this.objSelect2.setSelectTag(selectDescanso, { id: tarefaAtual.data.descanso.toString(), text: (tarefaAtual.data.descanso.toString() + this.selectTextMilisegundosComplementoDefault) })
        this.objSelect2.setSelectTag(selectIntervalo, { id: tarefaAtual.data.intervalo.toString(), text: (tarefaAtual.data.intervalo.toString() + this.selectTextMilisegundosComplementoDefault) })
        this.objSelect2.setSelectTag(selectTempo, { id: tarefaAtual.data.tempo.toString(), text: (tarefaAtual.data.tempo.toString() + this.selectTextMilisegundosComplementoDefault) })

        modalSniperPro.find("input[name='porcentagem_eficacia']").val(tarefaAtual.data.porcentagem_eficacia);
        modalSniperPro.find("input[name='tempo_minimo_eficacia']").val(tarefaAtual.data.tempo_minimo_eficacia);
        modalSniperPro.find("input[name='limite_compra']").val(tarefaAtual.data.limite_compra);
      }
    }

    private aoAplicarFiltroPro(e: JQueryEventObject) {
      var idContaEa: any = $(e.currentTarget).data('idContaEa');

      var filtro: IFiltroOptions = $(e.currentTarget).data('filtro');
      filtro.id = $(e.currentTarget).data('id');
      filtro.nome = $(e.currentTarget).data('nome');
      let nomeOriginal = $(e.currentTarget).data("nomeOnly");

      this.preencherCamposModalSniperTarefaAtual(idContaEa, filtro, nomeOriginal);
    }

    private aoLimparFiltroPro(e: JQueryEventObject) {
      var formSniperPro: any = $(e.currentTarget).parents('#formSniperPro');
      formSniperPro.find("#searchclearSniperPro").click();
      formSniperPro.find("input[name=max]").val('200').trigger('input').trigger('change');
      formSniperPro.find('#qualidade').val('').trigger('change').trigger('select2:select');
      formSniperPro.find('#raridade').val('').trigger('change').trigger('select2:select');
      formSniperPro.find('#posicao').val('').trigger('change').trigger('select2:select');
      formSniperPro.find('#estilo').val('').trigger('change').trigger('select2:select');
      formSniperPro.find('#estiloJogo').val('').trigger('change').trigger('select2:select');
      formSniperPro.find('#pais').val('').trigger('change').trigger('select2:select');
      formSniperPro.find('#liga').val('').trigger('change').trigger('select2:select');
      formSniperPro.find('#time').val('').trigger('change').trigger('select2:select');
    }

    private estadoVazioFiltroPro(e: JQueryEventObject) {
      var formFiltroProCad: any = $('#formFiltroProCad');
      $(e.currentTarget).find('#formFiltroProCad').find("#searchclearSniperPro").click();
      formFiltroProCad.find("input[name=minBuyNow]").val('').trigger('input').trigger('change');
      formFiltroProCad.find("input[name=maxBuyNow]").val('200').trigger('input').trigger('change');
      formFiltroProCad.find("input[name=variar]").val('').trigger('input').trigger('change');
      formFiltroProCad.find("input[name=turbo]").val('');
      formFiltroProCad.find('#qualidade').val('').trigger('change').trigger('select2:select');
      formFiltroProCad.find('#raridade').val('').trigger('change').trigger('select2:select');
      formFiltroProCad.find('#posicao').val('').trigger('change').trigger('select2:select');
      formFiltroProCad.find('#estilo').val('').trigger('change').trigger('select2:select');
      formFiltroProCad.find('#estiloJogo').val('').trigger('change').trigger('select2:select');
      formFiltroProCad.find('#pais').val('').trigger('change').trigger('select2:select');
      formFiltroProCad.find('#liga').val('').trigger('change').trigger('select2:select');
      formFiltroProCad.find('#time').val('').trigger('change').trigger('select2:select');
      formFiltroProCad.find(".conteudoGeralVendaAutomatica").find('input[name=ativar_venda_automatica]').prop('checked', false);
      formFiltroProCad.find(".conteudoGeralVendaAutomatica").find('input[name=precoInteligente]').prop('checked', false);
      formFiltroProCad.find(".conteudoGeralVendaAutomatica").find('input[name=precoFutbin]').prop('checked', false);
      formFiltroProCad.find("#filterName").val('');

      $(".corpoVendaAutomatica").hide();
    }

    private aoSelecionarPilotoAutomatico(e: JQueryEventObject) {
      var parent = $(e.target).parents('.parent-sniper-pro');
      if ($(e.target).is(':checked')) {
        parent.find('.espaco-formulario-pro').hide()
        parent.find('.espaco-piloto-automatico-pro').show()
        parent.find('.opcoes-form-sniper-pro').hide()
      } else {
        parent.find('.espaco-formulario-pro').show()
        parent.find('.opcoes-form-sniper-pro').show()
        parent.find('.espaco-piloto-automatico-pro').hide()
      }
    }

    private aoSelecionarPilotoAutomaticoAgendamento(e: JQueryEventObject) {
      var parent = $(e.target).parents('.card-espaco-configuracoes');
      if ($(e.target).is(':checked')) {
        parent.find('.condicao-piloto').hide()
        parent.find('.condicao-info-piloto').show()
      } else {
        parent.find('.condicao-piloto').show()
        parent.find('.condicao-info-piloto').hide()
      }
    }
    private copiarItemAgendamento(e: JQueryEventObject) {
      let itemLi = $(e.target).parents('li.container-item-sch');
      itemLi.find('.accordion .collapse').collapse('hide');
      let modal: JQuery = $(e.target).parents('.modal');
      let form: JQuery = modal.find('form');
      let idRegistro = form.find('input[name=id]').val();
      let index = itemLi.data('index')
      form.find(`#containerItem${index}`).find('.espaco-collapse-agenda').collapse('hide');
      let namesFiltros = itemLi.find('.info-names-filtros').html().split(",");
      let indexNext = form.find('li.container-item-sch').length

      var objAgendamento: IObjAgendamento = { id: form.find("input[name=id]").val(), nome: form.find("input[name=nome]").val(), dados: this.obterObjetoAgendamento(form, null) }

      let agendaCopy = objAgendamento.dados[index];
      agendaCopy.tarefa.data.filtros
      $.each(agendaCopy.tarefa.data.filtros, function (index: any, id: number) {
        agendaCopy.tarefa.data.filtros[index] = { nome: namesFiltros[index], id: id };
      });
      // console.log("OBJ AGEDAMENTO COPY", objAgendamento, agendaCopy, index, indexNext)
      this.preencherItemAgendamento(modal, form, objAgendamento, agendaCopy, indexNext)
      // $(`#containerItem${indexNext}`).find('.copy-item-sch').on("click", (e) => { this.copiarItemAgendamento(e) });



      // var main = $(e.target).parents('.clone-data');
      // let mainId = main.attr('id')
      // var itemLi = $(e.target).parents('li.container-item-sch');
      // let nextIndex = $(`#${mainId}`).find('.container-item-sch').length
      // console.log("COPY ITEM", nextIndex, main, itemLi);
      // let itemClone = itemLi.clone();
      // itemClone.attr('data-index', nextIndex)
      // itemClone.data('index', nextIndex)
      // itemClone.attr('id', `containerItem${nextIndex}`)
      // let idAccordion = itemClone.find('.accordion').attr('id').replace(/[0-9]/g, `${nextIndex}`);
      // itemClone.find('.accordion').attr('id', idAccordion)
      // let idHeading = itemClone.find('.card-header.checklist-item').attr('id').replace(/[0-9]/g, `${nextIndex}`);
      // let idCollapse = idHeading.replace('heading-', 'collapse-');
      // itemClone.find('.card-header.checklist-item').attr('id', idHeading)
      // itemClone.find('.card-header.checklist-item').attr('data-target', `#${idCollapse}`)
      // itemClone.find('.card-header.checklist-item').attr('aria-controls', `#${idCollapse}`)
      // itemClone.find('.card-header.checklist-item').data('target', `#${idCollapse}`)
      // let idDivCollapse = itemClone.find('div.collapse').attr('id').replace(/[0-9]/g, `${nextIndex}`);
      // itemClone.find('div.collapse').attr('id', idDivCollapse)
      // itemClone.find('div.collapse').attr('aria-labelledby', idHeading)
      // itemClone.find('div.collapse').attr('data-parent', `#${idAccordion}`)
      // itemClone.find('div.collapse').data('parent', `#${idAccordion}`)
      // itemClone.find('.copy-item-sch').on("click", (e) => { this.copiarItemAgendamento(e) });
      // itemClone.find('.select2.select2-container').remove()
      // if (itemClone.find('select.select2').length > 0) {
      //   this.objSelect2.inicializarCampo(itemClone.find('select.select2'));
      //   this.objSelect2.inicializarCampo(itemClone.find('select.select-tag'), Util.getOptionsSelectTag());
      // }
      // main.append(itemClone);
    }

    private atualizarContadorModalSniper(idConta: number) {
      if (idConta == this.idContaSniperModalAberto) {
        App.Util.incrementarComprasModalSniper()
      }
    }

    private tratarBuscaSniper(dados: any, callback: any) {
      // console.log("BUSCA...", dados);
      var comunicacaoEstabelecida = dados.id == this.idContaSniperModalAberto && $('#modalSniperPro').hasClass('show')
      if (comunicacaoEstabelecida) {
        switch (dados.tipo) {
          case 1:
            App.Util.incrementarTentativa($('#modalSniperPro .tentativas'), "fas fa-hourglass-half");
            break;
          case 0:
          default:
            App.Util.incrementarTentativa($('#modalSniperPro .tentativas'));
            break;
        }
      }

      return this.responderServidor(comunicacaoEstabelecida, {}, callback);
    }

    private tratarAcao(dados: any, callback: any = null) {
      // console.log("ACAO...", dados);
      var idConta = dados.id;
      switch (dados.tipo) {
        case 'abrindoWebApp':
          this.exibirLoadListConta(idConta, "Abrindo WebApp...")
          break;
        case 'inicializando':
          this.exibirLoadListConta(idConta, "Inicializando...")
          break;
        case 'executandoTarefasIniciais':
          this.exibirLoadListConta(idConta, "Executando Tarefas Iniciais...")
          break;
        case 'revendaJogadores':
          this.exibirLoadListConta(idConta, "Vendendo Jogadores de transferência coins...")
          break;
        case 'verificarVendaCoins':
          this.exibirLoadListConta(idConta, "Verificando venda de coins...")
          break;
        case 'iniciandoTarefa':
          this.exibirLoadListConta(idConta, "Iniciando Tarefa...")
          break;
        case 'fazendoLoginConta':
          this.exibirLoadListConta(idConta, "Login na conta...")
          break;
        case 'vendendoCoins':
          this.exibirLoadListConta(idConta, "Vendendo Coins...", true)
          break;
        case 'resolvendoDme':
          this.exibirLoadListConta(idConta, "Resolvendo DME 🎯...", false)
          break;
        case 'resolvaCaptcha':
          this.exibirMensagemPedindoResolucaoManualDeCaptcha(dados.data)
          break;
        case 'listando':
          this.tratarAcaoDeListagem(idConta, dados.data)
          break;
        case 'agendando':
          this.exibirLoadListConta(idConta, "Agendando...")
          break;
        case 'ocultarLoadListConta':
          this.ocultarLoadListConta(idConta)
          break;
      }
    }

    private tratarError(dados: any, callback: any = null) {
      // console.log("ERROR...", dados);
      var idConta = dados.id;
      switch (dados.tipo) {
        case 'erroIniciarInstancia':
          swal.fire({
            icon: 'error',
            title: 'Conta não iniciada:' + (dados.data ? dados.data.nome : idConta),
            text: 'Um erro ocorreu ao iniciar a conta, o navegador se desconectou ou algum outro problema ocorreu, tente novamente, se o erro persistir desligue e ligue seu plugin e carregue essa tela novamente.'
          })
          this.ocultarLoadListConta(idConta)
          App.Util.ocultarModalPaginaCarregando()
          break;
        case 'erroIniciarComProxy':
          swal.fire({
            icon: 'error',
            title: 'Proxy incorreto:' + (dados.data ? dados.data.nome : idConta),
            text: 'Proxy incorreto, verifique as configurações de proxy da sua conta, se o erro persistir desligue e ligue seu plugin novamente.'
          })
          this.ocultarLoadListConta(idConta)
          App.Util.ocultarModalPaginaCarregando()
          break;
        case 'erroContaNaoHabilitadaAgendamento':
          swal.fire({
            icon: 'error',
            title: 'Conta não pode ser agendada:' + (dados.data ? dados.data.nome : idConta),
            text: 'Verifique o status da conta, se houver captcha resolva antes de agendar nova tarefa, se o erro persistir recarregue o dashboard e desligue e ligue seu plugin novamente..'
          })
          this.ocultarLoadListConta(idConta)
          break;
      }
    }

    private atualizarViewProxyConta(idConta: number, checked: boolean = false, data: IDadosProxy) {
      // console.log("CHEGOU", idConta, checked, data)
      let infoProxy = this.getElementoListConta(idConta).find('.info-proxy');
      let strDataPopovers = `<p class="mb-0"><small>PROTOCOLO: ${data.protocolo ? data.protocolo : ''}</small></p><p class="mb-0"><small>IP: ${data.proxy_address ? data.proxy_address : ''}</small></p><p class="mb-0"><small>PORTA: ${data.proxy_port ? data.proxy_port : ''}</small></p>`
      if (checked) {
        infoProxy.show()
        infoProxy.attr('data-content', `${strDataPopovers}`);
      } else {
        infoProxy.hide()
        infoProxy.attr('data-content', ``);
      }
    }

    private getDadosProxyVinculo(idConta: number): IProxy {
      // se tem id da conta não é vinculo então nao precisa de proxy de vinculo de conta
      if (idConta) {
        return null;
      }

      let selectProxy = $(".form-vinculo-proxy").find('select[name=select_proxy]').find(':selected')
      if (!selectProxy.val()) {
        return null
      }

      let proxyVinculo = {
        id: selectProxy.val(),
        nome: selectProxy.data('nome'),
        protocolo: selectProxy.data('protocolo'),
        address: selectProxy.data('address'),
        port: selectProxy.data('port'),
        login: selectProxy.data('login'),
        password: selectProxy.data('password')
      }
      // console.log("VAI COM PROXY", proxyVinculo)

      return proxyVinculo.address && proxyVinculo.port && proxyVinculo.protocolo ? proxyVinculo : null
    }

    private getPersona() {
      let selectPersona = $(".form-persona").find('select[name=select_persona]').find(':selected');
      if (!selectPersona.val()) {
        return null
      }
      return selectPersona.val();
    }

    public ordenaListagemDeContas(id: number, status: number) {
      if (_.contains(Util.ARRAY_STATUS_CONTA_HABILITADA, status)) {
        App.Business.objDataTableContas.row(`#${id}`).order([2, 'asc']).draw();
      }
    }

    public exibirMensagemPedindoResolucaoManualDeCaptcha(dados: any) {
      swal.fire({
        icon: 'warning',
        title: 'Conta com Captcha:' + dados.email,
        text: 'Resolva o Captcha na Conta em outro navegador antes de vincula-la'
      })
    }

    public tratarAcaoDeListagem(idConta: number, dados: any) {
      if (dados.status) {
        this.exibirLoadListConta(idConta, "Listando...")
      }
    }

    private getContasSelecionadas() {
      return Business.objDataTableContas.rows({ selected: true })
    }

    private getAllContas() {
      return Business.objDataTableContas.rows()
    }

    private getIdsContasSelecionadas(): number[] {
      try {
        let contasSelecionadas = this.getContasSelecionadas()
        return contasSelecionadas.ids().toArray()
      } catch (error) {
        return []
      }
    }

    private getIdsAllContas(): number[] {
      try {
        let contasDash = this.getAllContas()
        return contasDash.ids().toArray()
      } catch (error) {
        return null
      }
    }

    // private getIdsServidoresSelecionados(): number[] {
    //   let servidoresSelecionados = this.getContasSelecionadas()
    //   return servidoresSelecionados.ids().toArray()
    // }

    // private getServidoresSelecionados() {
    //   return this.objDataTableServidores.rows({ selected: true })
    // }

    private async atualizarContaNoPluginAsync(id: any, semCache: boolean = false): Promise<IRespostaMensagem> {
      return new Promise((resolve: any, reject: any) => {
        this.atualizarContaNoPlugin({ id: id, semCache: semCache }, (response: IRespostaMensagem) => {
          if (response.status && response.result && response.result.contaAtualizada) {
            resolve(response);
          } else {
            resolve(null);
          }
        });
      });
    }

    private async atualizarContasNoPluginAposDadosAplicados(contas_ids: number[], semCache: boolean = false, callbackSucessoFinal: () => void = () => { }) {
      const delay = (ms: number) => new Promise((resolve: any) => setTimeout(resolve, ms)); // Função para criar o delay

      try {
        for (const id of contas_ids) {
          const response = await this.atualizarContaNoPluginAsync(id, semCache);
          console.log("Conta Atualizada no Plugin:", id, response);
          if (response && response.result && response.result.contaAtualizada) {
            this.updateContaDatatable(response.result.contaAtualizada);
          }
          // Adiciona um delay de 3 segundos antes de continuar para a próxima conta
          await delay(3000);

          // ao final desse for, preciso chamar callback de sucesso
          if (id === contas_ids[contas_ids.length - 1]) {
            callbackSucessoFinal();
          }
        }
      } catch (error) {
        console.log('Erro ao atualizar contas:', error);
      }
    }

    private aoAplicarPerfil(e: JQueryEventObject) {
      this.ajax = new App.Ajax();
      let dadosForm: any = this.ajax.convertFormToJSON($("#formAplicarPerfil"))
      dadosForm.contas_ids = this.getIdsContasSelecionadas()
      // console.log("IDS", dadosForm)

      $("#modalAplicarPerfil").modal('hide')
      this.ajax.postAcao(App.Util.config.urlAplicarProfile, dadosForm, async (resposta: { dadosEnviados: any, dadosRetornados: { dadosResposta: { perfil: { id: number, nome: string } } } }) => {
        // console.log("APP PERFIL::", resposta.dadosRetornados.dadosResposta.perfil);
        swal.fire({
          icon: 'success',
          title: 'Perfil Aplicado!',
          text: 'O Perfil foi aplicado nas contas selecionadas, aguarde um momento para que a parte visual seja atualizada.'
        })

        await this.atualizarContasNoPluginAposDadosAplicados(dadosForm.contas_ids, true)
      });
    }

    private aoAplicarFiltros(e: JQueryEventObject) {
      this.ajax = new App.Ajax();
      let dadosForm: any = this.ajax.convertFormToJSON($("#formAplicarFiltros"))
      dadosForm.contas_ids = this.getIdsContasSelecionadas()
      // console.log("APP FILTROS", dadosForm)

      $("#modalAplicarFiltros").modal('hide')
      this.ajax.postAcao(App.Util.config.urlAplicarFiltros, dadosForm, async (resposta: { dadosEnviados: any, dadosRetornados: { dadosResposta: { filtros: any[] } } }) => {
        // console.log("APP FILTROS::", resposta.dadosRetornados.dadosResposta);
        swal.fire({
          icon: 'success',
          title: 'Filtro Aplicado!',
          text: 'O Filtro foi aplicado nas contas selecionadas, aguarde um momento para que a parte visual seja atualizada.'
        })

        await this.atualizarContasNoPluginAposDadosAplicados(dadosForm.contas_ids, true)
      });
    }

    private aoAplicarProxy(e: JQueryEventObject) {
      this.ajax = new App.Ajax();
      let dadosForm: any = this.ajax.convertFormToJSON($("#formAplicarProxy"))
      dadosForm.contas_ids = this.getIdsContasSelecionadas()
      // console.log("IDS", dadosForm)

      $("#modalAplicarProxy").modal('hide')
      this.ajax.postAcao(App.Util.config.urlAplicarProxy, dadosForm, async (resposta: { dadosEnviados: any, dadosRetornados: { dadosResposta: { proxy: IProxy } } }) => {
        // console.log("ADD PROXY::", resposta.dadosRetornados.dadosResposta, resposta);
        swal.fire({
          icon: 'success',
          title: 'Proxy Aplicado!',
          text: 'O Proxy foi aplicado nas contas selecionadas, aguarde um momento para que a parte visual seja atualizada.'
        })

        await this.atualizarContasNoPluginAposDadosAplicados(dadosForm.contas_ids, true)
      });
    }

    private avisarSobreReagendamentoPluginDesconectado(mensagem: string = null) {
      // if (!this.conectado) {
      //   swal.fire({
      //     icon: 'warning',
      //     title: 'Impossível Reagendar!',
      //     text: mensagem ? mensagem : 'A interface não está conectada ao plugin, alterações de perfil e agendamentos serão atualizados automaticamente pelo plugin após alguns minutos, se desejar alteração imediata, conecte ao plugin e clique em "atualizar agenda" no menu da conta ou se estiver na mesma maquina do plugin, apenas inicie-o.'
      //   })
      // }
    }

    private inicializarEventosDataTables() {
      let aoSelecionarOuDeselecionar = (e: any, dt: any, type: any, indexes: any) => {
        if (type === 'row') {
          let contasSelecionadas = this.getContasSelecionadas()
          var count = contasSelecionadas.count();
          $('.btn-aplicar').html(count > 0 ? `+ Perfil (${count})` : `+ Perfil`)
          $('.btn-dt-aplicar-filtros').html(count > 0 ? `+ Filtros (${count})` : `+ Filtros`)
          $('.btn-dt-aplicar-proxy').html(count > 0 ? `+ Proxy (${count})` : `+ Proxy`)
          $('.btn-dt-atualizar').html(count > 0 ? `Atualizar (${count})` : `Atualizar`)
          $('.btn-executar-tarefa').html(count > 0 ? `Exec. Tarefa (${count})` : `Exec. Tarefa`)
          $('.btn-dt-acoes').html(count > 0 ? `+ Ações (${count})` : `+ Ações`)
          $('.btn-dt-resolver-dme').html(count > 0 ? `Resolver Dme (${count})` : `Resolver Dme`)


          $('.btn-aplicar-profile').html(count > 0 ? `Aplicar (${count})` : `Aplicar`)
          $('.btn-aplicar-filtros').html(count > 0 ? `Aplicar (${count})` : `Aplicar`)
          $('.btn-aplicar-proxy').html(count > 0 ? `Aplicar (${count})` : `Aplicar`)
          $('.btn-abrir-contas').html(count > 0 ? `Abrir Contas (${count})` : `Abrir Contas`)
          $('.btn-executar-tarefa-contas').html(count > 0 ? `Exec. Tarefa (${count})` : `Exec. Tarefa`)
          $('.btn-acao-resolver-dme-contas').html(count > 0 ? `Resolver (${count})` : `Resolver`)
          $('.btn-vender-coins').html(count > 0 ? `Exec. Venda Coins (${count})` : `Exec. Venda Coins`)
          $('.btn-resolver-bug-ea').html(count > 0 ? `Resolver Bug EA (${count})` : `Resolver Bug EA`)
          $('.btn-limpar-cache').html(count > 0 ? `Limpar Cache/Sincronizar (${count})` : `Limpar Cache/Sincronizar`)
        }
      }

      Business.objDataTableContas.on('user-select', function (e: any, dt: any, type: any, cell: any, originalEvent: any) {
        if (_.contains(['a', 'i', 'input'], originalEvent.target.nodeName.toLowerCase())) {
          return false;
        }
      });

      Business.objDataTableContas.on('select', aoSelecionarOuDeselecionar);
      Business.objDataTableContas.on('deselect', aoSelecionarOuDeselecionar);

    }

    private carregarTabelaContas(dataContas: IConta[]) {
      if (Business.objDataTableContas instanceof $.fn.dataTable.Api) {
        if ($.isArray(dataContas)) {
          Business.objDataTableContas.clear().draw();
          Business.objDataTableContas.rows.add(dataContas);
        } else {
          Business.objDataTableContas.row.add(dataContas);
        }
        Business.objDataTableContas.columns.adjust().draw();
      } else {

        Business.objDataTableContas = this.elDataTableContas.DataTable({
          language: {
            url: "/datatable-pt-br.json",
            // searchPanes: {
            //   collapse: { 0: 'Filtros', _: 'Filtros Aplicados (%d)' }
            // }
          },
          pageLength: 1000,
          bLengthChange: false,
          bInfo: false,
          // searchPanes: {
          //   viewTotal: true,
          //   cascadePanes: true,
          //   columns: [0, 1]
          // },
          // buttons: [
          //   'searchPanes'
          // ],
          data: dataContas,
          bAutoWidth: false,
          createdRow: (row: any, data: IConta, dataIndex: any) => {
            this.preencherCredenciais(data)
          },
          rowId: 'id',
          dom: 'Bfrtip',
          select: true,
          buttons: [
            {
              className: "btn-sm btn-outline-primary btn-selecionar-tudo",
              text: '<i title="Select/Unselect all" class="fas fa-check-double font-size-11 m-0"></i>',
              action: () => {
                let contasSelecionadas = this.getContasSelecionadas()
                var count = contasSelecionadas.count();
                if (count) {
                  Business.objDataTableContas.rows().deselect();
                } else {
                  Business.objDataTableContas.rows().select();
                }
              }
            },
            {
              className: "btn-sm btn-outline-primary btn-aplicar",
              text: '+ Perfil',
              action: () => {
                let contasSelecionadas = this.getContasSelecionadas()
                var count = contasSelecionadas.count();
                if (count) {
                  $("#modalAplicarPerfil").modal("show")
                }
              }
            },
            {
              className: "btn-sm btn-outline-primary btn-dt-aplicar-filtros",
              text: '+ Filtros',
              action: () => {
                let contasSelecionadas = this.getContasSelecionadas()
                var count = contasSelecionadas.count();
                if (count) {
                  $("#modalAplicarFiltros").modal("show")
                }
              }
            },
            {
              className: `btn-sm btn-outline-primary btn-dt-aplicar-proxy ${this.infoPlanoAtual.ehPlanoCloud ? ' display-none' : ''}`,
              text: '+ Proxy',
              action: () => {
                let contasSelecionadas = this.getContasSelecionadas()
                var count = contasSelecionadas.count();
                if (count) {
                  $("#modalAplicarProxy").modal("show")
                }
              }
            },
            {
              className: `btn-sm btn-outline-primary btn-dt-atualizar`,
              text: 'Atualizar',
              action: async () => {
                this.atualizarContas()
              }
            },
            {
              className: "btn-sm btn-outline-primary btn-executar-tarefa",
              text: 'Exec. Tarefa',
              action: () => {
                let contasSelecionadas = this.getContasSelecionadas()
                var count = contasSelecionadas.count();
                if (count) {
                  if (this.executandoTarefa) {
                    return
                  }

                  this.executandoTarefa = true;
                  $('.btn-executar-tarefa').text("Aguarde...");
                  $('.btn-executar-tarefa-contas').click()
                  setTimeout(() => {
                    $('.btn-executar-tarefa').text("Exec. Tarefa");
                    this.executandoTarefa = false
                  }, 6000);
                }
              }
            },
            {
              className: `btn-sm btn-outline-primary btn-dt-resolver-dme`,
              text: 'Resolver Dme',
              action: () => {
                let contasSelecionadas = this.getContasSelecionadas()
                var count = contasSelecionadas.count();
                if (count) {
                  $("#modalResolverDmeContasSelecionadas").modal("show")
                }
              }
            },
            {
              className: "btn-sm btn-outline-primary btn-dt-acoes",
              text: '+ Ações',
              action: () => {
                let contasSelecionadas = this.getContasSelecionadas()
                var count = contasSelecionadas.count();
                if (count) {
                  $("#modalAcoesContas").modal("show")
                }
              }
            }
          ],
          drawCallback: (settings: any) => {
            $('.btn-info-agenda').popover({
              "html": true,
              trigger: 'hover',
              placement: 'top'
            })
          },
          columnDefs: [
            {
              targets: 0,
              visible: false,
              render: function (data: any, tipo: any, obj: IConta, meta: any) {
                return obj.id;
              }
            },
            {
              targets: 1,
              className: "info-conta",
              render: (data: any, tipo: any, obj: IConta, meta: any) => {
                if (!this.configuracoesGeraisExecucao.exibir_escudo_clube && !this.cacheInfoContas[obj.id]) {
                  this.cacheInfoContas[obj.id] = {}
                  this.cacheInfoContas[obj.id].corAvatar = App.Util.obterCorRandomica()
                  this.cacheInfoContas[obj.id].nomeAvatar = App.Util.getNomeAvatar(obj.dadosEa.clubeName)
                }

                let partidas = ``
                let viewImageConta = this.configuracoesGeraisExecucao.exibir_escudo_clube
                  ? `<a href="#" class="avatar rounded-circle mr-3" style="width: 20px;height: 20px;"><img alt="Image conta" src="${obj.dadosEa.img}"></a>`
                  : `<a href="#" class="avatar rounded-circle mr-3" style="width: 20px;height: 20px;background-color:${this.cacheInfoContas[obj.id].corAvatar}">${this.cacheInfoContas[obj.id].nomeAvatar}</a>`


                if (obj.partidas) {
                  partidas = `V${obj.partidas.won}-E${obj.partidas.draw}-D${obj.partidas.loss}`
                }

                let strDataPopovers = '';
                if (obj.programacao && obj.programacao.length) {
                  $.each(obj.programacao, (index: any, descAgenda: string) => {
                    strDataPopovers += `<p class="mb-0"><span><i class="ni ni-time-alarm text-success font-size-10"></i></span>&nbsp;<small>${descAgenda}</small></p>`
                  });
                }

                let cemiterioHtml = ``
                let transferenciaHtml = ``
                let clubeHtml = ``

                if (obj.listas) {
                  cemiterioHtml = obj.listas.cemiterio_total ? `
                  <span title="Quantidade no cemitério" class="badge badge-info badge-plataforma text-uppercase font-size-8" style="vertical-align: baseline;padding: 2px 4px;background-color: #ebff77;color: #000000;">${obj.listas.cemiterio_total}</span>
                  ` : ``

                  transferenciaHtml = obj.listas.transferencia_total ? `
                  <span title="Quantidade no na lista de transferência" class="badge badge-info badge-plataforma text-uppercase font-size-8" style="vertical-align: baseline;padding: 2px 4px;background-color: #77ecff;color: #000000;">${obj.listas.transferencia_total}</span>
                  ` : ``

                  clubeHtml = obj.listas.clube_total ? `
                  <span title="Quantidade aproximada de cartas valiosas no clube por overal" class="badge badge-info badge-plataforma text-uppercase font-size-8" style="vertical-align: baseline;padding: 2px 4px;background-color: #edc8ed;color: #000000;">${obj.listas.clube_total}</span>
                  ` : ``
                }

                if (!obj.proxyUrl && obj.proxy) {
                  obj.proxyUrl = `${obj.proxy.protocolo}://${obj.proxy.address}`
                }


                data = `<div class="media align-items-center">
                      ${viewImageConta}
                      <div class="media-body" style="line-height: 10px;">
                          <span class="badge badge-secondary badge-plataforma text-uppercase font-size-8"
                            style="vertical-align: baseline;">
                            ${obj.dadosEa.plataforma}
                          </span>

                          <span class="badge badge-info mr-0" data-html="true"
                          data-container="body" data-toggle="popover" data-color="default" data-placement="top"
                          data-content="${obj.proxyUrl ? obj.proxyUrl : ''}" data-original-title="${obj.proxyUrl ? obj.proxyUrl : ''}" title="${obj.proxyUrl ? obj.proxyUrl : ''}"
                          style="padding: 2px 2px 2px 2px;text-transform: uppercase;font-weight: 600;font-size: 10px;border: 1px solid #cbcbcb;color: #000000;${obj.proxy && obj.proxyUrl && (_.contains(Util.ARRAY_STATUS_CONTA_WEBAPP_ABERTO, obj.status) || obj.status == Util.STATUS_CONTA_BANIDA) ? '' : 'display: none;'}">
                          <span class="text-black font-size-8"><i class="fa-solid fa-globe m-0"></i></span>
                          <small style="font-weight: 600;">${obj.proxy ? obj.proxy.address : 'proxy'}</small>
                          </span>

                         ${cemiterioHtml}
                         ${transferenciaHtml}
                         ${clubeHtml}

                          <button type="button" class="btn btn-sm btn-link btn-info-agenda mr-0" data-html="true"
                          data-container="body" data-toggle="popover" data-color="default" data-placement="top"
                          data-content='${strDataPopovers ? strDataPopovers : ''}' data-original-title="" title=""
                          style="padding: 0px 0px 0px 0px;${strDataPopovers ? '' : 'display: none;'}">
                          <i class="ni ni-calendar-grid-58 text-primary"
                          style="font-size: 11px;vertical-align: inherit;"></i>
                          </button>

                          <br />
                        <span class="name mb-0 text-sm conta-clube-nome font-size-10 bold-600 text-uppercase">${obj.dadosEa.clubeName}</span><br />
                        <span class="partidas" style="font-size: 9px;">${partidas}</span><br />
                        <span class="email-conta" style="font-size: 9px;">${obj.email}</span>
                      </div>
                </div>`

                return data;
              }
            },
            {
              targets: 2,
              // searchPanes: {
              //   show: true,
              //   header: 'Status',
              //   options: [
              //     {
              //       label: 'executando',
              //       value: function (obj: IConta, rowIdx: any) {
              //         return !obj.status;
              //       }
              //     },
              //     {
              //       label: 'aberta',
              //       value: function (obj: IConta, rowIdx: any) {
              //         return obj.status;
              //       }
              //     },
              //     {
              //       label: 'captcha solicitado',
              //       value: function (obj: IConta, rowIdx: any) {
              //         return obj.status;
              //       }
              //     }
              //   ]
              // },
              className: "status text-center",
              render: (data: any, type: any, obj: IConta, meta: any) => {
                if (type == 'sort') {
                  return Util.getSortByStatusConta(obj.status);
                }

                let execucao = obj.status == Util.STATUS_CONTA_EXECUCAO && obj.execucao && obj.execucao.funcionamentoAtual ? obj.execucao.funcionamentoAtual.filtro.toString() : ``
                let cronometro = obj.status == Util.STATUS_CONTA_EXECUCAO ? `
                <div class="cronometro${obj.id}" style="height: 1px;">
                  <span class="text-muted">
                      <span class="spinner-border spinner-border-sm" role="status" style="width: 0.8rem;height: 0.8rem;"
                          aria-hidden="true"></span>
                      <span class="sr-only">Loading...</span>
                      <span class="values font-size-12 text-muted font-weight-600"></span>
                  </span>
                </div>` : ''
                // let cronometro = `
                //     <span class="cronometro${obj.id} text-muted" style="${obj.status == Util.STATUS_CONTA_EXECUCAO ? '' : 'display:none;'}">
                //       <span class="spinner-border spinner-border-sm" role="status" style="width: 0.8rem;height: 0.8rem;" aria-hidden="true"></span><span class="sr-only">Loading...</span>
                //       <span class="values font-size-12 text-muted font-weight-600"></span>
                //     </span>`

                let objStatus = Util.getStatusDescContaById(obj.status)
                let statusNavegador = obj.navegador_status == true && obj.status == Util.STATUS_CONTA_BANIDA ? `<span class="conta-navegador-aberto${obj.id} badge badge-info text-uppercase">Aberta</span><br />` : ``;
                data = `
                <span class="badge badge-${objStatus.class} text-uppercase">${objStatus.status}</span><br />
                ${statusNavegador}
                ${cronometro}
                <br />
                <p title="Filtro" class="mt-0 mb-0 text-center text-limit-150 text-sm font-size-10" style="${!execucao ? 'display:none;' : ''}">
                  <small class="text-muted">
                    <span class="text-muted mr-2"><i class="fas fa-funnel-dollar"></i>&nbsp;<span class="info-filtro">${execucao}</span></span><br />
                  </small>
                </p>
                `
                return data;
              }
            },
            {
              targets: 3,
              // searchPanes: {
              //   show: false
              // },
              render: function (data: any, tipo: any, obj: IConta, meta: any) {

                return `<span class="mr-2"><i class="ni ni-money-coins" style="color: #fff18e;"></i>
                <span class="coins font-size-12">${obj.dadosEa.coins.toLocaleString('pt-BR')}</span>
                </span>`
              }
            },
            {
              targets: 4,
              // searchPanes: {
              //   show: false
              // },
              render: (data: any, tipo: any, obj: IConta, meta: any) => {
                let consolidado: IContaConsolidado = Util.getItemArrayById(this.arrayConsolidados, obj.id, {
                  id: obj.id, tempo_execucao: 0, captchas: 0, compras: 0, buscas: 0, vendas: 0, requests: 0, lucro: 0, ajuste_lucro: 0
                })

                var consolidadoLucro = this.getConsolidadoLucro(consolidado.lucro || 0, 'lucro')
                return `<a class="${consolidadoLucro.class} font-size-12 mr-2 btn-dt-ajustar-lucro btn btn-link p-0" data-ajuste-lucro="${consolidado.ajuste_lucro}" data-id-conta-ea="${obj.id}"><i class="${consolidadoLucro.classIcon}"></i> ${consolidadoLucro.valor.toLocaleString('pt-BR')}</a>`
              }
            },
            {
              targets: 5,
              className: "dmes",
              render: function (data: any, tipo: any, obj: IConta, meta: any) {
                if (!obj.dmes || obj.dmes.length === 0) {
                  return '<p class="font-size-12 text-limit-quebra-400">-</p>';
                }

                obj.dmes.sort((a: any, b: any) => b.challengesCount - a.challengesCount);

                const visibleDmes = obj.dmes.slice(0, 2); // Show the first two DMEs directly
                const collapsedDmes = obj.dmes.slice(2); // DMEs to be shown in the "Ver mais" section

                const visibleDmesHtml = visibleDmes
                  .map((dme: IConjuntoDmeResumido) => {
                    const circles = Array.from({ length: dme.challengesCount })
                      .map((_, index) => {
                        const isCompleted = (dme.timesCompleted && dme.timesCompleted > 0) || index < dme.challengesCompletedCount;
                        return `<span class="challenge-circle ${isCompleted ? "completed" : "pending"}"></span>`;
                      })
                      .join("");

                    return `
                      <div class="dme-item">
                        <div class="dme-info">
                          <span title="${dme.name}" class="dme-name font-weight-bold text-limit-150 font-size-12">${dme.name}</span>
                          <div class="challenge-circles">${circles}</div>
                        </div>
                      </div>
                    `;
                  })
                  .join("");

                if (collapsedDmes.length > 0) {
                  const collapsedDmesHtml = collapsedDmes
                    .map((dme: IConjuntoDmeResumido) => {
                      const circles = Array.from({ length: dme.challengesCount })
                        .map((_, index) => {
                          const isCompleted = (dme.timesCompleted && dme.timesCompleted > 0) || index < dme.challengesCompletedCount;
                          return `<span class="challenge-circle ${isCompleted ? "completed" : "pending"}"></span>`;
                        })
                        .join("");

                      return `
                        <div class="dme-item">
                          <div class="dme-info">
                            <span title="${dme.name}" class="dme-name font-weight-bold text-limit-150 font-size-12">${dme.name}</span>
                            <div class="challenge-circles">${circles}</div>
                          </div>
                        </div>
                      `;
                    })
                    .join("");

                  return `
                    <div class="dmes-container">
                      ${visibleDmesHtml}
                      <div class="dmes-toggle-container">
                        <a href="#" class="dmes-toggle" onclick="App.Util.toggleDmes(this)">Mais</a>
                      </div>
                      <div class="dmes-expanded" style="display: none;">
                        ${collapsedDmesHtml}
                      </div>
                    </div>
                  `;
                }

                return visibleDmesHtml; // If there are only two or fewer DMEs, return them directly
              }
            },
            {
              targets: 6,
              // searchPanes: {
              //   show: false
              // },
              className: "execucao",
              render: function (data: any, tipo: any, obj: IConta, meta: any) {
                let execucao = obj.status == Util.STATUS_CONTA_EXECUCAO && obj.execucao && obj.execucao.funcionamentoAtual ? obj.execucao.funcionamentoAtual.filtro.toString() : ``
                let strAgenda = obj.perfil && obj.perfil.dados && obj.perfil.dados.piloto_automatico ?
                  `<span class="badge badge-info" style="margin-left: 5px;color: #ffffff;font-size: 10px;background-color: #686868;cursor: auto;border: none;font-weight: 700;">PILOTO AUTO.</span>`
                  : (obj.perfil && obj.perfil.dados && obj.perfil.dados.filtros ? `<p style="word-wrap: break-word;width: 400px;white-space: normal;" class="m-0 pl-2 pr-2">${Util.getFiltrosGeralAgenda(obj.perfil.dados.filtros)}</p>` : ``)
                return `

              <div class="btn-group" style="border: 1px solid #b1bcff;border-radius: 6px;${obj.perfil && obj.perfil.id ? '' : 'display:none;'}">
                <div class="badge badge-secondary pl-0">
                  <a class="dropdown-toggle" data-toggle="dropdown" href="#" aria-expanded="false">
                      <span style="color: #504aff;font-weight: 700;"><i class="fas fa-cog ml-1 mr-1"></i>PERFIL:</span>
                      <span style="color: #6b6b6b !important;">&nbsp;${obj.perfil && obj.perfil.id ? obj.perfil.nome : ''}</span>
                      ${obj.filtros && $.isArray(obj.filtros) && obj.filtros.length ? `&nbsp;|&nbsp;<span class="text-uppercase mr-1" style="color: #ffffff;padding: 2px 6px 2px 6px;font-weight: 800;background-color: #9723f9;border-radius: 0px;"><i class="fas fa-filter mr-1"></i>Filtro Aplicado</span>` : ``}

                  </a>
                  <div class="dropdown-menu p-0 pt-1 pb-1" x-placement="top-start" style="max-width: 400px;position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(4px, 5px, 0px);border-radius: 3px;">
                    ${strAgenda}
                  </div>
                </div>
						  </div>


                <p class="m-0 mt-1 p-0 font-size-10">
                  ${obj.perfil && obj.perfil.dados && obj.perfil.dados.resolver_captcha_automaticamente ? `
                  <span>
                    <span class="badge badge-secondary" style="font-weight: 600;font-size: 8px;border: 1px solid #cbcbcb;">
                      <i class="fas fa-robot ml-1 mr-1"></i>AUTOCAPTCHA ATIVO
                    </span>
                  </span>`: ''}

                  ${obj.proxy ? `
                  <span data-html="true" data-container="body" data-toggle="popover" data-color="default" data-placement="top"
                  data-content="${obj.proxy.address}:${obj.proxy.port}" data-original-title="${obj.proxy.address}:${obj.proxy.port}" title="${obj.proxy.address}:${obj.proxy.port}">
                    <span class="badge badge-info" style="font-weight: 600;font-size: 8px;border: 1px solid #cbcbcb;">
                      <span style="color: #000000;font-weight: 700;"><i class="fa-solid fa-globe ml-1 mr-1"></i></i>${obj.proxy.address}:&nbsp;</span>
                      <span style="color: #414141;">${obj.proxy.nome}</span>
                    </span>
                  </span>`: ''}

                  ${obj.perfil && obj.perfil.api_venda_coins ? `
                  <span title="${obj.perfil.api_venda_coins.nome}">
                  <span class="badge badge-secondary" style="font-weight: 600;font-size: 8px;border: 1px solid #cbcbcb;">
                      <i class="fa-solid fa-dollar-sign ml-1 mr-1"></i>API ATIVA
                    </span>
                  </span>`: ''}

                </p>

                `
              }
            },

            {
              targets: 7,
              // searchPanes: {
              //   show: false
              // },
              className: "estatisticas",
              render: (data: any, tipo: any, obj: IConta, meta: any) => {
                let consolidado: IContaConsolidado = Util.getItemArrayById(this.arrayConsolidados, obj.id, {
                  id: obj.id, tempo_execucao: 0, captchas: 0, compras: 0, buscas: 0, vendas: 0, requests: 0
                })

                // var consolidadoProgressoBuscas = this.getProgressoDinamico(consolidado.buscas, 5500, 'buscas')
                var consolidadoProgressoCompras = this.getProgressoDinamico(consolidado.compras, 200, 'compras')
                // var consolidadoProgressoCaptchas = this.getProgressoDinamico(consolidado.captchas, 10, 'captchas')
                var consolidadoProgressoRequests = this.getProgressoDinamico(consolidado.requests, 6000, 'requests')
                var consolidadoProgressoTempoExecucao = this.getProgressoConsolidadoTempoExecucao(consolidado.tempo_execucao)

                var htmlEstatisticasBuscasCaptchas = ``;
                // var htmlEstatisticasBuscasCaptchas = `
                // <div class="col pl-2 p-0">
                // <div class="">
                //   <span class="completion mr-2" style="font-size: 10px;">${consolidadoProgressoBuscas.valor} ${consolidadoProgressoBuscas.label}</span>
                // </div>
                // <div class="progress" style="width: 70%;">
                //   <div class="progress-bar" role="progressbar" aria-valuenow="${consolidadoProgressoBuscas.valor}" aria-valuemin="0" aria-valuemax="${consolidadoProgressoBuscas.limite}" style="width: ${consolidadoProgressoBuscas.percent}%;background-color: ${consolidadoProgressoBuscas.color};"></div>
                // </div>
                // </div>
                // <div class="col pl-2 p-0">
                //     <div class="">
                //       <span class="completion mr-2" style="font-size: 10px;">${consolidadoProgressoCaptchas.valor} ${consolidadoProgressoCaptchas.label}</span>
                //     </div>
                //     <div class="progress" style="width: 70%;">
                //       <div class="progress-bar" role="progressbar" aria-valuenow="${consolidadoProgressoCaptchas.valor}" aria-valuemin="0" aria-valuemax="${consolidadoProgressoCaptchas.limite}" style="width: ${consolidadoProgressoCaptchas.percent}%;background-color: ${consolidadoProgressoCaptchas.color};"></div>
                //     </div>
                // </div>`

                return `
                       <div class="row pl-2">
                          <div class="col pl-2 p-0">
                            <div class="">
                              <span class="completion mr-2" style="font-size: 10px;">${consolidadoProgressoCompras.valor} ${consolidadoProgressoCompras.label}</span>
                            </div>
                            <div class="progress" style="width: 70%;">
                              <div class="progress-bar" role="progressbar" aria-valuenow="${consolidadoProgressoCompras.valor}" aria-valuemin="0" aria-valuemax="${consolidadoProgressoCompras.limite}" style="width: ${consolidadoProgressoCompras.percent}%;background-color: ${consolidadoProgressoCompras.color};"></div>
                            </div>
                          </div>
                          ${htmlEstatisticasBuscasCaptchas}
                          <div class="col pl-2 p-0">
                              <div class="">
                                <span class="completion mr-2" style="font-size: 10px;">${consolidadoProgressoTempoExecucao.tempo} ${consolidadoProgressoTempoExecucao.label}</span>
                              </div>
                              <div class="progress" style="width: 70%;">
                                <div class="progress-bar" role="progressbar" aria-valuenow="${consolidadoProgressoTempoExecucao.tempo}" aria-valuemin="0" aria-valuemax="${consolidadoProgressoTempoExecucao.limite}" style="width: ${consolidadoProgressoTempoExecucao.percent}%;background-color: ${consolidadoProgressoTempoExecucao.color};"></div>
                              </div>
                          </div>
                          <div class="col pl-2 p-0">
                              <div class="">
                                <span class="completion mr-2" style="font-size: 10px;">${consolidadoProgressoRequests.valor} ${consolidadoProgressoRequests.label}</span>
                              </div>
                              <div class="progress" style="width: 70%;">
                                <div class="progress-bar" role="progressbar" aria-valuenow="${consolidadoProgressoRequests.valor}" aria-valuemin="0" aria-valuemax="${consolidadoProgressoRequests.limite}" style="width: ${consolidadoProgressoRequests.percent}%;background-color: ${consolidadoProgressoRequests.color};"></div>
                              </div>
                          </div>
                          <div class="col-1 pl-0 p-0">
                              <a class="btn btn-link btn-ver-mais font-size-10 text-primary m-0 p-0" data-id-conta-ea="${obj.id}">ver mais...</a>
                          </div>
                       </div>
                       `
              }
            },
            {
              targets: 8,
              // searchPanes: {
              //   show: false
              // },
              className: "acoes",
              render: (data: any, tipo: any, obj: IConta, meta: any) => {
                let statusViewAcoes = this.getStateViewAcoes(obj.id, obj.status)
                let menuVenderCoins = ``;
                let menuResolverDme = ``;
                let menuAtualizarQuantidadeItensClube = ``;
                let menuCorrigirBugEa = ``;

                menuCorrigirBugEa = ` <a href="javascript:void(0)" data-id-conta-ea="${obj.id}" title="" class="dropdown-item btn-iniciar-correcao-bug-ea">
                🐛 Corrigir Bug EA
                </a>`

                if (obj.perfil && obj.perfil.api_venda_coins && !this.infoPlanoAtual.ehPlanoCloud) {
                  menuVenderCoins = ` <a href="javascript:void(0)" data-id-conta-ea="${obj.id}" title="Executar venda de coins se estiver habilitado e no nomento permitido de venda de acordo com suas configurações de API" class="dropdown-item btn-iniciar-venda-de-coins-imediata">
                  <i class="fa-solid fa-dollar-sign"></i>Executar Venda Coins
                  </a>`
                }

                menuResolverDme = ` <a href="javascript:void(0)" data-id-conta-ea="${obj.id}" title="Iniciar tarefa para resolver dme" class="dropdown-item btn-iniciar-resolver-dme-imediato">
                  <i class="fa-solid fa-dollar-sign"></i>Resolver DME GC
                  </a>`

                if (obj.status == Util.STATUS_CONTA_ABERTA || obj.status == Util.STATUS_CONTA_PARADA) {
                  menuAtualizarQuantidadeItensClube = ` <a href="javascript:void(0)" data-id-conta-ea="${obj.id}" title="Atualiza informações de quantidade de jogadores negociáveis do clube por range overall informado nas configurações gerais" class="dropdown-item btn-atualizar-info-jogadores-clube">
                  <i class="fas fa-sync-alt"></i>Atualizar Info Jogadores Clube
                  </a>`
                }

                if (!obj.loadList && obj.status == Util.STATUS_CONTA_VENDENDO_COINS) {
                  obj.loadList = { texto: "Vendendo Coins...", exibirBotaoCancelar: true }
                }

                let loadingConta = obj.loadList ? `
                <div id="loadListConta${obj.id}" class="col-md-12 load-list-conta" style="padding: 10px;width: 98.8%;background-color: #ececec;opacity: 0.9;z-index: 4;border-radius: 5px;position: absolute;left: 0px;">
                  <div class="text-center pt-1">
                    <div class="spinner-border" style="width: 1.2rem;height: 1.2rem;" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <span class="text-load pb-1 mb-0" style="font-size: 12px;font-weight: 600;"> ${obj.loadList.texto}</span>
                    ${obj.loadList.exibirBotaoCancelar ? `<a class="btn-danger btn-condicional btn-cancelar-venda-coins" data-id-conta-ea="${obj.id}" style="cursor: pointer;border-radius: 4px;padding: 1px 3px;color: #ffffff;text-transform: uppercase;font-size: 9px;position: absolute;top: 51px;left: 48%;cursor: pointer;">cancelar</a>` : ''}
                    <a class="btn-link btn-fechar-load-list" onclick="$(this).parents('.load-list-conta').hide()" style="cursor: pointer">x</a>
                  </div>
                </div>` : ``

                let versao = obj.versao && obj.versao != "1" && !this.infoPlanoAtual.ehPlanoCloud ? `<span class="badge badge-primary mr-1 p-2" style="background-color: #ffe077;color: #000000;font-size: 12px;border-radius: 14px;font-weight: 700;" title="Usando a versão ${obj.versao}, escolhida no perfil da conta">V${obj.versao}</span>` : ``

                let infoExecucao = `
                <div class="row mt-1 justify-content-end">
                  <div class="d-flex flex-column pr-3 text-muted" style="line-height: 12px;">
                    ${obj.ultima_execucao ? `<span title="Ultima execução de tarefa automática" class="text-muted" style="font-size: 9px;"><span class="text-uppercase"><i class="fas fa-clock mr-1"></i></span><span class="font-weight-bold">${Util.parseDataUtcStringToDateLocale(obj.ultima_execucao)}</span></span>` : ``}
                    ${obj.limite_atingido && obj.limite_atingido >= Util.getDateStringDefault() ? `<span title="tarefa automática encerrada no dia" class="text-muted" style="font-size: 9px;"><span class="text-uppercase"><i class="fa-solid fa-lock"></i></span><span class="font-weight-bold">${Util.parseDataUtcStringToDateLocale(obj.limite_atingido)}</span></span>` : ``}
                  </div>
                </div>
                `

                data =
                  `<div class="" style="float: right;">
                  <div class="row justify-content-end">
                  ${versao}

                      <a data-id-conta-ea="${obj.id}" href="javascript:void(0)" class="btn-autenticar btn btn-sm btn-outline-default line-height-0-2 pt-2" title="O sistema irá autenticar sua conta EA" style="${statusViewAcoes.btnAutenticar ? '' : 'display: none;'}">
                      Autenticar
                      </a>

                      <a data-id-conta-ea="${obj.id}" href="javascript:void(0)" class="btn-sincronizar-conta-local btn btn-sm btn-outline-default line-height-0-2 pt-2" title="O sistema irá sincronizar sua conta com a máquina local"
                      style="color: #ef8411;border-color: #ef8411; ${obj.tem_diretorio === false ? '' : 'display: none;'}">
                      sincronizar com database
                      </a>

                      <a data-id-conta-ea="${obj.id}" style="${statusViewAcoes.btnResolverCatptcha ? 'display: none;' : ''}" id="abrirSniper${obj.id}" style="${statusViewAcoes.btnAbrirSniper ? '' : 'display: none;'}" href="javascript:void(0)" class="abrir-sniper btn btn-sm btn-default line-height-0-2" title="Abrir Sniper">
                      <i class="fa-solid fa-play"></i>
                      </a>
                      <a href="javascript:void(0)" style="" data-id-conta-ea="${obj.id}" title="Exibir a janela do WebApp da sua conta" class="btn btn-sm btn-outline-default btn-mostrar-telawebapp">
                              <i class="fa-solid fa-eye"></i> ${statusViewAcoes.btnResolverCatptcha ? 'Resolver no Preview' : ''}
                      </a>
                      <a data-id-conta-ea="${obj.id}" style="${statusViewAcoes.btnPararTarefa ? '' : 'display: none;'}" href="javascript:void(0)" class="btn-parar-tarefa btn btn-sm btn-outline-danger line-height-0-2" title="O sistema irá para a tarefa atual na conta">
                      <i class="fa fa-stop"></i>
                      </a>
                      <a data-id-conta-ea="${obj.id}" style="${statusViewAcoes.btnResolverCatptcha ? '' : 'display: none;'}" href="javascript:void(0)" class="btn-resolver-captcha-auto btn btn-sm btn-outline-danger line-height-0-2 pt-2" title="O sistema tentará resolver o captcha de forma automática">
                      Resolver Auto.
                      </a>
                      <a data-id-conta-ea="${obj.id}" style="${statusViewAcoes.btnResolverCatptcha && !this.infoPlanoAtual.ehPlanoCloud ? '' : 'display: none;'}" href="javascript:void(0)" class="btn-resolver-captcha btn btn-sm btn-outline-danger line-height-0-2 pt-2" title="O sistema irá abrir o navegador com sua conta EA para você resolver o captcha">
                      Resolver Manual
                      </a>
                      <a data-id-conta-ea="${obj.id}" style="${statusViewAcoes.btnPararVendaCoins ? '' : 'display: none;'}" href="javascript:void(0)" class="btn-cancelar-venda-coins btn btn-sm btn-outline-danger line-height-0-2" title="Parar a venda de coins agora">
                      <i class="fa fa-stop"></i>
                      </a>

                      <div class="dropdown">
                        <button type="button" class="btn btn-sm btn-secondary line-height-0-2 padding-bt" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fas fa-ellipsis-h"></i></button>
                        <div class="dropdown-menu dropdown-menu-right">
                          <a data-id-conta-ea="${obj.id}" href="javascript:void(0)" class="dropdown-item btn-acessar" title="Abrir navegador com a conta logada"><i class="ni ni-controller text-success"></i>Abrir
                          WebApp
                          </a>

                          <a data-id-conta-ea="${obj.id}" href="javascript:void(0)" class="dropdown-item btn-fechar-sniper" title="O sistema irá fechar o navegador da respectiva conta EA">
                          <i class="fa fa-window-close"></i>Fechar
                          WebApp
                          </a>

                         ${menuVenderCoins}

                         ${menuResolverDme}

                         ${menuAtualizarQuantidadeItensClube}

                         ${menuCorrigirBugEa}

                          <a data-id="${obj.id}" href="javascript:void(0)" class="dropdown-item" data-toggle="modal" data-target="#modalConfigCredenciais${obj.id}" title="Configurar conta"><i class="ni ni-key-25 text-success"></i>Credenciais
                          </a>

                          <a href="javascript:void(0)" data-id-conta-ea="${obj.id}" class="dropdown-item remover-conta">
                            <i class="fa fa-trash text-danger"></i>Excluir Conta
                          </a>

                        </div>
                      </div>

                      <div class="ligar-desligar-conta mr-2">
                        <label class="custom-toggle custom-toggle-success mr-2"">
                          <input type="checkbox" ${this.conectado ? '' : 'disabled'} data-id-conta-ea="${obj.id}" ${obj.agenda_ativa ? 'checked' : ''}  name="agenda_ativa">
                          <span class="custom-toggle-slider rounded-circle" data-label-off="Desl" data-label-on="Lig"></span>
                        </label>
                      </div>

                        ${loadingConta}
                    </div>
                    ${infoExecucao}
                  </div>
                  `
                return data;
              }
            }
          ],

        });

        this.inicializarEventosDataTables()
        $.each(dataContas, (index: any, conta: IConta) => {
          if (conta.status == Util.STATUS_CONTA_EXECUCAO) {
            // console.log("ARRAY", conta.id, conta.status)
            this.atualizarViewFuncionamentoAtual(conta.id, conta.status, conta.navegador_status);
          }
        });
      }
    }

    public updateStatusContaDatatable(idConta: number, status: number, dadosFuncionamentoAtual: IFuncionamentoAtual = null, tarefa: ITarefa = null, navegador_status: boolean) {
      let rowConta = App.Business.objDataTableContas.row(`#${idConta}`)
      if (rowConta.length) {
        let objConta: IConta = rowConta.data()

        objConta.status = status
        objConta.navegador_status = navegador_status
        objConta.execucao = { funcionamentoAtual: dadosFuncionamentoAtual, tarefaAtual: tarefa }

        this.tarefasSniperContas[idConta] = tarefa
        this.arrayContas = Util.updateOrCreateItemArrayById(this.arrayContas, objConta.id, objConta)
        rowConta.data(objConta).draw();

        this.atualizarViewFuncionamentoAtual(idConta, status, navegador_status);
        this.ordenaListagemDeContas(idConta, status)
      }
    }

    public updateCoinsContaDatatable(idConta: number, coins: number) {
      let rowConta = App.Business.objDataTableContas.row(`#${idConta}`)
      if (rowConta.length) {
        let objConta: IConta = rowConta.data()
        objConta.dadosEa.coins = coins
        this.arrayContas = Util.updateOrCreateItemArrayById(this.arrayContas, objConta.id, objConta)
        rowConta.data(objConta).draw();
      }
      this.updateCoinsGeralPorPlataforma()
    }

    public updateAgendaContaDatatable(idConta: number, programacao: string[]) {
      let rowConta = App.Business.objDataTableContas.row(`#${idConta}`)
      if (rowConta.length) {
        let objConta: IConta = rowConta.data()
        objConta.programacao = programacao
        this.arrayContas = Util.updateOrCreateItemArrayById(this.arrayContas, objConta.id, objConta)
        rowConta.data(objConta).draw();
      }
    }

    public updateDadoContaDatatable(idConta: number, prop: string, valor: any) {
      let rowConta = App.Business.objDataTableContas.row(`#${idConta}`)
      if (rowConta.length) {
        let objConta: any = rowConta.data()
        objConta[prop] = valor
        this.arrayContas = Util.updateOrCreateItemArrayById(this.arrayContas, objConta.id, objConta)
        rowConta.data(objConta).draw();
      }
    }
    public updateDadoContaArrayContas(idConta: number, prop: string, valor: any) {
      let objConta: any = Util.getItemArrayById(this.arrayContas, idConta)
      if (objConta) {
        objConta[prop] = valor
        this.arrayContas = Util.updateOrCreateItemArrayById(this.arrayContas, objConta.id, objConta)
      }
    }

    public updateLucroContaDatatable(idConta: number, lucro: number) {
      let consolidado: IContaConsolidado = Util.getItemArrayById(this.arrayConsolidados, idConta)
      consolidado.lucro = lucro
      this.arrayConsolidados = Util.updateOrCreateItemArrayById(this.arrayConsolidados, idConta, consolidado)
      let rowConta = App.Business.objDataTableContas.row(`#${idConta}`)
      if (rowConta.length) {
        rowConta.draw();
      }
      this.updateLucroGeralPorPlataforma();
    }

    public updateContaDatatable(objConta: IConta) {
      let rowConta = App.Business.objDataTableContas.row(`#${objConta.id}`)
      if (rowConta.length) {
        this.arrayContas = Util.updateOrCreateItemArrayById(this.arrayContas, objConta.id, objConta)
        rowConta.data(objConta).draw();
      }
    }

    public updateConsolidadosContaDatatable(idConta: number, consolidado: IContaConsolidado) {
      // console.log("updateConsolidadosContaDatatable", idConta, consolidado)
      this.arrayConsolidados = Util.updateOrCreateItemArrayById(this.arrayConsolidados, consolidado.id, consolidado)
      let dadosAtt = App.Business.objDataTableContas.row(`#${idConta}`).data()
      App.Business.objDataTableContas.row(`#${idConta}`).data(dadosAtt).draw()
    }

    private exibirLoadListConta(id: number, txt: string = "Carregando...", exibirBotaoCancelar: boolean = false) {
      try {
        let rowConta = App.Business.objDataTableContas.row(`#${id}`)
        if (rowConta.length) {
          let objConta: IConta = rowConta.data()
          objConta.loadList = { texto: txt, exibirBotaoCancelar: exibirBotaoCancelar }
          this.arrayContas = Util.updateOrCreateItemArrayById(this.arrayContas, objConta.id, objConta)
          rowConta.data(objConta).draw();
        }
      } catch (e) { }
    }

    private ocultarLoadListConta(id: number) {
      let rowConta = App.Business.objDataTableContas.row(`#${id}`)
      if (rowConta.length) {
        let objConta: IConta = rowConta.data()
        objConta.loadList = null
        this.arrayContas = Util.updateOrCreateItemArrayById(this.arrayContas, objConta.id, objConta)
        rowConta.data(objConta).draw();
      }
    }

    private aoLigarDesligarAgenda(e: JQueryEventObject) {
      let idConta = $(e.currentTarget).data("idContaEa")
      let ligado = $(e.target).is(':checked');
      // console.log("aoLigarDesligarAgenda", idConta, ligado)
      this.updateDadoContaArrayContas(idConta, 'agenda_ativa', $(e.target).is(':checked'))
      this.ajax = new App.Ajax();
      this.ajax.postAcao(App.Util.config.urlSalvarContaEa, { id_conta_ea: idConta, agenda_ativa: ligado }, (obj: { dadosEnviados: { agenda_ativa: boolean, id_conta_ea: number }, dadosRetornados: { conta: IConta, status: boolean } }) => {
        if (obj.dadosRetornados && obj.dadosRetornados.status) {
          // console.log("MANDAR REAGENDAR", obj)
          this.atualizarContaNoPlugin({ id: idConta })
        }
        this.avisarSobreReagendamentoPluginDesconectado()
      })
    }

    private updateLucroGeralPorPlataforma() {
      let resultadoSomaLucro = { consoles: 0, pc: 0 }
      let somaLucro = this.arrayConsolidados.reduce((accumulator, consolidado: IContaConsolidado) => {
        try {
          let objConta: IConta = Util.getItemArrayById(this.arrayContas, consolidado.id)
          objConta.dadosEa.plataforma != "PC" ? resultadoSomaLucro.consoles += consolidado.lucro : resultadoSomaLucro.pc += consolidado.lucro;
        } catch (e) {
          return accumulator + 0;
        }

        return accumulator + consolidado.lucro;
      }, 0);

      for (var [key, value] of (Object as any).entries(resultadoSomaLucro)) {
        let lucroFormatado = this.getConsolidadoLucro(value, 'lucro');
        $(`.info-lucro-geral-${key}`).html(`<span class="${lucroFormatado.class} font-size-10 mr-2"><i class="${lucroFormatado.classIcon}"></i> ${lucroFormatado.valor.toLocaleString('pt-BR')}</span>`)
      }
    }

    private updateCoinsGeralPorPlataforma() {
      let resultadoSomaCoins = { consoles: 0, pc: 0 }
      let somaCoins = this.arrayContas.reduce((accumulator, conta: IConta) => {
        conta.dadosEa.plataforma != "PC" ? resultadoSomaCoins.consoles += conta.dadosEa.coins : resultadoSomaCoins.pc += conta.dadosEa.coins;
        return accumulator + conta.dadosEa.coins;
      }, 0);

      $(`.info-coins-geral`).html(`<span class="font-size-10 mr-2"><i class=""></i> ${somaCoins.toLocaleString('pt-BR')}</span>`)
      // for (var [key, value] of (Object as any).entries(resultadoSomaCoins)) {
      //   $(`.info-coins-geral-${key}`).html(`<span class="font-size-10 mr-2"><i class=""></i> ${value.toLocaleString('pt-BR')}</span>`)
      // }
    }

    private aoVerEstatisticas(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      //console.log("aoVerEstatisticas", idConta)
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_GET_ESTATISTICAS_CONTA, { id: idConta }, (response: IRespostaMensagem) => {
        //console.log("RESP Estatisticas", response)
        this.iniciarEstatisticas(response.result)
      });
    }

    private iniciarEstatisticas(historicoConsolidado: IContaConsolidado[]) {
      if (!historicoConsolidado.length) {
        return;
      }

      this.chartJsLucro = this.iniciarEstatiticasDinamico("graficoEstatisticasLucro", historicoConsolidado, 'lucro', 'Lucro', 'Lucro Diário', this.chartJsLucro)
      this.chartJsCaptchas = this.iniciarEstatiticasDinamico("graficoEstatisticasCaptchas", historicoConsolidado, 'captchas', 'Captchas', 'Captchas Diário', this.chartJsCaptchas, null, null, null, { positivo: "#ffb60094", negativo: "#c6c6c694" })
      this.chartJsRequests = this.iniciarEstatiticasDinamico("graficoEstatisticasRequests", historicoConsolidado, 'requests', 'Requests', 'Requests Diário', this.chartJsRequests, null, null, null, { positivo: "#da6aff94", negativo: "#c6c6c694" })

      if (!this.infoPlanoAtual.ehPlanoCloud) {
        this.chartJsVendasApi = this.iniciarEstatiticasDinamico("graficoEstatisticasVendasApi", historicoConsolidado, 'venda_coins.itens_vendidos', 'Vendas Api', 'Vendas Api Diária', this.chartJsVendasApi, null, null, null, { positivo: "#aac18a", negativo: "#c6c6c694" })
      }

      this.chartJsTempoUso = this.iniciarEstatiticasDinamico("graficoEstatisticasTempoUso", historicoConsolidado, 'tempo_execucao', 'Tempo Uso', 'Tempo uso diário', this.chartJsTempoUso, null, (tempo_execucao: any) => {
        var consolidadoProgressoTempoExecucao = this.getProgressoConsolidadoTempoExecucao(tempo_execucao)
        return consolidadoProgressoTempoExecucao.tempo + ' ' + consolidadoProgressoTempoExecucao.labelAbreviado;
      }, (mediaTotal: any) => {
        var mili = Util.parseSegundosParaMilisegundos(mediaTotal)
        return Util.getDescricaoHumanaMilissegundos(mili);
      }, { positivo: "#d9bd8494", negativo: "#c6c6c694" })

      this.chartJsComprasBuscas = this.iniciarEstatiticasComprasBuscas("graficoEstatisticasComprasBuscas", historicoConsolidado, this.chartJsComprasBuscas, null, (valor: any, context: any) => {
        // return valor + " " + context.dataset.label;
        return valor;
      })

      $("#modalEstatisticas").modal("show")
    }

    private iniciarEstatiticasComprasBuscas(seletorId: string, historicoConsolidado: any[], varGlobal: any = null, metodoFormatValue: any = null, metodoFormatDataLabels: any = null) {
      let labels = [];
      let backgroundColorsCompras = [];
      let backgroundColorsBuscas = [];
      let dadosCompras = [];
      let dadosBuscas = [];
      let totalCompras: any = 0;
      let totalBuscas: any = 0;
      let mediaCompras: any = 0;
      let mediaBuscas: any = 0;
      for (let consolidado of historicoConsolidado) {
        labels.push(consolidado.created_at)
        let dadoHistCompras = metodoFormatValue ? metodoFormatValue(consolidado.compras) : consolidado.compras;
        let dadoHistBuscas = metodoFormatValue ? metodoFormatValue(consolidado.buscas) : consolidado.buscas;
        totalCompras += dadoHistCompras
        totalBuscas += dadoHistBuscas
        dadosCompras.push(metodoFormatValue ? metodoFormatValue(consolidado.compras) : consolidado.compras)
        dadosBuscas.push(metodoFormatValue ? metodoFormatValue(consolidado.buscas) : consolidado.buscas)
        if (dadoHistCompras < 0) {
          backgroundColorsCompras.push("#f7446a94")
        } else {
          backgroundColorsCompras.push("#55f1cd9c")
        }
        if (dadoHistBuscas < 0) {
          backgroundColorsBuscas.push("##ffb60094")
        } else {
          backgroundColorsBuscas.push("#5c9aff9c")
        }
      }
      mediaCompras = totalCompras / historicoConsolidado.length
      mediaBuscas = totalBuscas / historicoConsolidado.length
      this.updateViewItemEstatistica(parseInt(totalCompras), $(`.info-total-compras`));
      this.updateViewItemEstatistica(parseInt(mediaCompras), $(`.info-media-compras`));

      this.updateViewItemEstatistica(parseInt(totalBuscas), $(`.info-total-buscas`));
      this.updateViewItemEstatistica(parseInt(mediaBuscas), $(`.info-media-buscas`));

      let data = {
        labels: labels,
        datasets: [{
          label: "Compras",
          data: dadosCompras,
          backgroundColor: backgroundColorsCompras,
          borderColor: backgroundColorsCompras,
          borderWidth: 0
        },
        {
          label: "Buscas",
          data: dadosBuscas,
          backgroundColor: backgroundColorsBuscas,
          borderColor: backgroundColorsBuscas,
          borderWidth: 0
        }]
      }

      if (varGlobal) {
        varGlobal.destroy();
        varGlobal = null
      }

      let classChartJs = new ChartJs();
      varGlobal = classChartJs.inicializarCampo(seletorId, data, "Compras / Buscas", metodoFormatDataLabels);
      return varGlobal
    }

    private iniciarEstatiticasDinamico(seletorId: string, historicoConsolidado: any[], chave: any, label: string, text: string, varGlobal: any = null, metodoFormatValue: any = null, metodoFormatDataLabels: any = null, metodoFormatMediaTotal: any = null, objCores: { negativo: string, positivo: string } = { negativo: "#f7446a94", positivo: "#55f1cd9c" }) {
      let labels = [];
      let dados = [];
      let backgroundColors = [];
      let total: any = 0;
      let media: any = 0;
      for (let consolidado of historicoConsolidado) {
        let subChave = null
        chave = chave.split('.')
        if (chave.length > 1) {
          subChave = chave[1]
        }
        chave = chave[0]

        let dadoHist = metodoFormatValue ? metodoFormatValue(subChave ? consolidado[chave][subChave] : consolidado[chave]) : subChave ? consolidado[chave][subChave] : consolidado[chave];


        total += dadoHist
        labels.push(consolidado.created_at)
        dados.push(metodoFormatValue ? metodoFormatValue(subChave ? consolidado[chave][subChave] : consolidado[chave]) : subChave ? consolidado[chave][subChave] : consolidado[chave])
        if (dadoHist < 0) {
          backgroundColors.push(objCores.negativo)
        } else {
          backgroundColors.push(objCores.positivo)
        }
      }
      media = total / historicoConsolidado.length
      this.updateViewItemEstatistica(metodoFormatMediaTotal ? metodoFormatMediaTotal(total) : parseInt(total), $(`.info-total-${chave}`));
      this.updateViewItemEstatistica(metodoFormatMediaTotal ? metodoFormatMediaTotal(media) : parseInt(media), $(`.info-media-${chave}`));

      let data = {
        labels: labels,
        datasets: [{
          label: label,
          data: dados,
          backgroundColor: backgroundColors,
          borderColor: backgroundColors,
          borderWidth: 0
        }]
      }

      if (varGlobal) {
        varGlobal.destroy();
        varGlobal = null
      }

      let classChartJs = new ChartJs();
      varGlobal = classChartJs.inicializarCampo(seletorId, data, text, metodoFormatDataLabels);
      return varGlobal
    }

    private updateViewItemEstatistica(valor: number, el: JQuery) {
      let simbolo = '<i class="fas fa-arrow-up text-success mr-1"></i>'
      if (valor == 0) {
        simbolo = '<i class="fas fa-arrow-up text-white mr-1"></i>'
      } else if (valor < 0) {
        simbolo = '<i class="fas fa-arrow-down text-danger mr-1"></i>'
      }
      el.html(valor.toLocaleString('pt-BR'))
    }

    private getDadosEncontrarJogadoresParaSniper(idConta: number) {
      let elementoFormEncontrarJogSniper = $(`#formEncontrarJogadorParaSniper${(idConta)}`);

      return {
        id: idConta,
        url: elementoFormEncontrarJogSniper.find('input[name=url]').val() || null,
        overal: elementoFormEncontrarJogSniper.find('input[name=overal]').val() || null,
        precoProcura: elementoFormEncontrarJogSniper.find('input[name=preco_procura]').val() || null,
        lucroPorCarta: parseInt(elementoFormEncontrarJogSniper.find('input[name=lucro_por_carta]').val() || 500),
        tempoMinimoAtualizacaoPreco: (elementoFormEncontrarJogSniper.find('input[name=tempo_minimo_atualizacao_preco]').val() || 30) * 60,
        tentativas: parseInt(elementoFormEncontrarJogSniper.find('input[name=tentativas]').val() || 1)
      }
    }

    private aoBuscarJogadoresParaSnipar(e: JQueryEventObject) {
      let btnEncontrarJogador = $(e.currentTarget)
      btnEncontrarJogador.prop("disabled", true)
      let modalContexto = $(e.currentTarget).parents(".modal")
      let loader = modalContexto.find('.loader-modal')
      loader.show()
      var idConta = $(e.currentTarget).data('idContaEa');
      //console.log("aoBuscarJogadoresParaSnipar", idConta, this.getDadosEncontrarJogadoresParaSniper(idConta))
      $(`#tableJogadoresParaSniper${idConta} tbody tr`).remove();
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_GET_JOGADORES_PARA_SNIPAR, this.getDadosEncontrarJogadoresParaSniper(idConta), async (response: IRespostaMensagem) => {
        btnEncontrarJogador.prop("disabled", false)
        loader.hide()
        //console.log("RESP", response)
        if (response.result && response.result.length) {
          for await (const jogador of response.result) {
            $(`#tableJogadoresParaSniper${idConta} tbody`).append(`
            <tr>
              <td><a target="_blank" href="${jogador.url}"><b>${jogador.nome}</b></a><i class="fa-solid fa-link ml-1"></i></td>
                <td>${jogador.rating}</td>
                <td>${jogador.precoFutbin} coins</td>
                <td><b>${jogador.precoEa} coins</b></td>
                <td class="td-actions text-right">
                    <button type="button" rel="tooltip"
                        class="btn btn-success btn-icon btn-sm btn-aplicar-jogador-filtro" data-id-conta-ea="${idConta}" data-preco-ea="${jogador.precoEa}" data-preco-futbin="${jogador.precoFutbin}" data-id-jogador="${jogador.assetId}" data-original-title=""
                        title="">
                        <i class="fa fa-check pt-1"></i>
                    </button>
              </td>
            </tr>`);
          }
          $(`#tableJogadoresParaSniper${idConta}`).show()
        } else {
          toastr.warning(`Nenhum jogador para sniper encontrado com essa url.`, "Nada encontrado!");
          $(`#tableJogadoresParaSniper${idConta}`).hide()
        }
      });
    }

    private async aplicarJogadorFiltroSniper(jogadoresIds: any[], precoCompra: any = null) {
      var modalSniperPro = $("#modalSniperPro");
      let arrIdsAntigos = modalSniperPro.find('select[name="maskedDefId[]"]').val()
      let precoCompraAtual = modalSniperPro.find('input[name="maxBuyNow"]').val()
      jogadoresIds = jogadoresIds.concat(arrIdsAntigos);
      modalSniperPro.find("#searchclearSniperPro").click();
      this.filtrosEa.setCampoJogadorFiltroPro(jogadoresIds, App.Util.objPlayers, modalSniperPro.find('select[name="maskedDefId[]"]'), "#searchclearSniperPro");
      this.filtrosEa.setCampoInputCheckbox("ativar_venda_automatica", true);
      this.filtrosEa.setCampoInputCheckbox("precoInteligente", true);
      if (precoCompra && (jogadoresIds.length == 1 || precoCompra <= precoCompraAtual)) {
        this.filtrosEa.setCampoInputName("maxBuyNow", precoCompra);
      }
    }

    private async aoAplicarjogadorFiltro(e: JQueryEventObject) {
      let modalJogadoresEncontradosSniper = $(e.currentTarget).parents('.modal');
      let idConta = $(e.currentTarget).data('idContaEa');
      let idJogador = $(e.currentTarget).data('idJogador');
      let precoFutbin = $(e.currentTarget).data('precoFutbin');
      //console.log([idJogador], idConta)
      await this.aplicarJogadorFiltroSniper([idJogador], precoFutbin)

      modalJogadoresEncontradosSniper.modal('hide')
      $(`#abrirSniper${idConta}`).click()
    }

    private mostrarTelaWebApp(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_MOSTRAR_WEBAPP, { id: idConta }, (response: IRespostaMensagem) => { });
    }

    private aoSelecionarLigarDesligarTarefa(e: JQueryEventObject) {
      this.comunicacao.enviar(Util.ACAO_LIGAR_DESLIGAR_TAREFA, { status: $(e.target).is(':checked') }, (response: IRespostaMensagem) => {
        let campoSelecionado = $('input[name=tarefa_ligada]').is(':checked')
        if (response.result.tarefa_ligada) {
          toastr.success("Suas contas serão executadas de acordo com as configurações de perfil se existir.", "Tarefas ligada!")
          if (!campoSelecionado) {
            $('input[name=tarefa_ligada]').prop("checked", true)
          }
        } else {
          toastr.warning("Nenhuma de suas conta serão executadas enquanto essa opção estiver desligada.", "Tarefas desligada!")
          if (campoSelecionado) {
            $('input[name=tarefa_ligada]').prop("checked", false)
          }
        }
      });
    }

    private obterConfiguracaoGeralLocalAtualizada(callback: any = null) {
      App.Util.exibirLoadingFormModal($('.loading-form-modal'))
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_GET_CONFIGURACAO_GERAL, {}, (response: IRespostaMensagem) => {
        App.Util.ocultarLoadingFormModal($('.loading-form-modal'))
        if (response.status) {
          this.preencherConfiguracaoGeral(response.result);
        }
        if (callback) {
          callback()
        }
      });
    }

    private obterConfiguracaoGeralAtualizada(callback: any = null) {
      try {
        App.Util.exibirLoadingFormModal($('.loading-form-modal'))
        this.obterConfiguracaoGeralRemotaAtualizada((dadosSucesso: IRespostaSucessoAjx) => {
          App.Util.ocultarLoadingFormModal($('.loading-form-modal'))
          let dadosConfig: IConfiguracaoGeralBaseRemota = dadosSucesso ? dadosSucesso.dadosRetornados : null
          // console.log("DADOS CHEGOU obterConfiguracaoGeralAtualizada", dadosSucesso, dadosConfig)
          if (dadosConfig && dadosConfig.status && dadosConfig.dados) {
            this.elCheckBoxAtivarDesativarConfigRemota.prop('checked', dadosConfig.status)
            this.aoAtivarDesativarConfigRemota(null, dadosConfig.status, dadosConfig.dados)
            if (callback) {
              callback()
            }
          } else {
            if (callback) {
              this.obterConfiguracaoGeralLocalAtualizada(callback)
            }
          }
        })
      } catch (e) {
        console.log("ERROR: obterConfiguracaoGeralAtualizada", e)
      }
    }

    private preencherConfiguracaoGeral(configs: IConfiguracoesGeraisExecucao) {
      if (!configs) {
        return;
      }
      this.configuracoesGeraisExecucao = configs
      var form = $(`#formConfiguracoesGeralBot`)

      Util.preencherFormulario(form, configs)
    }

    private aoSelecionarTodosOsFiltros(e: JQueryEventObject) {
      try {
        var options = $('#filtro option');
        $('#filtro').val(options.map(function () { return this.value; }).get()).trigger('change');
      } catch (e) {
      }
    }
    private aoApagarTodosOsFiltros(e: JQueryEventObject) {
      try {
        $('#filtro').val("").trigger('change');
      } catch (e) {
      }
    }

    private aoClicarAjustarLucro(e: JQueryEventObject) {
      let form = $("#formAjustarLucro");
      let idConta = $(e.currentTarget).data('idContaEa');
      let ajusteLucro = $(e.currentTarget).data('ajusteLucro');
      form.find("input[name=id]").val(idConta)
      form.find("input[name=ajuste_lucro]").val(ajusteLucro ? ajusteLucro : "")
      $("#modalAjustarLucro").modal("show")
    }

    private ajustarLucro(e: JQueryEventObject) {
      let form = $(e.currentTarget).parents("form");
      let dadosForm: any = this.ajax.convertFormToJSON(form)
      let idConta = form.find("input[name=id]").val()
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_AJUSTAR_LUCRO, dadosForm, (response: IRespostaMensagem) => {
        //console.log("acrescerDecrescerLucro", response)
        if (response.status) {
          this.atualizarConsolidadoDaConta(idConta, response.result)
          toastr.success("Ajuste foi feito", "Sucessso!");
          $("#modalAjustarLucro").modal("hide")
        } else {
          toastr.warning("Verifique se sua conta já foi iniciada no dia de hoje, se não, inicie antes de ajustar o lucro.", "Ajuste não foi feito!");
        }
      });
    }

    private abrirContas() {
      if (!this.conectado) {
        return
      }

      let ids = this.getIdsContasSelecionadas()
      //console.log("abrirContas", ids);
      $("#modalAcoesContas").modal("hide")
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_ABRIR_CONTAS, ids, (response: IRespostaMensagem) => {
        //console.log("IMEDIATO::", response)
      });
    }

    private executarTarefaContas() {
      if (!this.conectado) {
        return
      }

      let ids = this.getIdsContasSelecionadas()
      //console.log("executarTarefaContas", ids);
      $("#modalAcoesContas").modal("hide")
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_INICIAR_TAREFA_IMEDIATA, ids, (response: IRespostaMensagem) => {
        //console.log("IMEDIATO::", response)
      });
    }

    private async executarVendaCoinsIdsContas() {
      try {
        if (!this.conectado) {
          return
        }

        let ids = this.getIdsContasSelecionadas()
        this.vendendoCoinsContaLista = true
        $("#modalAcoesContas").modal("hide")
        for await (let id of ids) {
          if (!this.vendendoCoinsContaLista) {
            return
          }

          let rowConta = App.Business.objDataTableContas.row(`#${id}`)
          if (rowConta.length) {
            let objConta: IConta = rowConta.data()
            if (objConta && objConta.dadosEa && objConta.perfil && objConta.perfil.api_venda_coins && objConta.perfil.api_venda_coins.dados && objConta.dadosEa.coins >= objConta.perfil.api_venda_coins.dados.minimo_coins_na_conta) {
              console.log("OBJ CONTA ROW::", objConta.perfil.api_venda_coins.dados.minimo_coins_na_conta, objConta.dadosEa.coins)
              $(`#${id} .btn-iniciar-venda-de-coins-imediata`).click()
              await this.util.esperar(App.Business.tempoMilisegundoEntreAberturaContaVendaCoins || 40000)
            }
          }
        }
      } catch (e) {
        console.log("ERROR Vender coins lista contas::", e)
      }
    }

    private updateEncontradosPorFiltro() {
      //TODO desabilitado temporariamente
      if (true) {
        return
      }
      try {
        this.comunicacao.enviar(Util.ACAO_COMUNICACAO_GET_ENCONTRADOS_POR_FILTRO, {}, (response: IRespostaMensagem) => {
          if (response && response.result) {
            this.updateViewEncontradosPorFiltro(response.result)
          }
        });
      } catch (e) {
        console.log("Erro updateEncontradosPorFiltro::", e)
      }
    }

    private updateViewEncontradosPorFiltro(arrEncontradosPorfiltro: any[]) {
      $("#espacoEncontradosPorFiltro").html('');
      $("#encontradosPorFiltro").hide()

      if (arrEncontradosPorfiltro.length) {
        let col = ``;
        $.each(arrEncontradosPorfiltro, (chave: string, objFt: { nome: string, quantidade: number, snipers: number }) => {
          col = `
          <div class="card card-body border card-plain border-radius-lg d-flex align-items-center flex-row pb-2 pt-2 mb-1">
              <i class="fas fa-filter mr-2 pt-1 text-muted"></i>

              <h6 class="mb-0 mr-2 text-muted font-size-8 pt-1">${objFt.nome}</h6>
              <span class="badge badge-pill badge-primary font-size-10 mr-2">${objFt.quantidade}</span>
              <span class="badge badge-pill badge-success font-size-10">${objFt.snipers || 0}</span>
          </div>
          `

          $("#espacoEncontradosPorFiltro").append(col);
        });
        $("#encontradosPorFiltro").show()
      } else {

        $("#espacoEncontradosPorFiltro").html('');
        $("#encontradosPorFiltro").hide()
      }
    }

    private getJogadoresMultRaridadesPorUrlFutbin(e: JQueryEventObject) {
      console.log("getJogadoresMultRaridadesPorUrlFutbin")
      this.fecharDropdownCriarFiltro()
      let paramsUrl: any = null
      try {
        $('.conteudo-loading-sniper-pro').modal('show')
        var idContaEa: any = $(e.currentTarget).data('idContaEa');
        var menuCriarFiltro: JQuery = $(e.currentTarget).parents('.menu-criar-filtro');
        var modalContentContexto: JQuery = $(e.currentTarget).parents('.modal-content');
        var url = menuCriarFiltro.find("input[name=campo_url_filtro_futbin]").val()
        var coinsDisponivel = menuCriarFiltro.find("input[name=campo_coins_disponivel]").val() || 100000
        var apenasPlaystyles = menuCriarFiltro.find("input[name=apenas_playstyles]").prop('checked');
        paramsUrl = new URLSearchParams(new URL(url).search);

        if (!url || !url.includes("futbin.com/players")) {
          toastr.warning("Parece que a Url informada não é uma url de filtro de jogadores futbin.", "URL Inválida!");
          $('.conteudo-loading-sniper-pro').modal('hide')
          return;
        }

        // if (paramsUrl.get('position') && (paramsUrl.get('position') as any).includes(",")) {
        //   toastr.warning("Tente usar filtros simples como ligas, clubes, paises ou posicoes. para posições, use as opções comuns aceitas no webapp.", "URL Incorreta!");
        //   $('.conteudo-loading-sniper-pro').modal('hide')
        //   return;
        // }
      } catch (e) {
        $('.conteudo-loading-sniper-pro').modal('hide')
        toastr.warning(`Algum erro ocorreu. ${e.message}`, "Erro!");
        return;
      }

      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_GET_FILTRO_MULT_RARIDADE_FUTBIN, { url: url, valo_minimo: coinsDisponivel, apenas_playstyles: apenasPlaystyles }, (response: IRespostaMensagem) => {
        try {
          //console.log("RESP::", response)
          if (response.status && response.result && response.result.length) {
            var filtro: IFiltroOptions = {
              id: null, nome: "Criacao de Filtro",
              "data": {
                "maskedDefId": null,
                "minBid": null,
                "maxBid": null,
                "quality": "",
                "icontraits": apenasPlaystyles ? "icontraits" : "",
                "rarity": _.pluck(response.result, 'rarityId'),
                "position": Util.parsePositionFutBinToFilterFsw(paramsUrl.get('position')) as any,
                "chemical": null,
                "nation": paramsUrl.get('nation') as any,
                "league": paramsUrl.get('league') as any,
                "club": paramsUrl.get('club') as any,
                "minBuyNow": null,
                "maxBuyNow": null,
                "variar": null,
                "turbo": null,
                "lucro": 15
              },
              "venda": null
            }
            this.preencherCamposModalSniperTarefaAtual(idContaEa, filtro);
            toastr.success(`O filtro criado foi aplicado, estime o lucro para conferi-lo`, "Filtro Criado!");
            $('.conteudo-loading-sniper-pro').modal('hide')
            this.informarLogFiltroCriado(coinsDisponivel, response.result, modalContentContexto, apenasPlaystyles)
          } else {
            $('.conteudo-loading-sniper-pro').modal('hide')
            toastr.info(`Nenhuma raridade encontrada que se encaixe nesse preço e URL`, "Não foi possível criar o filtro!");
          }

        } catch (e) {
          $('.conteudo-loading-sniper-pro').modal('hide')
          toastr.warning(`Algum erro ocorreu. ${e.message}`, "URL Incorreta!");
        }
      })
    }

    private informarLogFiltroCriado(coinsDisponivel: number, arrJogadoresfiltro: IJogadoresFiltroCriado[], modalContentContexto: JQuery, apenasPlaystyles: boolean = false) {
      let htmlListaJogadores = ``
      let jogadorPrecoMaisBaixo = arrJogadoresfiltro.length ? arrJogadoresfiltro[arrJogadoresfiltro.length - 1] : null

      for (let jogador of arrJogadoresfiltro) {
        htmlListaJogadores += `<p class="text-xs mt-1 mb-1 ${jogadorPrecoMaisBaixo && jogadorPrecoMaisBaixo.preco <= jogador.minPrice ? 'bg-incompativel' : ''}" style="line-height: 18px;padding: 2px 4px 2px 4px;border: 1px solid #d7d7d7;border-radius: 5px;font-size: 60% !important;background-color: #ffffff;"><i class="fa fa-user mr-1 text-muted" aria-hidden="true"></i><span class="font-size-11" style="font-weight: 500;">${jogador.nome} (${jogador.rating})</span>,
                                <span class="font-weight-bold">${jogador.precoDesc},</span>
                                <span class="text-normal">min: <span class="font-weight-bold ${jogadorPrecoMaisBaixo && jogadorPrecoMaisBaixo.preco <= jogador.minPrice ? 'text-warning' : ''}">${jogador.minPrice}</span>,</span>
                                <span class="font-weight-bold text-primary">${jogador.rarityNome}</span>
                               </p>`
      }
      const filtroComPlayStyles = apenasPlaystyles ? `<span class="font-size-12 font-weight-bold"><img width="25" height="25" src="https://cdn.futbin.com/design/img/icons/playstyles/26/plus/scoring-finesseshot.png">PlayStyles++</span>` : ``
      let htmlLog = `
                <li class="list-group-item px-0 py-1 mt-0 mb-1 lucro-estimado" style="background-color: #fbf8ff;">
                  <div class="ml-3 mb-1">
                      <span class="badge badge-success text-uppercase mb-2">Filtro Criado</span>
                      ${filtroComPlayStyles}
                      <button onclick="$(this).parents('li').remove()" type="button" class="close" style="float: right;"><span>×</span></button>
                  </div>
                  <div class="row col-md-12 p-0 m-0">
                      <div class="col" style="line-height: 13px;">
                          <small style="font-size: 76%;">Preço acima de:</small>
                          <h5 class="mb-0 mt-2">${coinsDisponivel}</h5>
                      </div>
                      <div class="col" style="line-height: 13px;">
                          <small style="font-size: 76%;">Possibilidades:</small>
                          <h5 class="mb-0 mt-2">${arrJogadoresfiltro.length}</h5>
                      </div>
                  </div>
                  <div class="row ml-2 mr-1 mt-2">
                          ${htmlListaJogadores}
                   </div>
                </li>
                `

      this.exibirLogFixo(modalContentContexto, htmlLog, "filtro-criado", true);
    }

    private exibirLogFixo(elfind: JQuery, html: string, classDiv: string = '', remover: boolean = false) {
      if (remover) {
        elfind.find(".espaco-log-pro").find(`.${classDiv}`).remove();
      }

      elfind.find(".espaco-log-pro").prepend(`${html}`);
    }

    private limparLimitesContas(e: JQueryEventObject) {
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_LIMPAR_LIMITES_CONTAS, this.getIdsContasEaVinculadas(), (response: IRespostaMensagem) => {
        if (response.status) {
          toastr.success("Limites liberados", "Sucessso!");
        }
      })
    }
    private limparLogs(e: JQueryEventObject) {
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_LIMPAR_LOGS, null, (response: IRespostaMensagem) => {
        if (response.status) {
          toastr.success("registro de logs limpo", "Sucessso!");
        }
      })
    }

    private obterMediaDelay() {
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_GET_DELAY, null, (response: IRespostaMensagem) => {
        if (response.status && response.result) {
          $('.info-media-delay').html(`${response.result.toFixed(2)} ms`)
        }
      })
    }

    private imterromperTarefas(el: JQueryEventObject) {
      App.Util.botaoProcessando($(el.currentTarget), true);
      clearInterval(this.intervaloVinculoListaContas)
      this.vendendoCoinsContaLista = false
      this.executandoResolverBugEa = false
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_INTERROMPER_FECHAR_CONTAS, null, (response: IRespostaMensagem) => {
        App.Util.botaoProcessando($(el.currentTarget), false);
        if (response.status) {
          toastr.success("Tarefas interrompidas.", "Sucessso!");
        }
      })
    }

    private reiniciarPlugin(el: JQueryEventObject) {
      clearInterval(this.intervaloVinculoListaContas)
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_REINICIAR_PLUGIN, null, (response: IRespostaMensagem) => {
        if (response.status) {
          toastr.info("Seu Plugin está sendo reiniciado, considere reativar suas tarefas automaticas caso estivesse ativa antes.", "Aguarde!");
        } else {
          toastr.warning("Algum problema ocorreu e o plugin não pode ser reiniciado, considere fazer isso manualmente desligando-o e ligando novamente.", "Não Reiniciado!");

        }
      })
    }

    private aoAtivarDesativarConfigRemota(e: JQueryEventObject, status: boolean = null, config: IConfiguracoesGeraisExecucao = null) {
      let statusConfigRemota: boolean = status != null ? status : $(e.target).is(':checked')
      // console.log("ativou", statusConfigRemota)
      if (statusConfigRemota) {
        $('.info-config-remoto').show()
        $('.info-config-local').hide()
        if (config) {
          this.preencherConfiguracaoGeral(config);
        } else {
          App.Util.exibirLoadingFormModal($('.loading-form-modal'))
          this.obterConfiguracaoGeralRemotaAtualizada((dadosSucesso: IRespostaSucessoAjx) => {
            App.Util.ocultarLoadingFormModal($('.loading-form-modal'))
            let dadosConfig: IConfiguracaoGeralBaseRemota = dadosSucesso.dadosRetornados
            console.log("DADOS CHEGOU aoAtivarDesativarConfigRemota", dadosSucesso, dadosConfig)
            if (dadosConfig && dadosConfig.dados) {
              this.salvarConfiguracaoGeralRemotaAtualizada(statusConfigRemota)
              this.preencherConfiguracaoGeral(dadosConfig.dados);
            } else {
              this.salvarOuAtualizarConfigRemota(statusConfigRemota)
            }
          })
        }
      } else {
        $('.info-config-remoto').hide()
        $('.info-config-local').show()
        this.salvarConfiguracaoGeralRemotaAtualizada(false)
        this.obterConfiguracaoGeralLocalAtualizada()
      }
      // this.ajax = new App.Ajax();
      // this.ajax.postAcao($(e.currentTarget).data("url"), { id: $(e.currentTarget).data("id"), status: $(e.target).is(':checked') });
    }

    private obterConfiguracaoGeralRemotaAtualizada(callbackResposta: any) {
      this.ajax.get(`${App.Util.config.urlGetConfiguracaoPro}`, {}, callbackResposta, null, null, false)
    }

    private salvarOuAtualizarConfigRemota(status: boolean, callbackAtualizacaoConfig: any = null) {
      var form = $(`#formConfiguracoesGeralBot`)
      var dadosForm: IConfiguracoesGeraisExecucao = this.ajax.convertFormToJSON(form)
      this.salvarConfiguracaoGeralRemotaAtualizada(status, dadosForm, callbackAtualizacaoConfig)
    }

    private salvarConfiguracaoGeralRemotaAtualizada(status: boolean, config: IConfiguracoesGeraisExecucao = null, callbackPostConfigRemota: any = null) {
      App.Util.exibirLoadingFormModal($('.loading-form-modal'))
      let dadosPost: any = { status: status }
      if (config) {
        dadosPost.dados = config;
      }

      this.ajax.postAcao(App.Util.config.urlPostConfiguracaoPro, dadosPost, (objRepostaPostConfigRemota: any) => {
        App.Util.ocultarLoadingFormModal($('.loading-form-modal'))
        if (callbackPostConfigRemota) {
          callbackPostConfigRemota(objRepostaPostConfigRemota)
        }
      }, null, false);
    }

    private iniciarVisualizacaoTelaWebAppRemota(request: { ip: string, port: string, token: string }) {
      try {
        // console.log("EnderecoWsBrowser", request);
        const url = `/bw-view/?i=${request.ip}&prt=${request.port}&tk=${request.token}`;
        // Obter a largura e a altura da janela atual
        const screenWidth = window.innerWidth;
        const screenHeight = window.innerHeight;

        // Calcular a largura e a altura proporcionais (por exemplo, 80% da janela atual)
        const popupWidth = Math.floor(screenWidth * 0.5);
        const popupHeight = Math.floor(screenHeight * 0.8);

        // Calcular a posição centralizada para a nova janela
        const left = Math.floor((screenWidth - popupWidth) / 2);
        const top = Math.floor((screenHeight - popupHeight) / 2);

        // Abrir a nova janela com as dimensões calculadas
        const popup = window.open(url, '_blank', `width=${popupWidth},height=${popupHeight},left=0,top=0`);

        if (!popup || popup.closed || typeof popup.closed === 'undefined') {
          // Popup blocked or failed, open in a new tab
          window.open(url, '_blank');
        }
      } catch (e) {
        console.log("Error iniciar Visualizacao Browser Remoto", e);
        toastr.warning(`Não foi possível visualizar o WebApp, error: ${e.message}`, "Um Erro ocorreu!");
      }
    }

    private aoAbirFormAddConta(e: JQueryEventObject) {
      e.preventDefault();
      $('#modalAddConta').modal('show');
    }

    public deleteContaDataTable(id: number) {
      let rowConta = App.Business.objDataTableContas.row(`#${id}`)
      if (rowConta.length) {
        rowConta.remove().draw();
      }
    }

    private aoVincularConta(email: string, callbackVinculo: any) {
      $.ajax({
        url: App.Util.config.urlValidarVinculoConta,
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ email: email }),
        beforeSend: function (jqXHR, settings) {
          jqXHR.setRequestHeader('X-CSRF-TOKEN', $('meta[name=csrf-token]').attr("content"));
        },
        success: (resposta) => {
          console.log("resp Validacao Conta", resposta)
          if (resposta) {
            callbackVinculo(resposta)
          }
        },
        error: (jqXHR, textStatus, errorThrown) => {
          console.log("erro resp Validacao Conta", jqXHR, textStatus, errorThrown)
        }
      });
    }

    private getDadosPorUrlFiltroFutbin(url: string, callback: any) {
      console.log("getDadosPorUrlFiltroFutbin", url)
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_OBTER_DADOS_FILTRO_FUTBIN, { url: url }, (response: IRespostaMensagem) => {
        if (response.status) {
          toastr.success(response.status, "Sucessso!");
        }
        console.log("RESP getDadosPorUrlFiltroFutbin", response)
        callback(response)
      })
    }

    private async aoClicarEmailConta(e: JQueryEventObject) {
      const text = $(e.currentTarget).text() || '';
      Util.copyToClipboard(text, () => {
        toastr.success(`Email: ${text} copiado para área de transferência.`, "Copiado!");
      });
    }

    private async atualizarContas() {
      try {
        if (this.atualizandoContas) {
          return
        }

        toastr.info("Atualizando Contas ...", "Iniciou Atualização!");
        this.atualizandoContas = true;
        $('.btn-dt-atualizar').text("Atualizando...");

        let contasSelecionadas = this.getContasSelecionadas()
        let contasIds = contasSelecionadas.count() ? this.getIdsContasSelecionadas() : this.getIdsAllContas();
        console.log("atualizandoContas", contasIds)
        await this.atualizarContasNoPluginAposDadosAplicados(contasIds)

        $('.btn-dt-atualizar').text("Atualizar");
        this.atualizandoContas = false
        toastr.success("Atualização de contas finalizada.", "Terminou Atualização!");
      } catch (e) {
        toastr.warning("Não foi possível atualizar as contas", "Atualização Incompleta!");
        console.log("ERROR atualizarContas", e)
        $('.btn-dt-atualizar').text("Atualizar");
        this.atualizandoContas = false
      }
    }

    private limparCacheContas() {
      if (!this.conectado) {
        return
      }

      Util.exibirModalPaginaCarregando()
      let ids = this.getIdsContasSelecionadas()
      //console.log("abrirContas", ids);
      $("#modalAcoesContas").modal("hide")
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_LIMPAR_CACHE_CONTAS, ids, (response: IRespostaMensagem) => {
        toastr.success("Limpeza de cache/Sincronia de dados executada. Se necessário, recarregue a tela para aplicar as mudanças visuais.", "Sucessso!");
        Util.ocultarModalPaginaCarregando()
      });
    }

    private async sincronizarDataBaseContas() {
      if (!this.conectado) {
        return;
      }

      // Exibe uma confirmação para o usuário
      const result = await swal.fire({
        title: 'Sincronizar Database Local!',
        text: 'Ao sincronizar, os dados do navegador das contas, como o cache, serão perdidos. Caso não utilize um autenticador, após inciar a conta, um novo código de autenticação da EA será necessário. Tem certeza de que deseja sincronizar sua database local?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2dce89',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, sincronizar agora!',
        cancelButtonText: 'Não sincronizar!',
      });

      if (result.isConfirmed) {
        // Usuário confirmou a ação
        Util.exibirModalPaginaCarregando();
        let ids = this.getIdsAllContas();
        $("#modalAcoesContas").modal("hide");
        this.comunicacao.enviar(Util.ACAO_COMUNICACAO_SINCRONIZAR_DATABASE_CONTAS_PLUGIN, ids, (response: IRespostaMensagem) => {
          toastr.success("Diretório de contas e database sincronizados.", "Sucesso!");
          Util.ocultarModalPaginaCarregando();
        });
      }
    }

    private async getProxyById(idProxy: number) {
      return new Promise(async (resolve: any, reject: any) => {
        try {
          if (!this.ajax) {
            this.ajax = new Ajax();
          }

          this.ajax.get(App.Util.config.urlGetProxy, { "id": idProxy }, (dadosSucesso: IRespostaSucessoAjx) => {
            resolve(dadosSucesso.dadosRetornados)
          }, null, null, false)
        } catch (e) {
          resolve(null)
        }
      })
    }

    private sincronizarContaNaMaquinaLocal(e: JQueryEventObject, navegadorVisivel: boolean = false, mostrarTelaWebApp: boolean = false) {
      var idConta = $(e.currentTarget).data('idContaEa');
      if (!this.conectado) {
        return
      }

      Util.exibirModalPaginaCarregando()
      let ids = [idConta]
      //console.log("abrirContas", ids);
      $("#modalAcoesContas").modal("hide")
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_SINCRONIZAR_DATABASE_CONTAS_PLUGIN, ids, (response: IRespostaMensagem) => {
        if (ids.length > 1) {
          toastr.success("Contas sincronizadas na Database.", "Sucessso!");
        } else {
          toastr.success("Conta sincronizada na Database.", "Sucessso!");
        }
        Util.ocultarModalPaginaCarregando()
      });
    }

    private executarDesfragmentarLiberarEspacoDisco(e: JQueryEventObject) {
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_LIMPEZA_DESFRAGMENTACAO_DE_DISCO, App.Business.dadosTeste ? App.Business.dadosTeste : {}, (response: IRespostaMensagem) => {
        if (response.status) {
          toastr.success("Limpeza de disco iniciada.", "Sucessso!");
        }
      })
    }

    private adicionarPluginNaInicializacaoWindows(e: JQueryEventObject) {
      swal.fire({
        title: 'Inicialização automática: Login do sistema operacional',
        html: `<small>Para adicionar o plugin na inicialização automática do Windows, forneça as credenciais de login do sistema operacional.
        Isso é necessário para que o windows inicie por completo e o plugin seja iniciado automaticamente.</small>
          <input id="username" class="swal2-input" placeholder="Usuário Windows">
          <input id="password" type="password" class="swal2-input" placeholder="Senha Windows">
        `,
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        preConfirm: () => {
          const username = (document.getElementById('username') as HTMLInputElement).value;
          const password = (document.getElementById('password') as HTMLInputElement).value;

          // if (!username || !password) {
          //   swal.showValidationMessage('Usuário e senha são obrigatórios!');
          //   return false;
          // }

          return { username, password };
        },
      }).then((result: any) => {
        if (result.isConfirmed) {
          const { username, password } = result.value!;
          console.log('Dados fornecidos:', { username, password });

          // Envia os dados ao servidor
          this.comunicacao.enviar(Util.ACAO_COMUNICACAO_CRIAR_INICIALIZACAO_AUTOMATICA_PLUGIN, { username, password }, (response: IRespostaMensagem) => {
            if (response.status) {
              toastr.success("Plugin adicionado na inicialização do sistema operacional.", "Sucesso!");
            } else {
              toastr.error("Falha ao adicionar o plugin na inicialização.", "Erro!");
            }
          });
        } else {
          console.log('Operação cancelada pelo usuário.');
        }
      });
    }

    private reiniciarVm(e: JQueryEventObject) {
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_REINICIAR_WINDOWS, App.Business.dadosTeste ? App.Business.dadosTeste : {}, (response: IRespostaMensagem) => {
        if (response.status) {
          toastr.success("Uma reicialização foi solicitada na VM.", "Sucessso!");
        }
      })
    }

    private removerPluginNaInicializacaoWindows(e: JQueryEventObject) {
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_REMOVER_INICIALIZACAO_AUTOMATICA_PLUGIN, App.Business.dadosTeste ? App.Business.dadosTeste : {}, (response: IRespostaMensagem) => {
        if (response.status) {
          toastr.success("Plugin removido da inicialização do sistema operacional.", "Sucessso!");
        }
      })
    }

    private exportarDataBaseLocal(e: JQueryEventObject) {
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_EXPORTAR_DATABASE_LOCAL, {}, (response: IRespostaMensagem) => {
        if (response.status && response.result && response.result.urlDownload) {
          try {
            toastr.success("Exportando database...", "Sucesso!");

            // Obtém o conteúdo JSON e o IP
            const urlDownload = response.result.urlDownload;
            console.log(`Arquivo  pronto para download.`, urlDownload);
            // Abre o link em uma nova aba para o download
            window.open(urlDownload, '_blank');
          } catch (e) {
            console.log("ERROR exportarDataBaseLocal", e)
            toastr.warning("Algum erro ocorreu, não foi possível exportar a database.", "Erro!");
          }
        } else {
          toastr.warning("Algum erro ocorreu, não foi possível exportar a database.", "Erro!");
        }
      });
    }

    private aoSubstituirFiltroPro(e: JQueryEventObject) {
      this.ajax = new App.Ajax();

      var filtroASerSubstituido: IFiltroOptions = $(e.currentTarget).data('filtro');
      filtroASerSubstituido.id = $(e.currentTarget).data('id');
      filtroASerSubstituido.nome = $(e.currentTarget).data('nome');

      let formSniperPro: any = $(e.currentTarget).parents('#formSniperPro');
      let dadosForm: any = this.ajax.convertFormToJSON(formSniperPro);
      let nomeFiltro = formSniperPro.find('input[name=campo_nome_filtro]').val()
      console.log("dadosForm", dadosForm, filtroASerSubstituido)

      let dadosFormatado = _.omit(dadosForm, ['descanso', 'intervalo', 'limite_compra', 'piloto_automatico', 'tempo', 'velocidade']);
      dadosFormatado.nome = nomeFiltro ? nomeFiltro : this.obterNomeFiltro("#formSniperPro");

      if (App.Util.validarFiltroSniper(dadosForm)) {
        swal.fire({
          title: `Deseja substituir o filtro selecionado ${filtroASerSubstituido.nome}?`,
          text: `Após confirmar, o filtro selecionado será substituído pelos novos dados de filtro atual do formulário com nome de ${dadosFormatado.nome}.`,
          icon: 'warning',
          confirmButtonText: 'Substituir',
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          confirmButtonColor: "#db5250",
          allowOutsideClick: true,
          allowEscapeKey: true
        }).then((result: any) => {
          if (result.isConfirmed) {
            this.ajax.postAcaoSemCabecalhoGlobal(formSniperPro.find('.menu-substituir-filtro').data("url-substituir-filtro-modal-sniper") + '/' + filtroASerSubstituido.id, dadosFormatado, (objResposta: IRespostaAjaxPostAcao) => {
              if (objResposta.status == '200' && objResposta.dadosRetornados) {
                toastr.success(`Filtro ${filtroASerSubstituido.nome} substituído por ${dadosFormatado.nome}`, "Sucessso!");
              } else {
                toastr.warning("Algum erro ocorreu, o filtro não pode ser substituído.", "Não Substituído!");
              }
            }, null, false);
          }
        });
      }
    }

    private informarSobreInstalacaoChrome(request: { status: number }) {
      if (request.status == 3) {
        swal.fire({
          icon: 'warning',
          title: 'Erro ao instalar chrome!',
          text: `Reinstale o plugin novamente, acesse o dashboard e aguarde uma nova tentativa de reinstalação do chrome, se o problema persistir, entre em contato com suporte pelo email contato@futsniperweb.com.br.`
        })
      }
    }

    private verificarSituacaoDaConta() {
      try {
        let servidorCloudEmInstalacao = this.infoPlanoAtual.ehPlanoCloud && $('.sniper-page') && $('.sniper-page').data('ehUsuarioCloudComServidor') == '0';
        // console.log("verificarSituacaoDaConta", $('.sniper-page').data('ehUsuarioCloudComServidor'))
        if (servidorCloudEmInstalacao) {
          swal.fire({
            icon: 'warning',
            title: 'Servidor em instalação!',
            html: `Nossa equipe está instalando seu servidor.<br/>
                 <b>Fique atento ao seu e-mail</b>, você será avisado quando estiver pronto.<br/>Após isso seu plano Cloud estará liberado.<br/><br/>
                 ⏱️ Prazo: até 48h úteis após o envio do comprovante para <b>contato@futsniperweb.com.br</b>.`
          })
        }
      } catch (e) {
        console.log("ERROR verificarSituacaoDaConta", e)
      }
    }

    private aoClicarResolverDmeImediato(e: JQueryEventObject) {
      const idConta = $(e.currentTarget).data('idContaEa');
      $("#modalConfigAutoDme").find('.btn-acao-resolver-dme')
        .attr('data-id-conta-ea', idConta)
        .data('idContaEa', idConta); // <-- atualiza o cache do jQuery
      $("#modalConfigAutoDme").modal("show");
    }

    private executarResolverDmeImediato(e: JQueryEventObject, elModal: JQuery = $("#modalConfigAutoDme"), contasIds: number[] = null) {
      let valido = true;
      elModal.find('#precoMaximoDesafio, #precoMaximoJogador, #select-dme').each(function () {
        if (!$(this).val()) {
          valido = false;
          $(this).addClass('is-invalid');
        } else {
          $(this).removeClass('is-invalid');
        }
      });

      if (!valido) {
        toastr.warning("Preencha todos os campos obrigatórios!", "Dados faltando!");
        return false;
      }

      var idConta = 0;
      if (!contasIds) {
        idConta = $(e.currentTarget).data('idContaEa');
        this.exibirLoadListConta(idConta, "Resolver Dme")
      }

      const dmeId = elModal.find("#select-dme").val();
      const dmeName = elModal.find("#select-dme option:selected").text().trim().replace(/<[^>]*>/g, '');
      const links = App.Util.obterLinksFutbin();
      const precoMaximoDesafio = parseInt(elModal.find("#precoMaximoDesafio").val()) || 30000;
      const precoMaximoJogador = parseInt(elModal.find("#precoMaximoJogador").val()) || 2000;

      const abrirPackInegociavel = elModal.find("#abrirPacksInegociaveisAutomaticamente").is(':checked');
      const abrirPackNegociavel = elModal.find("#abrirPacksNegociaveisAutomaticamente").is(':checked');

      console.log("executarResolverDmeImediato", idConta, dmeId, links, contasIds)

      const dadosDme: ResolverPayload = {
        dme: {
          setId: dmeId,
          name: `${dmeName}`,
          links: links,
        },
        configuracao: {
          repetir: 0,
          repetirIntervaloMinutos: 1,
          tipoSugestaoSolucao: 1,
          quantidadeSolucoesColetadas: 3,
          excluirNegociaveis: false,
          excluirEspeciais: true,
          usarConceitos: true,
          coletarConceitos: true,
          quantidadeMaximaDeJogConceitos: 0,
          minimoRating: 45,
          maximoRating: 89,
          tempoMaximoResolucaoMinutos: 100,
          usarDuplicatas: true,
          enviarAutomaticamente: true,
          precoMaximoDesafio: precoMaximoDesafio,
          precoMaximoJogador: precoMaximoJogador,
          naoUsarJogadorCaroNegociavel: 10000,
          naoUsarJogadorCaroInegociavel: 20000,
          comprarJogadorSomenteNaCertezaDeSolucao: true,
          retentativasAntesDeFecharWebApp: 0,
          forcarSolucaoACadaRetentativa: false,
          aumentarRatingAposCadaTentativa: 0,
          aumentarPrecoJogadorAposCadaTentativa: 0,
          enviarImediatamenteSeEstiverPronto: true,
          solucaoRapida: true,
          abrirPacksInegociaveisAutomaticamente: abrirPackInegociavel,
          abrirPacksNegociaveisAutomaticamente: abrirPackNegociavel,
        }
      }

      const dadosDmeInicial: ResolverPayload = {
        dme: { setId: 1, name: "DME Inicial", links: null },
        configuracao: {
          solucaoRapida: false,
          repetir: 0,
          repetirIntervaloMinutos: 1,
          tipoSugestaoSolucao: 1,
          quantidadeSolucoesColetadas: 0,
          excluirNegociaveis: true,
          excluirEspeciais: true,
          usarConceitos: true,
          coletarConceitos: true,
          quantidadeMaximaDeJogConceitos: 0,
          minimoRating: 45,
          maximoRating: 70,
          tempoMaximoResolucaoMinutos: 100,
          usarDuplicatas: true,
          abrirPacksInegociaveisAutomaticamente: true,
          abrirPacksNegociaveisAutomaticamente: true,
          enviarAutomaticamente: true,
          precoMaximoDesafio: 10000,
          precoMaximoJogador: 2000,
          naoUsarJogadorCaroNegociavel: 10000,
          naoUsarJogadorCaroInegociavel: 20000,
          comprarJogadorSomenteNaCertezaDeSolucao: true,
          retentativasAntesDeFecharWebApp: 0,
          forcarSolucaoACadaRetentativa: false,
          aumentarRatingAposCadaTentativa: 0,
          aumentarPrecoJogadorAposCadaTentativa: 0,
          enviarImediatamenteSeEstiverPronto: true,
        }
      }

      console.log("DME", { acao: Util.ID_TIPO_ACAO_UNICA_RESOLVER_DME, id: idConta || contasIds, dadosDme: dadosDme, dadosDmeInicial: dadosDmeInicial })

      if (contasIds && contasIds.length) {
        elModal.modal("hide");
        for (const idConta of contasIds) {
          this.exibirLoadListConta(idConta, "Resolver Dme")
        }

        this.comunicacao.enviar(Util.ACAO_COMUNICACAO_RESOLVER_DME_CONTAS, { ids: contasIds, dadosDme: dadosDme, dadosDmeInicial: dadosDmeInicial }, (response: IRespostaMensagem) => {
          console.log("RESOLVER_DME_CONTAS", response)
          this.ocultarLoadListConta(idConta)
        });
      } else {
        elModal.modal("hide");
        this.comunicacao.enviar(Util.ACAO_COMUNICACAO_EXECUTAR_ACAO_UNICA, { acao: Util.ID_TIPO_ACAO_UNICA_RESOLVER_DME, id: idConta, dadosDme: dadosDme, dadosDmeInicial: dadosDmeInicial }, (response: IRespostaMensagem) => {
          this.ocultarLoadListConta(idConta)
        });
      }
    }

    private executarResolverBugContaEa(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      this.resolverBugContaEa(idConta);
    }

    private resolverBugContaEa(idConta: number) {
      this.exibirLoadListConta(idConta, "Resolvendo Bug")
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_EXECUTAR_ACAO_UNICA, { acao: Util.ID_TIPO_ACAO_UNICA_RESOLVER_BUG_CONTA_EA, id: idConta }, (response: IRespostaMensagem) => {
        this.ocultarLoadListConta(idConta)
      });
    }

    private async aoAtivaDesativarRegistros(modelViewRegistro: ModelView, status: boolean, ids: number[] = []) {
      this.ajax = new App.Ajax();
      let dadosForm: any = { status: status };

      // Dividir os IDs em lotes de 100
      const lotes = App.Util.chunkArray(ids, 10);

      try {
        // Processar os lotes de forma assíncrona, um por vez
        for (const lote of lotes) {
          // Atualizar os dados do formulário com o lote atual
          dadosForm.ids = lote;

          // Enviar a requisição para o servidor como uma promessa
          console.log(`Enviando lote com ${lote.length} contas...`);
          await this.ativarDesativarRegistrosAsync(modelViewRegistro.ojDataTableCarregado.elDataTable.data('urlStatusMultFiltros'), dadosForm, lote);
        }

        App.Util.ocultarModalPaginaCarregando();
        // Exibir mensagem de sucesso após todos os lotes serem processados
        swal.fire({
          icon: 'success',
          title: 'Registros Alterados!',
          text: 'Registros alterados com sucesso.'
        });

      } catch (error) {
        App.Util.ocultarModalPaginaCarregando();
        // Tratar erros durante o processamento dos lotes
        console.error(`Erro ao processar lote:`, error);
        swal.fire({
          icon: 'error',
          title: 'Erro ao Alterar Registros Selecionadas',
          text: 'Ocorreu um erro ao processar um dos lotes. Verifique sua conexão e tente novamente.'
        });
      }
    }

    // Função para enviar um lote como uma promessa
    private ativarDesativarRegistrosAsync(url: string, dadosForm: any, lote: any[]): Promise<void> {
      return new Promise((resolve, reject) => {
        this.ajax.postAcao(url, dadosForm, (resposta: { dadosEnviados: any, dadosRetornados: any }) => {
          console.log(`Lote com ${lote.length} registros processado com sucesso.`, resposta);
          if (resposta.dadosRetornados && resposta.dadosRetornados.atualizado) {
            let ids = resposta.dadosRetornados.ids;

            // Atualizar os checkboxes com base nos IDs retornados
            ids.forEach((id: string) => {
              const checkbox = $(`input[data-id="${id}"]`);
              if (checkbox.length) {
                checkbox.prop('checked', resposta.dadosRetornados.status); // Atualiza o estado do checkbox
              }
            });
          }
          resolve(); // Resolve a promessa quando a requisição for concluída
        }, null, true, false);
      });
    }

    private async executarResolverBugIdsContas() {
      try {
        if (!this.conectado) {
          return
        }

        if (this.executandoResolverBugEa) {
          return
        }

        $("#modalAcoesContas").modal("hide")
        this.executandoResolverBugEa = true
        let ids = this.getIdsContasSelecionadas()
        for await (let id of ids) {
          if (!this.executandoResolverBugEa) {
            break;
          }

          this.resolverBugContaEa(id);
          await this.util.esperar(App.Business.tempoMilisegundoEntreAberturaContaVendaCoins || 30000)
        }

        this.executandoResolverBugEa = false
      } catch (e) {
        console.log("ERROR Vender coins lista contas::", e)
      }
    }
  }
}
